

// // // // // import React, { useEffect, useState, useRef } from 'react';
// // // // // import './Estimate.css';
// // // // // import CryptoJS from 'crypto-js';

// // // // // const Estimate = ({ accessToken, booking, userDetails, userMap }) => {
// // // // //   const [isActive, setIsActive] = useState(false);
// // // // //   const [status, setStatus] = useState('Draft');
// // // // //   const [products, setProducts] = useState([]);
// // // // //   const [editingRow, setEditingRow] = useState(null);
// // // // //   const [salesValueOptions, setSalesValueOptions] = useState([]);
// // // // //   const [existingEstimate, setExistingEstimate] = useState(null);
// // // // //   const [formData, setFormData] = useState({});
// // // // //   const [showConfirmOverlay, setShowConfirmOverlay] = useState(false);
// // // // //   const [showLoadingOverlay, setShowLoadingOverlay] = useState(false);
// // // // //   const [provinces, setProvinces] = useState([]);
// // // // //   const [alertMessage, setAlertMessage] = useState({ type: '', message: '' });
// // // // //   const [defaultMessage, setDefaultMessage] = useState('');
// // // // //   const [overlayAction, setOverlayAction] = useState('');
// // // // //   const [showViewEstimate, setShowViewEstimate] = useState(false);
// // // // //   const [showEstimateOverlay, setShowEstimateOverlay] = useState(false);
// // // // //   const tableRef = useRef(null);

// // // // //   const SECRET_KEY = '7f3a1d9e4c6b2f88b0e7a5c9d4f1342b';

// // // // //   useEffect(() => {
// // // // //     const fetchProvinces = async () => {
// // // // //       try {
// // // // //         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/taxvalueid');
// // // // //         if (!response.ok) throw new Error('Error fetching provinces');
// // // // //         const data = await response.json();
// // // // //         setProvinces(data.records || []);
// // // // //       } catch (error) {
// // // // //         console.error('Error fetching provinces:', error);
// // // // //       }
// // // // //     };

// // // // //     const fetchSalesValues = async () => {
// // // // //       try {
// // // // //         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/salesvalueid');
// // // // //         if (!response.ok) throw new Error('Error fetching sales values');
// // // // //         const data = await response.json();
// // // // //         setSalesValueOptions(data.records || []);
// // // // //       } catch (error) {
// // // // //         console.error('Error fetching sales values:', error);
// // // // //       }
// // // // //     };

// // // // //     fetchProvinces();
// // // // //     fetchSalesValues();
// // // // //   }, []);

// // // // //   useEffect(() => {
// // // // //     const fetchEmailTemplate = async () => {
// // // // //       try {
// // // // //         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/emailtemp');
// // // // //         if (!response.ok) throw new Error('Error fetching email template');
// // // // //         const data = await response.json();
// // // // //         if (data.status === 'success' && data.records.length > 0) {
// // // // //           setDefaultMessage(data.records[0].defaultMessage || '');
// // // // //         }
// // // // //       } catch (error) {
// // // // //         console.error('Error fetching email template:', error);
// // // // //         setDefaultMessage(
// // // // //           'Thank you for the opportunity to provide an estimate for your move.'
// // // // //         );
// // // // //       }
// // // // //     };

// // // // //     fetchEmailTemplate();
// // // // //   }, []);

// // // // //   useEffect(() => {
// // // // //     const checkExistingEstimate = async () => {
// // // // //       if (!booking?.LeadACVLRecordID || !accessToken) return;
// // // // //       setShowViewEstimate(false);
// // // // //       if (booking?.Status === 'Estimate sent' || booking?.Status === 'Booked') {
// // // // //         setShowViewEstimate(true);
// // // // //       }
// // // // //       try {
// // // // //         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/esti', {
// // // // //           method: 'GET',
// // // // //           headers: {
// // // // //             'Authorization': `Bearer ${accessToken}`,
// // // // //             'Content-Type': 'application/json',
// // // // //             'LeadACVLRecordID': booking.LeadACVLRecordID,
// // // // //           },
// // // // //         });
// // // // //         if (response.ok) {
// // // // //           const result = await response.json();
// // // // //           if (result.status === 'success' && result.totalRecords > 0) {
// // // // //             setExistingEstimate(result.data[0]);
// // // // //             const itemsString = result.data[0].Items;
// // // // //             let validJsonString = itemsString
// // // // //               .replace(/=/g, ':')
// // // // //               .replace(/([{,])\s*([^{,\s:]+)\s*:/g, '$1"$2":')
// // // // //               .replace(/:\s*([^",}\s][^,}]*)(?=[,}])/g, (match, value) => {
// // // // //                 const trimmedValue = value.trim();
// // // // //                 return /^[0-9.-]+$/.test(trimmedValue) ? `:${trimmedValue}` : `:"${trimmedValue}"`;
// // // // //               });

// // // // //             try {
// // // // //               const parsedItems = JSON.parse(validJsonString).map(item => {
// // // // //                 const matchingOption = salesValueOptions.find(opt => opt.Name === item.desc);
// // // // //                 return {
// // // // //                   productService: item.desc,
// // // // //                   description: matchingOption ? matchingOption.Description : item.desc,
// // // // //                   qty: parseFloat(item.qty) || 0,
// // // // //                   rate: parseFloat(item.rate) || 0,
// // // // //                   amount: parseFloat(item.amount) || 0,
// // // // //                 };
// // // // //               });
// // // // //               setProducts(parsedItems);
// // // // //             } catch (parseError) {
// // // // //               console.error('JSON parse error:', parseError);
// // // // //               const manualItems = itemsString.match(/\{[^}]*\}/g)?.map(itemStr => {
// // // // //                 const item = {};
// // // // //                 itemStr.replace(/(\w+)\s*=\s*([^,}]+)/g, (_, key, value) => {
// // // // //                   item[key] = isNaN(value) ? value.trim() : parseFloat(value);
// // // // //                 });
// // // // //                 const matchingOption = salesValueOptions.find(opt => opt.Name === item.desc);
// // // // //                 return {
// // // // //                   productService: item.desc,
// // // // //                   description: matchingOption ? matchingOption.Description : item.desc,
// // // // //                   qty: parseFloat(item.qty) || 0,
// // // // //                   rate: parseFloat(item.rate) || 0,
// // // // //                   amount: parseFloat(item.amount) || 0,
// // // // //                 };
// // // // //               }) || [];
// // // // //               setProducts(manualItems);
// // // // //             }
// // // // //           } else {
// // // // //             setExistingEstimate(null);
// // // // //             setProducts([]);
// // // // //           }
// // // // //         } else {
// // // // //           console.error('API request failed:', response.statusText);
// // // // //         }
// // // // //       } catch (error) {
// // // // //         console.error('Error checking existing estimate:', error);
// // // // //       }
// // // // //     };

// // // // //     setProducts([]);
// // // // //     setExistingEstimate(null);
// // // // //     setEditingRow(null);
// // // // //     setStatus('Draft');
// // // // //     checkExistingEstimate();
// // // // //   }, [booking, accessToken, salesValueOptions, userDetails]);

// // // // //   useEffect(() => {
// // // // //     const newFormData = existingEstimate
// // // // //       ? {
// // // // //           customerName: booking.Customer_Name || '',
// // // // //           customerEmail: existingEstimate.Email || '',
// // // // //           originAddressLine1: booking.FromAddress || booking.OriginCity,
// // // // //           originProvince: booking.OriginCity || '',
// // // // //           moveDate: booking.Move_Date || '',
// // // // //           destAddressLine1: booking.ToAddress || booking.DestinationCity,
// // // // //           destProvince: booking.DestinationCity || '',
// // // // //           moveSize: booking.Move_Size || '',
// // // // //           depositToPay: existingEstimate.Deposittopay || '',
// // // // //           discountInput: existingEstimate.Discount || '0.00',
// // // // //           discountType: existingEstimate.DiscountType || 'percent',
// // // // //           message: existingEstimate.message || defaultMessage,
// // // // //           selectedProvince: existingEstimate.Tax || '0',
// // // // //         }
// // // // //       : booking
// // // // //       ? {
// // // // //           customerName: booking.Customer_Name || '',
// // // // //           customerEmail: booking.Email || '',
// // // // //           originAddressLine1: booking.FromAddress || booking.OriginCity,
// // // // //           moveDate: booking.Move_Date || '',
// // // // //           destAddressLine1: booking.ToAddress || booking.DestinationCity,
// // // // //           moveSize: booking.Move_Size || '',
// // // // //           discountType: 'percent',
// // // // //           discountInput: '0.00',
// // // // //           selectedProvince: '0',
// // // // //           depositToPay: '100',
// // // // //           message: defaultMessage,
// // // // //         }
// // // // //       : { message: defaultMessage };
// // // // //     setFormData(newFormData);
// // // // //     updateTotals();
// // // // //   }, [booking, existingEstimate, defaultMessage]);

// // // // //   useEffect(() => {
// // // // //     updateTotals();
// // // // //   }, [products, formData]);

// // // // //   useEffect(() => {
// // // // //     const handleClickOutside = (event) => {
// // // // //       if (tableRef.current && !tableRef.current.contains(event.target) && editingRow !== null) {
// // // // //         saveRow(editingRow);
// // // // //       }
// // // // //     };

// // // // //     document.addEventListener('mousedown', handleClickOutside);
// // // // //     return () => {
// // // // //       document.removeEventListener('mousedown', handleClickOutside);
// // // // //     };
// // // // //   }, [editingRow]);

// // // // //   const toTitleCase = str => str?.toLowerCase().replace(/(^|\s)\w/g, letter => letter.toUpperCase()) || '';

// // // // //   const calculateSubtotal = () => products.reduce((sum, product) => sum + (parseFloat(product.amount) || 0), 0);

// // // // //   const calculateDiscount = subtotal => {
// // // // //     const discountType = formData.discountType || 'percent';
// // // // //     const discountValue = parseFloat(formData.discountInput) || 0;
// // // // //     return discountType === 'percent' ? (subtotal * discountValue) / 100 : discountValue;
// // // // //   };

// // // // //   const calculateTax = subtotalAfterDiscount => {
// // // // //     const selectedProvince = provinces.find(p => p.Province === formData.selectedProvince);
// // // // //     const taxPercentage = selectedProvince ? selectedProvince['Tax%'] * 100 : 0;
// // // // //     return (subtotalAfterDiscount * taxPercentage) / 100;
// // // // //   };

// // // // //   const updateTotals = () => {
// // // // //     const subtotal = calculateSubtotal();
// // // // //     const discountAmount = calculateDiscount(subtotal);
// // // // //     const subtotalAfterDiscount = subtotal - discountAmount;
// // // // //     const gstAmount = calculateTax(subtotalAfterDiscount);
// // // // //     const total = subtotalAfterDiscount + gstAmount;
// // // // //     document.getElementById('EstimateSubtotal').textContent = subtotal.toFixed(2);
// // // // //     document.getElementById('EstimateDiscountAmount').textContent = discountAmount.toFixed(2);
// // // // //     document.getElementById('EstimateGstAmount').textContent = gstAmount.toFixed(2);
// // // // //     document.getElementById('EstimateTotal').textContent = total.toFixed(2);
// // // // //   };

// // // // //   const handleFormChange = (field, value) => {
// // // // //     setFormData(prev => ({ ...prev, [field]: value }));
// // // // //   };

// // // // //   const toggleContent = () => setIsActive(prev => !prev);

// // // // //   const handleCancelClick = e => {
// // // // //     e.stopPropagation();
// // // // //     setIsActive(false);
// // // // //   };

// // // // //   const handleProductServiceChange = (index, value) => {
// // // // //     const match = salesValueOptions.find(opt => opt.Name === value);
// // // // //     if (match) {
// // // // //       const descriptionInput = document.getElementById(`EstimateDescription-${index}`);
// // // // //       const rateInput = document.getElementById(`EstimateRate-${index}`);
// // // // //       if (descriptionInput) descriptionInput.value = match.Description;
// // // // //       if (rateInput) rateInput.value = match.UnitPrice;
// // // // //     }
// // // // //   };

// // // // //   const addNewRow = () => {
// // // // //     let updated = [...products]; 
// // // // //     if (editingRow !== null && editingRow < updated.length) {
// // // // //       const result = saveRow(editingRow);
// // // // //       if (!result) return;
// // // // //       updated = result;
// // // // //     }

// // // // //     const newRow = { productService: '', description: '', rate: 0, qty: 0, amount: 0 };
// // // // //     const newProducts = [...updated, newRow];
// // // // //     const newIndex = newProducts.length - 1;

// // // // //     setProducts(newProducts);
// // // // //     setEditingRow(newIndex);

// // // // //     setTimeout(() => {
// // // // //       const input = document.getElementById(`EstimateProductService-${newIndex}`);
// // // // //       if (input) input.focus();

// // // // //       const row = document.querySelector(`#EstimateProductsTableBody tr:nth-child(${newIndex + 1})`);
// // // // //       if (row) row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
// // // // //     }, 100);
// // // // //   };

// // // // //   const deleteRow = index => {
// // // // //     const newProducts = products.filter((_, i) => i !== index);
// // // // //     setProducts(newProducts);
// // // // //     if (editingRow === index) setEditingRow(null);
// // // // //   };

// // // // //   const saveRow = index => {
// // // // //     const qty = parseFloat(document.getElementById(`EstimateQty-${index}`).value) || 0;
// // // // //     const rate = parseFloat(document.getElementById(`EstimateRate-${index}`).value) || 0;
  
// // // // //     if (qty < 0 || rate < 0) {
// // // // //       setAlertMessage({ type: 'error', message: 'Quantity and rate must be non-negative.' });
// // // // //       setShowConfirmOverlay(true);
// // // // //       return null;
// // // // //     }
  
// // // // //     const productService = document.getElementById(`EstimateProductService-${index}`).value;
// // // // //     const description = document.getElementById(`EstimateDescription-${index}`).value;
// // // // //     const amount = (qty * rate).toFixed(2);
  
// // // // //     const updatedProducts = products.map((p, i) =>
// // // // //       i === index ? { ...p, productService, description: toTitleCase(description), rate, qty, amount } : p
// // // // //     );
  
// // // // //     setProducts(updatedProducts);
// // // // //     setEditingRow(null);
// // // // //     return updatedProducts;
// // // // //   };
  
// // // // //   const handleQtyRateChange = index => {
// // // // //     const qty = parseFloat(document.getElementById(`EstimateQty-${index}`).value) || 0;
// // // // //     const rate = parseFloat(document.getElementById(`EstimateRate-${index}`).value) || 0;
// // // // //     const amount = (qty * rate).toFixed(2);
// // // // //     const updatedProducts = [...products];
// // // // //     updatedProducts[index] = { ...updatedProducts[index], qty, rate, amount };
// // // // //     setProducts(updatedProducts);
// // // // //   };

// // // // //   const toggleEditMode = index => {
// // // // //     if (editingRow !== null && editingRow !== index) saveRow(editingRow);
// // // // //     setEditingRow(editingRow === index ? null : index);
// // // // //   };

// // // // //   const handleSendConfirm = () => {
// // // // //     setOverlayAction('confirm');
// // // // //     setShowConfirmOverlay(true);
// // // // //     setAlertMessage({ type: '', message: '' });
// // // // //   };

// // // // //   const closeOverlay = () => {
// // // // //     setShowConfirmOverlay(false);
// // // // //     setAlertMessage({ type: '', message: '' });
// // // // //     setOverlayAction('');
// // // // //   };

// // // // //   const handleSaveClick = () => {
// // // // //     if (editingRow !== null) saveRow(editingRow);
// // // // //   };

// // // // //   const handleProvinceChange = provinceName => {
// // // // //     const selectedProvince = provinces.find(p => p.Province === provinceName);
// // // // //     setFormData(prev => ({
// // // // //       ...prev,
// // // // //       selectedProvince: provinceName,
// // // // //       provinceId: selectedProvince?.ID || null,
// // // // //       gstDropdown: selectedProvince ? (selectedProvince['Tax%'] * 100).toString() : '0',
// // // // //     }));
// // // // //   };

// // // // //   const handleViewEstimateClick = () => {
// // // // //     if (!booking?.LeadACVLRecordID) {
// // // // //       setAlertMessage({ type: 'error', message: 'Estimate ID is missing.' });
// // // // //       setShowConfirmOverlay(true);
// // // // //       return;
// // // // //     }
// // // // //     setShowEstimateOverlay(true);
// // // // //   };

// // // // //   const closeEstimateOverlay = () => {
// // // // //     setShowEstimateOverlay(false);
// // // // //   };

// // // // //   const handleSendClick = () => {
// // // // //     setOverlayAction('send');
// // // // //     setShowConfirmOverlay(true);
// // // // //     setAlertMessage({ type: '', message: '' });
// // // // //   };

// // // // //   const sendEstimate = async () => {
// // // // //     if (products.length === 0) {
// // // // //       setAlertMessage({ type: 'error', message: 'Please add at least one product/service to the estimate before sending.' });
// // // // //       setShowConfirmOverlay(true);
// // // // //       return;
// // // // //     }

// // // // //     setShowConfirmOverlay(false);
// // // // //     setShowLoadingOverlay(true);
// // // // //     setAlertMessage({ type: '', message: '' });

// // // // //     const selectedProvince = provinces.find(p => p.Province === formData.selectedProvince);
// // // // //     const taxField = selectedProvince
// // // // //       ? `${selectedProvince.Province} - ${(selectedProvince['Tax%'] * 100).toFixed(0)}%`
// // // // //       : '0';

// // // // //     let salesAgentName = booking?.Sales_Agent || '';
// // // // //     if (!salesAgentName && userDetails?.userId && userMap) {
// // // // //       salesAgentName = userMap[userDetails.userId] || 'Agent';
// // // // //     }
// // // // //     if (!salesAgentName) {
// // // // //       salesAgentName = 'Agent';
// // // // //     }

// // // // //     const payload1 = {
// // // // //       LeadACVLRecordID: booking.LeadACVLRecordID,
// // // // //       OriginCity: formData.originProvince,
// // // // //       Customer_Name: formData.customerName,
// // // // //       Deposittopay: formData.depositToPay,
// // // // //       Sales_Agent: salesAgentName,
// // // // //       Email: formData.customerEmail,
// // // // //       message: formData.message,
// // // // //       Move_Size: formData.moveSize,
// // // // //       Move_Date: formData.moveDate,
// // // // //       Estimatetotal: parseFloat(document.getElementById('EstimateTotal').textContent),
// // // // //       DestinationCity: formData.destProvince,
// // // // //       FromAddress: `${formData.originAddressLine1}`,
// // // // //       ToAddress: `${formData.destAddressLine1}`,
// // // // //       Items: products.map(product => ({
// // // // //         desc: product.productService,
// // // // //         prod: product.description,
// // // // //         qty: product.qty,
// // // // //         rate: parseFloat(product.rate).toFixed(2),
// // // // //         amount: parseFloat(product.amount).toFixed(2),
// // // // //       })),
// // // // //       Subtotal: calculateSubtotal().toFixed(2),
// // // // //       Discount: formData.discountInput,
// // // // //       TAXValue: calculateTax(calculateSubtotal() - calculateDiscount(calculateSubtotal())).toFixed(2),
// // // // //       DiscountType: formData.discountType || ' ',
// // // // //       Tax: formData.selectedProvince || '0',
// // // // //       TaxPercentage: taxField || '0',
// // // // //     };

// // // // //     const payload2 = {
// // // // //       recipientEmail: formData.customerEmail,
// // // // //       subject: 'Estimate #' + booking.LeadACVLRecordID + ' from All Canada Van Lines Inc.',
// // // // //       message: formData.message,
// // // // //       filteredByOriginDestRange: products.map(product => ({
// // // // //         'Estimate Item - Desc': product.productService,
// // // // //         'Estimate Item - pro': product.description,
// // // // //         'Estimate Item - Quantity': product.qty,
// // // // //         'Estimate Item - Rate': parseFloat(product.rate),
// // // // //         'Estimate Item - Amount': parseFloat(product.amount),
// // // // //       })),
// // // // //       subTotal: calculateSubtotal(),
// // // // //       tax: taxField,
// // // // //       Deposittopay: formData.depositToPay,
// // // // //       taxAmount: calculateTax(calculateSubtotal() - calculateDiscount(calculateSubtotal())),
// // // // //       Discount: calculateDiscount(calculateSubtotal()),
// // // // //       finalamount: parseFloat(document.getElementById('EstimateTotal').textContent),
// // // // //       LeadACVLRecordID: booking.LeadACVLRecordID,
// // // // //     };

// // // // //     const payload3 = [
// // // // //       {
// // // // //         ROWID: booking.ROWID,
// // // // //         Status: 'Estimate sent',
// // // // //       },    
// // // // //     ];

// // // // //     try {
// // // // //       const response1 = await fetch('https://salesjet-10097049716.catalystappsail.com/esti', {
// // // // //         method: 'POST',
// // // // //         headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
// // // // //         body: JSON.stringify(payload1),
// // // // //       });
// // // // //       if (!response1.ok) throw new Error('Failed to send estimate to First API');
// // // // //       console.log('First API Response:', await response1.json());

// // // // //       const response2 = await fetch(
// // // // //         'https://salesjet-841904208.catalystserverless.com/server/email-estimate-function/email-estimate',
// // // // //         {
// // // // //           method: 'POST',
// // // // //           headers: { 'Content-Type': 'application/json' },
// // // // //           body: JSON.stringify(payload2),
// // // // //         }
// // // // //       );

// // // // //       if (!response2.ok) {
// // // // //         let errorMessage = `HTTP error ${response2.status}: ${response2.statusText}`;
// // // // //         try {
// // // // //           const errorData = await response2.json();
// // // // //           errorMessage = errorData.message || errorData.error || errorMessage; 
// // // // //         } catch (jsonError) {
// // // // //           console.warn('Failed to parse error response from Second API:', jsonError);
// // // // //         }
// // // // //         throw new Error(errorMessage); 
// // // // //       }

// // // // //       console.log('Second API Response:', await response2.json());

// // // // //       if (booking.Status !== 'Booked') {
// // // // //         const response3 = await fetch('https://salesjet-10097049716.catalystappsail.com/leadsdata', {
// // // // //           method: 'PUT',
// // // // //           headers: {
// // // // //             'Content-Type': 'application/json',
// // // // //             Authorization: `Bearer ${accessToken}`,
// // // // //           },
// // // // //           body: JSON.stringify(payload3),
// // // // //         });
// // // // //         if (!response3.ok) throw new Error('Failed to update status to "Estimate sent"');
// // // // //         console.log('Status Update Response:', await response3.json());
// // // // //       } else {
// // // // //         console.log('Booking already marked as "Booked", skipping status update.');
// // // // //       }

// // // // //       setStatus('Sent');
// // // // //       setShowViewEstimate(true);
// // // // //       setAlertMessage({ type: 'success', message: 'Email sent successfully' });
// // // // //     } catch (error) {
// // // // //       console.error('Error sending estimate:', error);
// // // // //       setAlertMessage({ type: 'error', message: `Failed to send estimate: ${error.message}` });
// // // // //     } finally {
// // // // //       setShowLoadingOverlay(false);
// // // // //       setShowConfirmOverlay(true);
// // // // //     }
// // // // //   };

// // // // //   const confirmBooking = async () => {
// // // // //     setShowConfirmOverlay(false);
// // // // //     setShowLoadingOverlay(true);
// // // // //     setAlertMessage({ type: '', message: '' });
// // // // //     const customerEmail = document.getElementById('EstimateCustomerEmail').value;
// // // // //     const customerName = document.getElementById('EstimateCustomerName').value;
// // // // //     const DocNumber = booking.LeadACVLRecordID || 'DocNumber';
// // // // //     const billAddr = {
// // // // //       Line1: document.getElementById('EstimateOriginAddressLine1').value,
// // // // //       Country: 'CA',
// // // // //     };
// // // // //     const shipAddr = {
// // // // //       Line1: document.getElementById('EstimateDestAddressLine1').value,
// // // // //       Country: 'CA',
// // // // //     };
// // // // //     const depositAmount = parseFloat(document.getElementById('Deposittopay').value) || 0;

// // // // //     const lineItems = [];
// // // // //     if (depositAmount > 0) {
// // // // //       lineItems.push({
// // // // //         Id: '1',
// // // // //         LineNum: 1,
// // // // //         Description: 'Deposit Towards Move Booked',
// // // // //         Amount: depositAmount,
// // // // //         DetailType: 'SalesItemLineDetail',
// // // // //         SalesItemLineDetail: {
// // // // //           ItemRef: {
// // // // //             value: '1',
// // // // //             name: 'Services',
// // // // //           },
// // // // //           UnitPrice: depositAmount,
// // // // //           Qty: 1,
// // // // //           ItemAccountRef: {
// // // // //             value: '52',
// // // // //             name: 'Services',
// // // // //           },
// // // // //         },
// // // // //       });
// // // // //     } else {
// // // // //       setAlertMessage({ type: 'error', message: 'Please specify a deposit amount to confirm the booking.' });
// // // // //       setShowLoadingOverlay(false);
// // // // //       setShowConfirmOverlay(true);
// // // // //       return;
// // // // //     }
// // // // //     const payload = {
// // // // //       customerEmail: customerEmail,
// // // // //       DisplayName: customerName,
// // // // //       invoiceData: {
// // // // //         BillEmail: {
// // // // //           Address: customerEmail,
// // // // //         },
// // // // //         DocNumber: DocNumber,
// // // // //         TxnDate: new Date().toISOString().split('T')[0],
// // // // //         DueDate: document.getElementById('EstimateMoveDate').value,
// // // // //         CustomField: [
// // // // //           {
// // // // //             DefinitionId: '1',
// // // // //             Name: 'Sales Agent',
// // // // //             Type: 'StringType',
// // // // //             StringValue: 'Paul1',
// // // // //           },
// // // // //         ],
// // // // //         BillAddr: billAddr,
// // // // //         ShipAddr: shipAddr,
// // // // //         CustomerMemo: {
// // // // //           value: 'Receipt deposit for your upcoming move. This will be applied toward your final invoice.',
// // // // //         },
// // // // //         GlobalTaxCalculation: 'NotApplicable',
// // // // //         Line: lineItems,
// // // // //         Deposit: depositAmount,
// // // // //         DepositToAccountRef: {
// // // // //           value: '5',
// // // // //           name: 'Undeposited Funds',
// // // // //         },
// // // // //       },
// // // // //     };
// // // // //     const payload4 = [
// // // // //       {
// // // // //         ROWID: booking.ROWID,
// // // // //         Status: 'Booked',
// // // // //       },
// // // // //     ];
// // // // //     try {
// // // // //       const response = await fetch(
// // // // //         'https://salesjet-841904208.catalystserverless.com/server/qb_post/handle-invoice',
// // // // //         {
// // // // //           method: 'POST',
// // // // //           headers: {
// // // // //             'Content-Type': 'application/json',
// // // // //           },
// // // // //           body: JSON.stringify(payload),
// // // // //         }
// // // // //       );

// // // // //       if (!response.ok) {
// // // // //         const errorData = await response.json();
// // // // //         console.error('API Error:', errorData);
// // // // //         setAlertMessage({
// // // // //           type: 'error',
// // // // //           message: `Failed to create invoice: ${errorData.Fault?.Error[0]?.Message || 'Unknown error'} (${errorData.Fault?.Error[0]?.Detail || ''})`,
// // // // //         });
// // // // //         throw new Error('Failed to save estimate');
// // // // //       }

// // // // //       const result = await response.json();
// // // // //       console.log('Estimate saved successfully:', result);

// // // // //       const response2 = await fetch('https://salesjet-10097049716.catalystappsail.com/leadsdata', {
// // // // //         method: 'PUT',
// // // // //         headers: {
// // // // //           'Content-Type': 'application/json',
// // // // //           Authorization: `Bearer ${accessToken}`,
// // // // //         },
// // // // //         body: JSON.stringify(payload4),
// // // // //       });
// // // // //       if (!response2.ok) throw new Error('Failed to update status to "Booked"');
// // // // //       console.log('Status Update Response:', await response2.json());

// // // // //       setStatus('Saved');
// // // // //       setShowViewEstimate(true);
// // // // //       setAlertMessage({ type: 'success', message: 'Invoice sent successfully in QB' });
// // // // //     } catch (error) {
// // // // //       console.error('Error saving estimate:', error);
// // // // //       setAlertMessage({ type: 'error', message: 'Failed to Create Invoice in QB. Please try again.' });
// // // // //     } finally {
// // // // //       setShowLoadingOverlay(false);
// // // // //       setShowConfirmOverlay(true);
// // // // //     }
// // // // //   };

// // // // //   // Function to generate and copy customer link
// // // // //   const handleCopyCustomerLink = () => {
// // // // //     if (!booking?.LeadACVLRecordID) {
// // // // //       setAlertMessage({ type: 'error', message: 'Estimate ID is missing.' });
// // // // //       setShowConfirmOverlay(true);
// // // // //       return;
// // // // //     }

// // // // //     const encryptedId = CryptoJS.AES.encrypt(booking.LeadACVLRecordID.toString(), SECRET_KEY).toString();
// // // // //     const encodedEncryptedId = encodeURIComponent(encryptedId);
// // // // //     const customerLink = `https://salesjet.allcanadavanlines.com/server/estimate_view/?${encodedEncryptedId}`;

// // // // //     navigator.clipboard.writeText(customerLink).then(() => {
// // // // //       setAlertMessage({ type: 'success', message: 'Customer link copied to clipboard!' });
// // // // //       setShowConfirmOverlay(true);
// // // // //     }).catch(err => {
// // // // //       setAlertMessage({ type: 'error', message: 'Failed to copy link to clipboard.' });
// // // // //       setShowConfirmOverlay(true);
// // // // //       console.error('Clipboard error:', err);
// // // // //     });
// // // // //   };

// // // // //   return (
// // // // //     <div>
// // // // //       <div className={`EstimateHeader ${isActive ? 'EstimateActive' : ''}`} onClick={toggleContent}>
// // // // //         <div className="EstimateLeftSection">
// // // // //           <h2>ESTIMATE</h2>
// // // // //           <span className="EstimateLeftSection" style={{ background: 'white', padding: '5px', borderRadius: '10px' }}>
// // // // //             {booking.Status}
// // // // //           </span>
// // // // //           {showViewEstimate && (
// // // // //             <>
// // // // //               <button
// // // // //                 className="EstimateViewBtn"
// // // // //                 onClick={handleViewEstimateClick}
// // // // //               >
// // // // //                 View Estimate
// // // // //               </button>
// // // // //               <button
// // // // //                 className="EstimateViewBtn"
// // // // //                 onClick={handleCopyCustomerLink}
// // // // //                 style={{ marginLeft: '10px' }}
// // // // //               >
// // // // //                 Customer Link
// // // // //               </button>
// // // // //             </>
// // // // //           )}
// // // // //         </div>
// // // // //         <div className="EstimateRightButtons">
// // // // //           <button className="EstimateCancelBtn" onClick={handleCancelClick}>
// // // // //             Cancel
// // // // //           </button>
// // // // //           <button className="EstimateSendBtn" onClick={handleSendClick}>
// // // // //             Send
// // // // //           </button>
// // // // //         </div>
// // // // //       </div>     
// // // // //       <div className={`EstimateContent ${isActive ? 'EstimateVisible' : ''}`}>
// // // // //         <div className="EstimateCustomerSection">
// // // // //           <div className="EstimateCustomerField">
// // // // //             <label htmlFor="EstimateCustomerName">Customer</label>
// // // // //             <input
// // // // //               type="text"
// // // // //               id="EstimateCustomerName"
// // // // //               placeholder="Enter customer name"
// // // // //               value={formData.customerName || ''}
// // // // //               readOnly
// // // // //               onChange={e => handleFormChange('customerName', e.target.value)}
// // // // //             />
// // // // //           </div>
// // // // //           <div className="EstimateEmailField">
// // // // //             <label htmlFor="EstimateCustomerEmail">Email</label>
// // // // //             <input
// // // // //               type="text"
// // // // //               id="EstimateCustomerEmail"
// // // // //               placeholder="Email (separate emails...)"
// // // // //               value={formData.customerEmail || ''}
// // // // //               onChange={e => handleFormChange('customerEmail', e.target.value)}
// // // // //             />
// // // // //           </div>
// // // // //         </div>

// // // // //         <div className="EstimateAddressSection">
// // // // //           <div className="EstimateAddressesContainer">
// // // // //             <div>
// // // // //               <label>Origin Address</label>
// // // // //               <div className="EstimateAddressField">
// // // // //                 <input
// // // // //                   type="text"
// // // // //                   id="EstimateOriginAddressLine1"
// // // // //                   placeholder="Enter the Origin Address Line 1"
// // // // //                   maxLength="100"
// // // // //                   value={formData.originAddressLine1 || ''}
// // // // //                   onChange={e => handleFormChange('originAddressLine1', e.target.value)}
// // // // //                   readOnly
// // // // //                 />
// // // // //               </div>
// // // // //               <div className="EstimateAddressFieldDate">
// // // // //                 <label>Move Date</label>
// // // // //                 <input
// // // // //                   type="date"
// // // // //                   id="EstimateMoveDate"
// // // // //                   value={formData.moveDate || ''}
// // // // //                   onChange={e => handleFormChange('moveDate', e.target.value)}
// // // // //                   readOnly
// // // // //                 />
// // // // //               </div>
// // // // //             </div>
// // // // //             <div>
// // // // //               <label>Destination Address</label>
// // // // //               <div className="EstimateAddressField">
// // // // //                 <input
// // // // //                   type="text"
// // // // //                   id="EstimateDestAddressLine1"
// // // // //                   placeholder="Enter the Destination Address Line 1"
// // // // //                   maxLength="100"
// // // // //                   value={formData.destAddressLine1 || ''}
// // // // //                   onChange={e => handleFormChange('destAddressLine1', e.target.value)}
// // // // //                   readOnly
// // // // //                 />
// // // // //               </div>
// // // // //               <div className="EstimateAddressField">
// // // // //                 <label>Move Size</label>
// // // // //                 <input
// // // // //                   type="text"
// // // // //                   id="EstimateMoveSize"
// // // // //                   placeholder="Enter move size"
// // // // //                   value={formData.moveSize || ''}
// // // // //                   onChange={e => handleFormChange('moveSize', e.target.value)}
// // // // //                   readOnly
// // // // //                 />
// // // // //               </div>
// // // // //             </div>
// // // // //           </div>
// // // // //         </div>

// // // // //         <div className="EstimateTableSection" ref={tableRef}>
// // // // //           <table id="EstimateProductsTable">
// // // // //             <thead>
// // // // //               <tr>
// // // // //                 <th scope="col">#</th>
// // // // //                 <th scope="col">
// // // // //                   PRODUCT/
// // // // //                   <br />
// // // // //                   SERVICE
// // // // //                 </th>
// // // // //                 <th scope="col">DESCRIPTION</th>
// // // // //                 <th scope="col">
// // // // //                   <div className="EstimateHeaderLabel">
// // // // //                     <span>RATE</span>
// // // // //                     <span className="EstimateCurrency">CA$</span>
// // // // //                   </div>
// // // // //                 </th>
// // // // //                 <th scope="col">QTY</th>
// // // // //                 <th scope="col">
// // // // //                   <div className="EstimateHeaderLabel">
// // // // //                     <span>AMOUNT</span>
// // // // //                     <span className="EstimateCurrency">CA$</span>
// // // // //                   </div>
// // // // //                 </th>
// // // // //                 <th scope="col"></th>
// // // // //                 <th scope="col"></th>
// // // // //               </tr>
// // // // //             </thead>
// // // // //             <tbody id="EstimateProductsTableBody">
// // // // //               {products.map((product, index) => (
// // // // //                 <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F9FAFB' }}>
// // // // //                   {editingRow === index ? (
// // // // //                     <>
// // // // //                       <td>{index + 1}</td>
// // // // //                       <td>
// // // // //                         <div className="EstimateAutocompleteContainer">
// // // // //                           <input
// // // // //                             type="text"
// // // // //                             id={`EstimateProductService-${index}`}
// // // // //                             defaultValue={product.productService}
// // // // //                             list={`salesValueOptionsForProduct-${index}`}
// // // // //                             className="EstimateEditableInput EstimateProductService"
// // // // //                             onChange={e => handleProductServiceChange(index, e.target.value)}
// // // // //                           />
// // // // //                           <datalist id={`salesValueOptionsForProduct-${index}`}>
// // // // //                             {salesValueOptions.map(opt => (
// // // // //                               <option key={opt.Id} value={opt.Name} />
// // // // //                             ))}
// // // // //                           </datalist>
// // // // //                         </div>
// // // // //                       </td>
// // // // //                       <td>
// // // // //                         <div className="EstimateAutocompleteContainer">
// // // // //                           <input
// // // // //                             type="text"
// // // // //                             id={`EstimateDescription-${index}`}
// // // // //                             defaultValue={product.description}
// // // // //                             list={`salesValueOptionsForDescription-${index}`}
// // // // //                             className="EstimateEditableInput EstimateDescription"
// // // // //                           />
// // // // //                           <datalist id={`salesValueOptionsForDescription-${index}`}>
// // // // //                             {salesValueOptions.map(opt => (
// // // // //                               <option key={opt.Id} value={opt.Description} />
// // // // //                             ))}
// // // // //                           </datalist>
// // // // //                         </div>
// // // // //                       </td>
// // // // //                       <td>
// // // // //                         <input
// // // // //                           type="number"
// // // // //                           id={`EstimateRate-${index}`}
// // // // //                           defaultValue={product.rate}
// // // // //                           className="EstimateEditableInput EstimateRate"
// // // // //                           min="0"
// // // // //                           step="0.01"
// // // // //                           onChange={() => handleQtyRateChange(index)}
// // // // //                         />
// // // // //                       </td>
// // // // //                       <td>
// // // // //                         <input
// // // // //                           type="number"
// // // // //                           id={`EstimateQty-${index}`}
// // // // //                           defaultValue={product.qty}
// // // // //                           className="EstimateEditableInput EstimateQty"
// // // // //                           min="0"
// // // // //                           step="1"
// // // // //                           onChange={() => handleQtyRateChange(index)}
// // // // //                         />
// // // // //                       </td>
// // // // //                       <td className="EstimateAmount">{(product.qty * product.rate).toFixed(2)}</td>
// // // // //                       <td>
// // // // //                         <button className="EstimateDeleteBtn" onClick={() => deleteRow(index)}>
// // // // //                           🗑️
// // // // //                         </button>
// // // // //                       </td>
// // // // //                       <td>
// // // // //                         <button className="EstimateEditBtn" onClick={() => saveRow(index)}>
// // // // //                           ✏️
// // // // //                         </button>
// // // // //                       </td>
// // // // //                     </>
// // // // //                   ) : (
// // // // //                     <>
// // // // //                       <td>{index + 1}</td>
// // // // //                       <td>{product.productService || ''}</td>
// // // // //                       <td>{product.description || ''}</td>
// // // // //                       <td>{parseFloat(product.rate).toFixed(2)}</td>
// // // // //                       <td>{product.qty || '0'}</td>
// // // // //                       <td className="EstimateAmount">{product.amount}</td>
// // // // //                       <td>
// // // // //                         <button className="EstimateDeleteBtn" onClick={() => deleteRow(index)}>
// // // // //                           🗑️
// // // // //                         </button>
// // // // //                       </td>
// // // // //                       <td>
// // // // //                         <button className="EstimateEditBtn" onClick={() => toggleEditMode(index)}>
// // // // //                           ✏️
// // // // //                         </button>
// // // // //                       </td>
// // // // //                     </>
// // // // //                   )}
// // // // //                 </tr>
// // // // //               ))}
// // // // //             </tbody>
// // // // //           </table>
// // // // //           <div className="EstimateActionButtons">
// // // // //             <button id="EstimateAddLinesBtn" onClick={addNewRow}>
// // // // //               Add Lines
// // // // //             </button>
// // // // //             <button id="EstimateClearLinesBtn" onClick={() => {
// // // // //               setProducts([]);
// // // // //               setEditingRow(null);
// // // // //             }}>
// // // // //               Clear All Lines
// // // // //             </button>
// // // // //             <button id="EstimateSaveBtn" onClick={handleSaveClick}>
// // // // //               Save
// // // // //             </button>
// // // // //           </div>
// // // // //         </div>

// // // // //         <div className="EstimateTotalsContainer">
// // // // //           <div className="EstimateMessageSection">
// // // // //             <label htmlFor="EstimateMessage">Email Content</label>
// // // // //             <textarea
// // // // //               id="EstimateMessage"
// // // // //               placeholder="Email message"
// // // // //               value={formData.message || ''}
// // // // //               onChange={e => handleFormChange('message', e.target.value)}
// // // // //             />
// // // // //           </div>
// // // // //           <div className="EstimateTotalsSection">
// // // // //             <div className="EstimateTotalsRow EstimateSubtotalRow">
// // // // //               <label>SUBTOTAL</label>
// // // // //               <div className="EstimateMiddleSection"></div>
// // // // //               <div className="EstimateSpacer"></div>
// // // // //               <span className="EstimateValue" id="EstimateSubtotal">
// // // // //                 0.00
// // // // //               </span>
// // // // //             </div>
// // // // //             <div className="EstimateTotalsRow EstimateDiscountRow">
// // // // //               <label>DISCOUNT</label>
// // // // //               <div className="EstimateMiddleSection">
// // // // //                 <div className="EstimateDiscountContainer">
// // // // //                   <select
// // // // //                     id="EstimateDiscountTypeDropdown"
// // // // //                     value={formData.discountType || 'percent'}
// // // // //                     onChange={e => handleFormChange('discountType', e.target.value)}
// // // // //                   >
// // // // //                     <option value="percent">%</option>
// // // // //                     <option value="value">$</option>
// // // // //                   </select>
// // // // //                   <div id="EstimateDiscountInputContainer">
// // // // //                     <input
// // // // //                       type="number"
// // // // //                       id="EstimateDiscountInput"
// // // // //                       placeholder="0.00"
// // // // //                       min="0"
// // // // //                       step="0.01"
// // // // //                       value={formData.discountInput || '0.00'}
// // // // //                       onChange={e => handleFormChange('discountInput', e.target.value)}
// // // // //                     />
// // // // //                   </div>
// // // // //                 </div>
// // // // //               </div>
// // // // //               <div className="EstimateSpacer"></div>
// // // // //               <span className="EstimateValue" id="EstimateDiscountAmount">
// // // // //                 0.00
// // // // //               </span>
// // // // //             </div>
// // // // //             <div className="EstimateTotalsRow EstimateTaxRow">
// // // // //               <label>TAX</label>
// // // // //               <div className="EstimateMiddleSection">
// // // // //                 <select
// // // // //                   id="EstimateProvinceDropdown"
// // // // //                   value={formData.selectedProvince || ''}
// // // // //                   onChange={e => handleProvinceChange(e.target.value)}
// // // // //                 >
// // // // //                   <option value="">Select Province</option>
// // // // //                   {provinces.map(province => (
// // // // //                     <option key={province.ID} value={province.Province}>
// // // // //                       {province.Province} ({province['Tax%'] * 100}%)
// // // // //                     </option>
// // // // //                   ))}
// // // // //                 </select>
// // // // //               </div>
// // // // //               <div className="EstimateSpacer"></div>
// // // // //               <span className="EstimateValue" id="EstimateGstAmount">
// // // // //                 0.00
// // // // //               </span>
// // // // //             </div>
// // // // //             <div className="EstimateTotalsRow EstimateEstimateTotal EstimateEstimateTotalRow">
// // // // //               <label className="EstimateBold">ESTIMATE TOTAL</label>
// // // // //               <div className="EstimateSpacer"></div>
// // // // //               <span className="EstimateValue EstimateBold" id="EstimateTotal">
// // // // //                 0.00
// // // // //               </span>
// // // // //             </div>
// // // // //             <div className="EstimateTotalsRow EstimateEstimateTotal EstimateEstimateTotalRow">
// // // // //               <label className="EstimateBold">Deposit to pay</label>
// // // // //               <div className="EstimateSpacer"></div>
// // // // //               <span className="EstimateValue EstimateBold">
// // // // //                 <input
// // // // //                   type="number"
// // // // //                   style={{ padding: '5px', border: '1px solid', borderRadius: '2px' }}
// // // // //                   id="Deposittopay"
// // // // //                   placeholder="Deposit to pay"
// // // // //                   value={formData.depositToPay || ''}
// // // // //                   onChange={e => handleFormChange('depositToPay', e.target.value)}
// // // // //                 />
// // // // //               </span>
// // // // //             </div>
// // // // //           </div>
// // // // //         </div>
// // // // //       </div>

// // // // //       {showConfirmOverlay && (
// // // // //         <div className="ConfirmOverlay">
// // // // //           <div className="ConfirmOverlayContent">
// // // // //             {alertMessage.message ? (
// // // // //               <>
// // // // //                 <h3>{alertMessage.type === 'success' ? 'Success' : 'Error'}</h3>
// // // // //                 <p>{alertMessage.message}</p>
// // // // //                 <div className="ConfirmOverlayButtons">
// // // // //                   <button className="OverlayCloseBtn" onClick={closeOverlay}>
// // // // //                     Close
// // // // //                   </button>
// // // // //                 </div>
// // // // //               </>
// // // // //             ) : (
// // // // //               <>
// // // // //                 <h3>{overlayAction === 'send' ? 'Send Estimate' : 'Confirm Booking'}</h3>
// // // // //                 <p>
// // // // //                   {overlayAction === 'send'
// // // // //                     ? 'Are you sure you want to send this estimate? This action will email the estimate to the customer.'
// // // // //                     : (
// // // // //                       <>
// // // // //                         Are you sure you want to confirm this booking? This action will send the invoice for a deposit of 
// // // // //                         <strong> ${parseFloat(formData.depositToPay || 0).toFixed(2)}</strong> and update the status to "Booked."
// // // // //                       </>
// // // // //                     )}
// // // // //                 </p>
// // // // //                 <div className="ConfirmOverlayButtons">
// // // // //                   <button className="OverlayCloseBtn" onClick={closeOverlay}>
// // // // //                     Close
// // // // //                   </button>
// // // // //                   <button
// // // // //                     className="OverlayConfirmBtn"
// // // // //                     onClick={overlayAction === 'send' ? sendEstimate : confirmBooking}
// // // // //                   >
// // // // //                     {overlayAction === 'send' ? 'Send' : 'Confirm'}
// // // // //                   </button>
// // // // //                 </div>
// // // // //               </>
// // // // //             )}
// // // // //           </div>
// // // // //         </div>
// // // // //       )}

// // // // //       {showLoadingOverlay && (
// // // // //         <div className="LoadingOverlay">
// // // // //           <div className="LoadingOverlayContent">
// // // // //             <div className="Spinner"></div>
// // // // //             <p>Processing...</p>
// // // // //           </div>
// // // // //         </div>
// // // // //       )}

// // // // //       {showEstimateOverlay && (
// // // // //         <div className="EstimateOverlay">
// // // // //           <div className="EstimateOverlayContent">
// // // // //             <button className="OverlayCloseBtn" onClick={closeEstimateOverlay} style={{ position: 'absolute', top: '10px', right: '10px' }}>
// // // // //               Close
// // // // //             </button>
// // // // //             <iframe
// // // // //               src={`https://salesjet.allcanadavanlines.com/app/index.html#/estimate/${btoa(booking.LeadACVLRecordID.toString())}`}
// // // // //               style={{ width: '100%', height: '100%', border: 'none' }}
// // // // //               title="Estimate View"
// // // // //               frameBorder="0"
// // // // //             />
// // // // //           </div>
// // // // //         </div>
// // // // //       )}
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default Estimate;




// // // // import React, { useEffect, useState, useRef } from 'react';
// // // // import './Estimate.css';
// // // // import CryptoJS from 'crypto-js';
// // // // import EstimatePage from '../EmailEsimate/Emailestimate';

// // // // const Estimate = ({ accessToken, booking, userDetails, userMap, updateLeadData }) => {
// // // //   const [isActive, setIsActive] = useState(false);
// // // //   const [status, setStatus] = useState('Draft');
// // // //   const [products, setProducts] = useState([]);
// // // //   const [editingRow, setEditingRow] = useState(null);
// // // //   const [salesValueOptions, setSalesValueOptions] = useState([]);
// // // //   const [existingEstimate, setExistingEstimate] = useState(null);
// // // //   const [formData, setFormData] = useState({});
// // // //   const [showConfirmOverlay, setShowConfirmOverlay] = useState(false);
// // // //   const [showLoadingOverlay, setShowLoadingOverlay] = useState(false);
// // // //   const [provinces, setProvinces] = useState([]);
// // // //   const [alertMessage, setAlertMessage] = useState({ type: '', message: '' });
// // // //   const [defaultMessage, setDefaultMessage] = useState('');
// // // //   const [overlayAction, setOverlayAction] = useState('');
// // // //   const [showViewEstimate, setShowViewEstimate] = useState(false);
// // // //   const [showEstimateOverlay, setShowEstimateOverlay] = useState(false);
// // // //   const tableRef = useRef(null);

// // // //   const SECRET_KEY = '7f3a1d9e4c6b2f88b0e7a5c9d4f1342b';

// // // //   useEffect(() => {
// // // //     const fetchProvinces = async () => {
// // // //       try {
// // // //         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/taxvalueid');
// // // //         if (!response.ok) throw new Error('Error fetching provinces');
// // // //         const data = await response.json();
// // // //         setProvinces(data.records || []);
// // // //       } catch (error) {
// // // //         console.error('Error fetching provinces:', error);
// // // //       }
// // // //     };

// // // //     const fetchSalesValues = async () => {
// // // //       try {
// // // //         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/salesvalueid');
// // // //         if (!response.ok) throw new Error('Error fetching sales values');
// // // //         const data = await response.json();
// // // //         setSalesValueOptions(data.records || []);
// // // //       } catch (error) {
// // // //         console.error('Error fetching sales values:', error);
// // // //       }
// // // //     };

// // // //     fetchProvinces();
// // // //     fetchSalesValues();
// // // //   }, []);

// // // //   useEffect(() => {
// // // //     const fetchEmailTemplate = async () => {
// // // //       try {
// // // //         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/emailtemp');
// // // //         if (!response.ok) throw new Error('Error fetching email template');
// // // //         const data = await response.json();
// // // //         if (data.status === 'success' && data.records.length > 0) {
// // // //           setDefaultMessage(data.records[0].defaultMessage || '');
// // // //         }
// // // //       } catch (error) {
// // // //         console.error('Error fetching email template:', error);
// // // //         setDefaultMessage(
// // // //           'Thank you for the opportunity to provide an estimate for your move.'
// // // //         );
// // // //       }
// // // //     };

// // // //     fetchEmailTemplate();
// // // //   }, []);

// // // //   useEffect(() => {
// // // //     const checkExistingEstimate = async () => {
// // // //       if (!booking?.LeadACVLRecordID || !accessToken) return;
// // // //       setShowViewEstimate(false);
// // // //       if (booking?.Status === 'Estimate sent' || booking?.Status === 'Booked') {
// // // //         setShowViewEstimate(true);
// // // //       }
// // // //       try {
// // // //         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/esti', {
// // // //           method: 'GET',
// // // //           headers: {
// // // //             'Authorization': `Bearer ${accessToken}`,
// // // //             'Content-Type': 'application/json',
// // // //             'LeadACVLRecordID': booking.LeadACVLRecordID,
// // // //           },
// // // //         });
// // // //         if (response.ok) {
// // // //           const result = await response.json();
// // // //           if (result.status === 'success' && result.totalRecords > 0) {
// // // //             setExistingEstimate(result.data[0]);
// // // //             const itemsString = result.data[0].Items;
// // // //             let validJsonString = itemsString
// // // //               .replace(/=/g, ':')
// // // //               .replace(/([{,])\s*([^{,\s:]+)\s*:/g, '$1"$2":')
// // // //               .replace(/:\s*([^",}\s][^,}]*)(?=[,}])/g, (match, value) => {
// // // //                 const trimmedValue = value.trim();
// // // //                 return /^[0-9.-]+$/.test(trimmedValue) ? `:${trimmedValue}` : `:"${trimmedValue}"`;
// // // //               });

// // // //             try {
// // // //               const parsedItems = JSON.parse(validJsonString).map(item => {
// // // //                 const matchingOption = salesValueOptions.find(opt => opt.Name === item.desc);
// // // //                 return {
// // // //                   productService: item.desc,
// // // //                   description: matchingOption ? matchingOption.Description : item.desc,
// // // //                   qty: parseFloat(item.qty) || 0,
// // // //                   rate: parseFloat(item.rate) || 0,
// // // //                   amount: parseFloat(item.amount) || 0,
// // // //                 };
// // // //               });
// // // //               setProducts(parsedItems);
// // // //             } catch (parseError) {
// // // //               console.error('JSON parse error:', parseError);
// // // //               const manualItems = itemsString.match(/\{[^}]*\}/g)?.map(itemStr => {
// // // //                 const item = {};
// // // //                 itemStr.replace(/(\w+)\s*=\s*([^,}]+)/g, (_, key, value) => {
// // // //                   item[key] = isNaN(value) ? value.trim() : parseFloat(value);
// // // //                 });
// // // //                 const matchingOption = salesValueOptions.find(opt => opt.Name === item.desc);
// // // //                 return {
// // // //                   productService: item.desc,
// // // //                   description: matchingOption ? matchingOption.Description : item.desc,
// // // //                   qty: parseFloat(item.qty) || 0,
// // // //                   rate: parseFloat(item.rate) || 0,
// // // //                   amount: parseFloat(item.amount) || 0,
// // // //                 };
// // // //               }) || [];
// // // //               setProducts(manualItems);
// // // //             }
// // // //           } else {
// // // //             setExistingEstimate(null);
// // // //             setProducts([]);
// // // //           }
// // // //         } else {
// // // //           console.error('API request failed:', response.statusText);
// // // //         }
// // // //       } catch (error) {
// // // //         console.error('Error checking existing estimate:', error);
// // // //       }
// // // //     };

// // // //     setProducts([]);
// // // //     setExistingEstimate(null);
// // // //     setEditingRow(null);
// // // //     setStatus('Draft');
// // // //     checkExistingEstimate();
// // // //   }, [booking, accessToken, salesValueOptions, userDetails]);

// // // //   useEffect(() => {
// // // //     const newFormData = existingEstimate
// // // //       ? {
// // // //           customerName: booking.Customer_Name || '',
// // // //           customerEmail: existingEstimate.Email || '',
// // // //           originAddressLine1: booking.FromAddress || booking.OriginCity,
// // // //           originProvince: booking.OriginCity || '',
// // // //           moveDate: booking.Move_Date || '',
// // // //           destAddressLine1: booking.ToAddress || booking.DestinationCity,
// // // //           destProvince: booking.DestinationCity || '',
// // // //           moveSize: booking.Move_Size || '',
// // // //           depositToPay: existingEstimate.Deposittopay || '',
// // // //           discountInput: existingEstimate.Discount || '0.00',
// // // //           discountType: existingEstimate.DiscountType || 'percent',
// // // //           message: existingEstimate.message || defaultMessage,
// // // //           selectedProvince: existingEstimate.Tax || '0',
// // // //         }
// // // //       : booking
// // // //       ? {
// // // //           customerName: booking.Customer_Name || '',
// // // //           customerEmail: booking.Email || '',
// // // //           originAddressLine1: booking.FromAddress || booking.OriginCity,
// // // //           moveDate: booking.Move_Date || '',
// // // //           destAddressLine1: booking.ToAddress || booking.DestinationCity,
// // // //           moveSize: booking.Move_Size || '',
// // // //           discountType: 'percent',
// // // //           discountInput: '0.00',
// // // //           selectedProvince: '0',
// // // //           depositToPay: '100',
// // // //           message: defaultMessage,
// // // //         }
// // // //       : { message: defaultMessage };
// // // //     setFormData(newFormData);
// // // //     updateTotals();
// // // //   }, [booking, existingEstimate, defaultMessage]);

// // // //   useEffect(() => {
// // // //     updateTotals();
// // // //   }, [products, formData]);

// // // //   useEffect(() => {
// // // //     const handleClickOutside = (event) => {
// // // //       if (tableRef.current && !tableRef.current.contains(event.target) && editingRow !== null) {
// // // //         saveRow(editingRow);
// // // //       }
// // // //     };

// // // //     document.addEventListener('mousedown', handleClickOutside);
// // // //     return () => {
// // // //       document.removeEventListener('mousedown', handleClickOutside);
// // // //     };
// // // //   }, [editingRow]);

// // // //   const toTitleCase = str => str?.toLowerCase().replace(/(^|\s)\w/g, letter => letter.toUpperCase()) || '';

// // // //   const calculateSubtotal = () => products.reduce((sum, product) => sum + (parseFloat(product.amount) || 0), 0);

// // // //   const calculateDiscount = subtotal => {
// // // //     const discountType = formData.discountType || 'percent';
// // // //     const discountValue = parseFloat(formData.discountInput) || 0;
// // // //     return discountType === 'percent' ? (subtotal * discountValue) / 100 : discountValue;
// // // //   };

// // // //   const calculateTax = subtotalAfterDiscount => {
// // // //     const selectedProvince = provinces.find(p => p.Province === formData.selectedProvince);
// // // //     const taxPercentage = selectedProvince ? selectedProvince['Tax%'] * 100 : 0;
// // // //     return (subtotalAfterDiscount * taxPercentage) / 100;
// // // //   };

// // // //   const updateTotals = () => {
// // // //     const subtotal = calculateSubtotal();
// // // //     const discountAmount = calculateDiscount(subtotal);
// // // //     const subtotalAfterDiscount = subtotal - discountAmount;
// // // //     const gstAmount = calculateTax(subtotalAfterDiscount);
// // // //     const total = subtotalAfterDiscount + gstAmount;
// // // //     document.getElementById('EstimateSubtotal').textContent = subtotal.toFixed(2);
// // // //     document.getElementById('EstimateDiscountAmount').textContent = discountAmount.toFixed(2);
// // // //     document.getElementById('EstimateGstAmount').textContent = gstAmount.toFixed(2);
// // // //     document.getElementById('EstimateTotal').textContent = total.toFixed(2);
// // // //   };

// // // //   const handleFormChange = (field, value) => {
// // // //     setFormData(prev => ({ ...prev, [field]: value }));
// // // //   };

// // // //   const toggleContent = () => setIsActive(prev => !prev);

// // // //   const handleCancelClick = e => {
// // // //     e.stopPropagation();
// // // //     setIsActive(false);
// // // //   };

// // // //   const handleProductServiceChange = (index, value) => {
// // // //     const match = salesValueOptions.find(opt => opt.Name === value);
// // // //     if (match) {
// // // //       const descriptionInput = document.getElementById(`EstimateDescription-${index}`);
// // // //       const rateInput = document.getElementById(`EstimateRate-${index}`);
// // // //       if (descriptionInput) descriptionInput.value = match.Description;
// // // //       if (rateInput) rateInput.value = match.UnitPrice;
// // // //     }
// // // //   };

// // // //   const addNewRow = () => {
// // // //     let updated = [...products]; 
// // // //     if (editingRow !== null && editingRow < updated.length) {
// // // //       const result = saveRow(editingRow);
// // // //       if (!result) return;
// // // //       updated = result;
// // // //     }

// // // //     const newRow = { productService: '', description: '', rate: 0, qty: 0, amount: 0 };
// // // //     const newProducts = [...updated, newRow];
// // // //     const newIndex = newProducts.length - 1;

// // // //     setProducts(newProducts);
// // // //     setEditingRow(newIndex);

// // // //     setTimeout(() => {
// // // //       const input = document.getElementById(`EstimateProductService-${newIndex}`);
// // // //       if (input) input.focus();

// // // //       const row = document.querySelector(`#EstimateProductsTableBody tr:nth-child(${newIndex + 1})`);
// // // //       if (row) row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
// // // //     }, 100);
// // // //   };

// // // //   const deleteRow = index => {
// // // //     const newProducts = products.filter((_, i) => i !== index);
// // // //     setProducts(newProducts);
// // // //     if (editingRow === index) setEditingRow(null);
// // // //   };

// // // //   const saveRow = index => {
// // // //     const qty = parseFloat(document.getElementById(`EstimateQty-${index}`).value) || 0;
// // // //     const rate = parseFloat(document.getElementById(`EstimateRate-${index}`).value) || 0;
  
// // // //     if (qty < 0 || rate < 0) {
// // // //       setAlertMessage({ type: 'error', message: 'Quantity and rate must be non-negative.' });
// // // //       setShowConfirmOverlay(true);
// // // //       return null;
// // // //     }
  
// // // //     const productService = document.getElementById(`EstimateProductService-${index}`).value;
// // // //     const description = document.getElementById(`EstimateDescription-${index}`).value;
// // // //     const amount = (qty * rate).toFixed(2);
  
// // // //     const updatedProducts = products.map((p, i) =>
// // // //       i === index ? { ...p, productService, description: toTitleCase(description), rate, qty, amount } : p
// // // //     );
  
// // // //     setProducts(updatedProducts);
// // // //     setEditingRow(null);
// // // //     return updatedProducts;
// // // //   };
  
// // // //   const handleQtyRateChange = index => {
// // // //     const qty = parseFloat(document.getElementById(`EstimateQty-${index}`).value) || 0;
// // // //     const rate = parseFloat(document.getElementById(`EstimateRate-${index}`).value) || 0;
// // // //     const amount = (qty * rate).toFixed(2);
// // // //     const updatedProducts = [...products];
// // // //     updatedProducts[index] = { ...updatedProducts[index], qty, rate, amount };
// // // //     setProducts(updatedProducts);
// // // //   };

// // // //   const toggleEditMode = index => {
// // // //     if (editingRow !== null && editingRow !== index) saveRow(editingRow);
// // // //     setEditingRow(editingRow === index ? null : index);
// // // //   };

// // // //   const handleSendConfirm = () => {
// // // //     setOverlayAction('confirm');
// // // //     setShowConfirmOverlay(true);
// // // //     setAlertMessage({ type: '', message: '' });
// // // //   };

// // // //   const closeOverlay = () => {
// // // //     setShowConfirmOverlay(false);
// // // //     setAlertMessage({ type: '', message: '' });
// // // //     setOverlayAction('');
// // // //   };

// // // //   const handleSaveClick = () => {
// // // //     if (editingRow !== null) saveRow(editingRow);
// // // //   };

// // // //   const handleProvinceChange = provinceName => {
// // // //     const selectedProvince = provinces.find(p => p.Province === provinceName);
// // // //     setFormData(prev => ({
// // // //       ...prev,
// // // //       selectedProvince: provinceName,
// // // //       provinceId: selectedProvince?.ID || null,
// // // //       gstDropdown: selectedProvince ? (selectedProvince['Tax%'] * 100).toString() : '0',
// // // //     }));
// // // //   };

// // // //   const handleViewEstimateClick = () => {
// // // //     if (!booking?.LeadACVLRecordID) {
// // // //       setAlertMessage({ type: 'error', message: 'Estimate ID is missing.' });
// // // //       setShowConfirmOverlay(true);
// // // //       return;
// // // //     }
// // // //     setShowEstimateOverlay(true);
// // // //   };

// // // //   const closeEstimateOverlay = () => {
// // // //     setShowEstimateOverlay(false);
// // // //   };

// // // //   const handleSendClick = () => {
// // // //     setOverlayAction('send');
// // // //     setShowConfirmOverlay(true);
// // // //     setAlertMessage({ type: '', message: '' });
// // // //   };

// // // //   const sendEstimate = async () => {
// // // //     if (products.length === 0) {
// // // //       setAlertMessage({ type: 'error', message: 'Please add at least one product/service to the estimate before sending.' });
// // // //       setShowConfirmOverlay(true);
// // // //       return;
// // // //     }

// // // //     setShowConfirmOverlay(false);
// // // //     setShowLoadingOverlay(true);
// // // //     setAlertMessage({ type: '', message: '' });

// // // //     const selectedProvince = provinces.find(p => p.Province === formData.selectedProvince);
// // // //     const taxField = selectedProvince
// // // //       ? `${selectedProvince.Province} - ${(selectedProvince['Tax%'] * 100).toFixed(0)}%`
// // // //       : '0';

// // // //     let salesAgentName = booking?.Sales_Agent || '';
// // // //     if (!salesAgentName && userDetails?.userId && userMap) {
// // // //       salesAgentName = userMap[userDetails.userId] || 'Agent';
// // // //     }
// // // //     if (!salesAgentName) {
// // // //       salesAgentName = 'Agent';
// // // //     }

// // // //     const payload1 = {
// // // //       LeadACVLRecordID: booking.LeadACVLRecordID,
// // // //       OriginCity: booking.OriginCity,
// // // //       Customer_Name: formData.customerName,
// // // //       Deposittopay: formData.depositToPay,
// // // //       Sales_Agent: salesAgentName,
// // // //       Email: formData.customerEmail,
// // // //       message: formData.message,
// // // //       Move_Size: formData.moveSize,
// // // //       Move_Date: formData.moveDate,
// // // //       Estimatetotal: parseFloat(document.getElementById('EstimateTotal').textContent),
// // // //       DestinationCity: booking.DestinationCity,
// // // //       FromAddress: `${formData.originAddressLine1}`,
// // // //       ToAddress: `${formData.destAddressLine1}`,
// // // //       Items: products.map(product => ({
// // // //         desc: product.productService,
// // // //         prod: product.description,
// // // //         qty: product.qty,
// // // //         rate: parseFloat(product.rate).toFixed(2),
// // // //         amount: parseFloat(product.amount).toFixed(2),
// // // //       })),
// // // //       Subtotal: calculateSubtotal().toFixed(2),
// // // //       Discount: formData.discountInput,
// // // //       TAXValue: calculateTax(calculateSubtotal() - calculateDiscount(calculateSubtotal())).toFixed(2),
// // // //       DiscountType: formData.discountType || ' ',
// // // //       Tax: formData.selectedProvince || '0',
// // // //       TaxPercentage: taxField || '0',
// // // //     };

// // // //     const payload2 = {
// // // //       recipientEmail: formData.customerEmail,
// // // //       subject: 'Estimate #' + booking.LeadACVLRecordID + ' from All Canada Van Lines Inc.',
// // // //       message: formData.message,
// // // //       filteredByOriginDestRange: products.map(product => ({
// // // //         'Estimate Item - Desc': product.productService,
// // // //         'Estimate Item - pro': product.description,
// // // //         'Estimate Item - Quantity': product.qty,
// // // //         'Estimate Item - Rate': parseFloat(product.rate),
// // // //         'Estimate Item - Amount': parseFloat(product.amount),
// // // //       })),
// // // //       subTotal: calculateSubtotal(),
// // // //       tax: taxField,
// // // //       Deposittopay: formData.depositToPay,
// // // //       taxAmount: calculateTax(calculateSubtotal() - calculateDiscount(calculateSubtotal())),
// // // //       Discount: calculateDiscount(calculateSubtotal()),
// // // //       finalamount: parseFloat(document.getElementById('EstimateTotal').textContent),
// // // //       LeadACVLRecordID: booking.LeadACVLRecordID,
// // // //     };

// // // //     const payload3 = [
// // // //       {
// // // //         ROWID: booking.ROWID,
// // // //         Status: 'Estimate sent',
// // // //         Estimate_Amount: parseFloat(document.getElementById('EstimateTotal').textContent),
// // // //       },    
// // // //     ];

// // // //     try {
// // // //       const response1 = await fetch('https://salesjet-10097049716.catalystappsail.com/esti', {
// // // //         method: 'POST',
// // // //         headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
// // // //         body: JSON.stringify(payload1),
// // // //       });
// // // //       if (!response1.ok) throw new Error('Failed to send estimate to First API');
// // // //       console.log('First API Response:', await response1.json());

// // // //       const response2 = await fetch(
// // // //         'https://salesjet-841904208.catalystserverless.com/server/email-estimate-function/email-estimate',
// // // //         {
// // // //           method: 'POST',
// // // //           headers: { 'Content-Type': 'application/json' },
// // // //           body: JSON.stringify(payload2),
// // // //         }
// // // //       );

// // // //       if (!response2.ok) {
// // // //         let errorMessage = `HTTP error ${response2.status}: ${response2.statusText}`;
// // // //         try {
// // // //           const errorData = await response2.json();
// // // //           errorMessage = errorData.message || errorData.error || errorMessage; 
// // // //         } catch (jsonError) {
// // // //           console.warn('Failed to parse error response from Second API:', jsonError);
// // // //         }
// // // //         throw new Error(errorMessage); 
// // // //       }

// // // //       console.log('Second API Response:', await response2.json());

// // // //       if (booking.Status !== 'Booked') {
// // // //         const response3 = await fetch('https://salesjet-10097049716.catalystappsail.com/leadsdata', {
// // // //           method: 'PUT',
// // // //           headers: {
// // // //             'Content-Type': 'application/json',
// // // //             Authorization: `Bearer ${accessToken}`,
// // // //           },
// // // //           body: JSON.stringify(payload3),
// // // //         });
// // // //         if (!response3.ok) throw new Error('Failed to update status to "Estimate sent"');
// // // //         console.log('Status Update Response:', await response3.json());
// // // //         // addednewly
// // // //          const updatedBooking = {
// // // //           LeadACVLRecordID: booking.LeadACVLRecordID,
// // // //           ROWID: booking.ROWID,
// // // //           Status: 'Estimate sent',
// // // //           Estimate_Amount: parseFloat(document.getElementById('EstimateTotal').textContent),
// // // //         };
// // // //         console.log('Calling updateLeadData with:', updatedBooking);
// // // //         updateLeadData(updatedBooking);
// // // //       } else {
// // // //         console.log('Booking already marked as "Booked", skipping status update.');
// // // //       }

// // // //       setStatus('Sent');
// // // //       setShowViewEstimate(true);
// // // //       setAlertMessage({ type: 'success', message: 'Email sent successfully' });
// // // //     } catch (error) {
// // // //       console.error('Error sending estimate:', error);
// // // //       setAlertMessage({ type: 'error', message: `Failed to send estimate: ${error.message}` });
// // // //     } finally {
// // // //       setShowLoadingOverlay(false);
// // // //       setShowConfirmOverlay(true);
// // // //     }
// // // //   };

// // // //   const confirmBooking = async () => {
// // // //     setShowConfirmOverlay(false);
// // // //     setShowLoadingOverlay(true);
// // // //     setAlertMessage({ type: '', message: '' });
// // // //     const customerEmail = document.getElementById('EstimateCustomerEmail').value;
// // // //     const customerName = document.getElementById('EstimateCustomerName').value;
// // // //     const DocNumber = booking.LeadACVLRecordID || 'DocNumber';
// // // //     const billAddr = {
// // // //       Line1: document.getElementById('EstimateOriginAddressLine1').value,
// // // //       Country: 'CA',
// // // //     };
// // // //     const shipAddr = {
// // // //       Line1: document.getElementById('EstimateDestAddressLine1').value,
// // // //       Country: 'CA',
// // // //     };
// // // //     const depositAmount = parseFloat(document.getElementById('Deposittopay').value) || 0;

// // // //     const lineItems = [];
// // // //     if (depositAmount > 0) {
// // // //       lineItems.push({
// // // //         Id: '1',
// // // //         LineNum: 1,
// // // //         Description: 'Deposit Towards Move Booked',
// // // //         Amount: depositAmount,
// // // //         DetailType: 'SalesItemLineDetail',
// // // //         SalesItemLineDetail: {
// // // //           ItemRef: {
// // // //             value: '1',
// // // //             name: 'Services',
// // // //           },
// // // //           UnitPrice: depositAmount,
// // // //           Qty: 1,
// // // //           ItemAccountRef: {
// // // //             value: '52',
// // // //             name: 'Services',
// // // //           },
// // // //         },
// // // //       });
// // // //     } else {
// // // //       setAlertMessage({ type: 'error', message: 'Please specify a deposit amount to confirm the booking.' });
// // // //       setShowLoadingOverlay(false);
// // // //       setShowConfirmOverlay(true);
// // // //       return;
// // // //     }
// // // //     const payload = {
// // // //       customerEmail: customerEmail,
// // // //       DisplayName: customerName,
// // // //       invoiceData: {
// // // //         BillEmail: {
// // // //           Address: customerEmail,
// // // //         },
// // // //         DocNumber: DocNumber,
// // // //         TxnDate: new Date().toISOString().split('T')[0],
// // // //         DueDate: document.getElementById('EstimateMoveDate').value,
// // // //         CustomField: [
// // // //           {
// // // //             DefinitionId: '1',
// // // //             Name: 'Sales Agent',
// // // //             Type: 'StringType',
// // // //             StringValue: 'Paul1',
// // // //           },
// // // //         ],
// // // //         BillAddr: billAddr,
// // // //         ShipAddr: shipAddr,
// // // //         CustomerMemo: {
// // // //           value: 'Receipt deposit for your upcoming move. This will be applied toward your final invoice.',
// // // //         },
// // // //         GlobalTaxCalculation: 'NotApplicable',
// // // //         Line: lineItems,
// // // //         Deposit: depositAmount,
// // // //         DepositToAccountRef: {
// // // //           value: '5',
// // // //           name: 'Undeposited Funds',
// // // //         },
// // // //       },
// // // //     };
// // // //     const payload4 = [
// // // //       {
// // // //         ROWID: booking.ROWID,
// // // //         Status: 'Booked',
// // // //       },
// // // //     ];
// // // //     try {
// // // //       const response = await fetch(
// // // //         'https://salesjet-841904208.catalystserverless.com/server/qb_post/handle-invoice',
// // // //         {
// // // //           method: 'POST',
// // // //           headers: {
// // // //             'Content-Type': 'application/json',
// // // //           },
// // // //           body: JSON.stringify(payload),
// // // //         }
// // // //       );

// // // //       if (!response.ok) {
// // // //         const errorData = await response.json();
// // // //         console.error('API Error:', errorData);
// // // //         setAlertMessage({
// // // //           type: 'error',
// // // //           message: `Failed to create invoice: ${errorData.Fault?.Error[0]?.Message || 'Unknown error'} (${errorData.Fault?.Error[0]?.Detail || ''})`,
// // // //         });
// // // //         throw new Error('Failed to save estimate');
// // // //       }

// // // //       const result = await response.json();
// // // //       console.log('Estimate saved successfully:', result);

// // // //       const response2 = await fetch('https://salesjet-10097049716.catalystappsail.com/leadsdata', {
// // // //         method: 'PUT',
// // // //         headers: {
// // // //           'Content-Type': 'application/json',
// // // //           Authorization: `Bearer ${accessToken}`,
// // // //         },
// // // //         body: JSON.stringify(payload4),
// // // //       });
// // // //       if (!response2.ok) throw new Error('Failed to update status to "Booked"');
// // // //       console.log('Status Update Response:', await response2.json());

// // // //       setStatus('Saved');
// // // //       setShowViewEstimate(true);
// // // //       setAlertMessage({ type: 'success', message: 'Invoice sent successfully in QB' });
// // // //     } catch (error) {
// // // //       console.error('Error saving estimate:', error);
// // // //       setAlertMessage({ type: 'error', message: 'Failed to Create Invoice in QB. Please try again.' });
// // // //     } finally {
// // // //       setShowLoadingOverlay(false);
// // // //       setShowConfirmOverlay(true);
// // // //     }
// // // //   };

// // // //   // Function to generate and copy customer link

// // // //   const handleCopyCustomerLink = () => {
// // // //     if (!booking?.LeadACVLRecordID) {
// // // //       setAlertMessage({ type: 'error', message: 'Estimate ID is missing.' });
// // // //       setShowConfirmOverlay(true);
// // // //       return;
// // // //     }

// // // //     const encryptedId = CryptoJS.AES.encrypt(booking.LeadACVLRecordID.toString(), SECRET_KEY).toString();
// // // //     const encodedEncryptedId = encodeURIComponent(encryptedId);
// // // //     const customerLink = `https://salesjet.allcanadavanlines.com/server/estimate_view/?${encodedEncryptedId}`;

// // // //     navigator.clipboard.writeText(customerLink).then(() => {
// // // //       setAlertMessage({ type: 'success', message: 'Customer link copied to clipboard!' });
// // // //       setShowConfirmOverlay(true);
// // // //     }).catch(err => {
// // // //       setAlertMessage({ type: 'error', message: 'Failed to copy link to clipboard.' });
// // // //       setShowConfirmOverlay(true);
// // // //       console.error('Clipboard error:', err);
// // // //     });
// // // //   };

// // // //   return (
// // // //     <div>
// // // //       <div className={`EstimateHeader ${isActive ? 'EstimateActive' : ''}`} onClick={toggleContent}>
// // // //         <div className="EstimateLeftSection">
// // // //           <h2>ESTIMATE</h2>
// // // //           <span className="EstimateLeftSection" style={{ background: 'white', padding: '5px', borderRadius: '10px' }}>
// // // //             {booking.Status}
// // // //           </span>
// // // //           {showViewEstimate && (
// // // //             <>
// // // //               <button
// // // //                 className="EstimateViewBtn"
// // // //                 onClick={handleViewEstimateClick}
// // // //               >
// // // //                 View Estimate
// // // //               </button>
// // // //               <button
// // // //                 className="EstimateViewBtn"
// // // //                 onClick={handleCopyCustomerLink}
// // // //                 style={{ marginLeft: '10px' }}
// // // //               >
// // // //                 Customer Link
// // // //               </button>
// // // //             </>
// // // //           )}
// // // //         </div>
// // // //         <div className="EstimateRightButtons">
// // // //           <button className="EstimateCancelBtn" onClick={handleCancelClick}>
// // // //             Cancel
// // // //           </button>
// // // //           <button className="EstimateSendBtn" onClick={handleSendClick}>
// // // //             Send
// // // //           </button>
// // // //         </div>
// // // //       </div>     
// // // //       <div className={`EstimateContent ${isActive ? 'EstimateVisible' : ''}`}>
// // // //         <div className="EstimateCustomerSection">
// // // //           <div className="EstimateCustomerField">
// // // //             <label htmlFor="EstimateCustomerName">Customer</label>
// // // //             <input
// // // //               type="text"
// // // //               id="EstimateCustomerName"
// // // //               placeholder="Enter customer name"
// // // //               value={formData.customerName || ''}
// // // //               readOnly
// // // //               onChange={e => handleFormChange('customerName', e.target.value)}
// // // //             />
// // // //           </div>
// // // //           <div className="EstimateEmailField">
// // // //             <label htmlFor="EstimateCustomerEmail">Email</label>
// // // //             <input
// // // //               type="text"
// // // //               id="EstimateCustomerEmail"
// // // //               placeholder="Email (separate emails...)"
// // // //               value={formData.customerEmail || ''}
// // // //               onChange={e => handleFormChange('customerEmail', e.target.value)}
// // // //             />
// // // //           </div>
// // // //         </div>

// // // //         <div className="EstimateAddressSection">
// // // //           <div className="EstimateAddressesContainer">
// // // //             <div>
// // // //               <label>Origin Address</label>
// // // //               <div className="EstimateAddressField">
// // // //                 <input
// // // //                   type="text"
// // // //                   id="EstimateOriginAddressLine1"
// // // //                   placeholder="Enter the Origin Address Line 1"
// // // //                   maxLength="100"
// // // //                   value={formData.originAddressLine1 || ''}
// // // //                   onChange={e => handleFormChange('originAddressLine1', e.target.value)}
// // // //                   readOnly
// // // //                 />
// // // //               </div>
// // // //               <div className="EstimateAddressFieldDate">
// // // //                 <label>Move Date</label>
// // // //                 <input
// // // //                   type="date"
// // // //                   id="EstimateMoveDate"
// // // //                   value={formData.moveDate || ''}
// // // //                   onChange={e => handleFormChange('moveDate', e.target.value)}
// // // //                   readOnly
// // // //                 />
// // // //               </div>
// // // //             </div>
// // // //             <div>
// // // //               <label>Destination Address</label>
// // // //               <div className="EstimateAddressField">
// // // //                 <input
// // // //                   type="text"
// // // //                   id="EstimateDestAddressLine1"
// // // //                   placeholder="Enter the Destination Address Line 1"
// // // //                   maxLength="100"
// // // //                   value={formData.destAddressLine1 || ''}
// // // //                   onChange={e => handleFormChange('destAddressLine1', e.target.value)}
// // // //                   readOnly
// // // //                 />
// // // //               </div>
// // // //               <div className="EstimateAddressField">
// // // //                 <label>Move Size</label>
// // // //                 <input
// // // //                   type="text"
// // // //                   id="EstimateMoveSize"
// // // //                   placeholder="Enter move size"
// // // //                   value={formData.moveSize || ''}
// // // //                   onChange={e => handleFormChange('moveSize', e.target.value)}
// // // //                   readOnly
// // // //                 />
// // // //               </div>
// // // //             </div>
// // // //           </div>
// // // //         </div>

// // // //         <div className="EstimateTableSection" ref={tableRef}>
// // // //           <table id="EstimateProductsTable">
// // // //             <thead>
// // // //               <tr>
// // // //                 <th scope="col">#</th>
// // // //                 <th scope="col">
// // // //                   PRODUCT/
// // // //                   <br />
// // // //                   SERVICE
// // // //                 </th>
// // // //                 <th scope="col">DESCRIPTION</th>
// // // //                 <th scope="col">
// // // //                   <div className="EstimateHeaderLabel">
// // // //                     <span>RATE</span>
// // // //                     <span className="EstimateCurrency">CA$</span>
// // // //                   </div>
// // // //                 </th>
// // // //                 <th scope="col">QTY</th>
// // // //                 <th scope="col">
// // // //                   <div className="EstimateHeaderLabel">
// // // //                     <span>AMOUNT</span>
// // // //                     <span className="EstimateCurrency">CA$</span>
// // // //                   </div>
// // // //                 </th>
// // // //                 <th scope="col"></th>
// // // //                 <th scope="col"></th>
// // // //               </tr>
// // // //             </thead>
// // // //             <tbody id="EstimateProductsTableBody">
// // // //               {products.map((product, index) => (
// // // //                 <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F9FAFB' }}>
// // // //                   {editingRow === index ? (
// // // //                     <>
// // // //                       <td>{index + 1}</td>
// // // //                       <td>
// // // //                         <div className="EstimateAutocompleteContainer">
// // // //                           <input
// // // //                             type="text"
// // // //                             id={`EstimateProductService-${index}`}
// // // //                             defaultValue={product.productService}
// // // //                             list={`salesValueOptionsForProduct-${index}`}
// // // //                             className="EstimateEditableInput EstimateProductService"
// // // //                             onChange={e => handleProductServiceChange(index, e.target.value)}
// // // //                           />
// // // //                           <datalist id={`salesValueOptionsForProduct-${index}`}>
// // // //                             {salesValueOptions.map(opt => (
// // // //                               <option key={opt.Id} value={opt.Name} />
// // // //                             ))}
// // // //                           </datalist>
// // // //                         </div>
// // // //                       </td>
// // // //                       <td>
// // // //                         <div className="EstimateAutocompleteContainer">
// // // //                           <input
// // // //                             type="text"
// // // //                             id={`EstimateDescription-${index}`}
// // // //                             defaultValue={product.description}
// // // //                             list={`salesValueOptionsForDescription-${index}`}
// // // //                             className="EstimateEditableInput EstimateDescription"
// // // //                           />
// // // //                           <datalist id={`salesValueOptionsForDescription-${index}`}>
// // // //                             {salesValueOptions.map(opt => (
// // // //                               <option key={opt.Id} value={opt.Description} />
// // // //                             ))}
// // // //                           </datalist>
// // // //                         </div>
// // // //                       </td>
// // // //                       <td>
// // // //                         <input
// // // //                           type="number"
// // // //                           id={`EstimateRate-${index}`}
// // // //                           defaultValue={product.rate}
// // // //                           className="EstimateEditableInput EstimateRate"
// // // //                           min="0"
// // // //                           step="0.01"
// // // //                           onChange={() => handleQtyRateChange(index)}
// // // //                         />
// // // //                       </td>
// // // //                       <td>
// // // //                         <input
// // // //                           type="number"
// // // //                           id={`EstimateQty-${index}`}
// // // //                           defaultValue={product.qty}
// // // //                           className="EstimateEditableInput EstimateQty"
// // // //                           min="0"
// // // //                           step="1"
// // // //                           onChange={() => handleQtyRateChange(index)}
// // // //                         />
// // // //                       </td>
// // // //                       <td className="EstimateAmount">{(product.qty * product.rate).toFixed(2)}</td>
// // // //                       <td>
// // // //                         <button className="EstimateDeleteBtn" onClick={() => deleteRow(index)}>
// // // //                           🗑️
// // // //                         </button>
// // // //                       </td>
// // // //                       <td>
// // // //                         <button className="EstimateEditBtn" onClick={() => saveRow(index)}>
// // // //                           ✏️
// // // //                         </button>
// // // //                       </td>
// // // //                     </>
// // // //                   ) : (
// // // //                     <>
// // // //                       <td>{index + 1}</td>
// // // //                       <td>{product.productService || ''}</td>
// // // //                       <td>{product.description || ''}</td>
// // // //                       <td>{parseFloat(product.rate).toFixed(2)}</td>
// // // //                       <td>{product.qty || '0'}</td>
// // // //                       <td className="EstimateAmount">{product.amount}</td>
// // // //                       <td>
// // // //                         <button className="EstimateDeleteBtn" onClick={() => deleteRow(index)}>
// // // //                           🗑️
// // // //                         </button>
// // // //                       </td>
// // // //                       <td>
// // // //                         <button className="EstimateEditBtn" onClick={() => toggleEditMode(index)}>
// // // //                           ✏️
// // // //                         </button>
// // // //                       </td>
// // // //                     </>
// // // //                   )}
// // // //                 </tr>
// // // //               ))}
// // // //             </tbody>
// // // //           </table>
// // // //           <div className="EstimateActionButtons">
// // // //             <button id="EstimateAddLinesBtn" onClick={addNewRow}>
// // // //               Add Lines
// // // //             </button>
// // // //             <button id="EstimateClearLinesBtn" onClick={() => {
// // // //               setProducts([]);
// // // //               setEditingRow(null);
// // // //             }}>
// // // //               Clear All Lines
// // // //             </button>
// // // //             <button id="EstimateSaveBtn" onClick={handleSaveClick}>
// // // //               Save
// // // //             </button>
// // // //           </div>
// // // //         </div>

// // // //         <div className="EstimateTotalsContainer">
// // // //           <div className="EstimateMessageSection">
// // // //             <label htmlFor="EstimateMessage">Email Content</label>
// // // //             <textarea
// // // //               id="EstimateMessage"
// // // //               placeholder="Email message"
// // // //               value={formData.message || ''}
// // // //               onChange={e => handleFormChange('message', e.target.value)}
// // // //             />
// // // //           </div>
// // // //           <div className="EstimateTotalsSection">
// // // //             <div className="EstimateTotalsRow EstimateSubtotalRow">
// // // //               <label>SUBTOTAL</label>
// // // //               <div className="EstimateMiddleSection"></div>
// // // //               <div className="EstimateSpacer"></div>
// // // //               <span className="EstimateValue" id="EstimateSubtotal">
// // // //                 0.00
// // // //               </span>
// // // //             </div>
// // // //             <div className="EstimateTotalsRow EstimateDiscountRow">
// // // //               <label>DISCOUNT</label>
// // // //               <div className="EstimateMiddleSection">
// // // //                 <div className="EstimateDiscountContainer">
// // // //                   <select
// // // //                     id="EstimateDiscountTypeDropdown"
// // // //                     value={formData.discountType || 'percent'}
// // // //                     onChange={e => handleFormChange('discountType', e.target.value)}
// // // //                   >
// // // //                     <option value="percent">%</option>
// // // //                     <option value="value">$</option>
// // // //                   </select>
// // // //                   <div id="EstimateDiscountInputContainer">
// // // //                     <input
// // // //                       type="number"
// // // //                       id="EstimateDiscountInput"
// // // //                       placeholder="0.00"
// // // //                       min="0"
// // // //                       step="0.01"
// // // //                       value={formData.discountInput || '0.00'}
// // // //                       onChange={e => handleFormChange('discountInput', e.target.value)}
// // // //                     />
// // // //                   </div>
// // // //                 </div>
// // // //               </div>
// // // //               <div className="EstimateSpacer"></div>
// // // //               <span className="EstimateValue" id="EstimateDiscountAmount">
// // // //                 0.00
// // // //               </span>
// // // //             </div>
// // // //             <div className="EstimateTotalsRow EstimateTaxRow">
// // // //               <label>TAX</label>
// // // //               <div className="EstimateMiddleSection">
// // // //                 <select
// // // //                   id="EstimateProvinceDropdown"
// // // //                   value={formData.selectedProvince || ''}
// // // //                   onChange={e => handleProvinceChange(e.target.value)}
// // // //                 >
// // // //                   <option value="">Select Province</option>
// // // //                   {provinces.map(province => (
// // // //                     <option key={province.ID} value={province.Province}>
// // // //                       {province.Province} ({province['Tax%'] * 100}%)
// // // //                     </option>
// // // //                   ))}
// // // //                 </select>
// // // //               </div>
// // // //               <div className="EstimateSpacer"></div>
// // // //               <span className="EstimateValue" id="EstimateGstAmount">
// // // //                 0.00
// // // //               </span>
// // // //             </div>
// // // //             <div className="EstimateTotalsRow EstimateEstimateTotal EstimateEstimateTotalRow">
// // // //               <label className="EstimateBold">ESTIMATE TOTAL</label>
// // // //               <div className="EstimateSpacer"></div>
// // // //               <span className="EstimateValue EstimateBold" id="EstimateTotal">
// // // //                 0.00
// // // //               </span>
// // // //             </div>
// // // //             <div className="EstimateTotalsRow EstimateEstimateTotal EstimateEstimateTotalRow">
// // // //               <label className="EstimateBold">Deposit to pay</label>
// // // //               <div className="EstimateSpacer"></div>
// // // //               <span className="EstimateValue EstimateBold">
// // // //                 <input
// // // //                   type="number"
// // // //                   style={{ padding: '5px', border: '1px solid', borderRadius: '2px' }}
// // // //                   id="Deposittopay"
// // // //                   placeholder="Deposit to pay"
// // // //                   value={formData.depositToPay || ''}
// // // //                   onChange={e => handleFormChange('depositToPay', e.target.value)}
// // // //                 />
// // // //               </span>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       </div>

// // // //       {showConfirmOverlay && (
// // // //         <div className="ConfirmOverlay">
// // // //           <div className="ConfirmOverlayContent">
// // // //             {alertMessage.message ? (
// // // //               <>
// // // //                 <h3>{alertMessage.type === 'success' ? 'Success' : 'Error'}</h3>
// // // //                 <p>{alertMessage.message}</p>
// // // //                 <div className="ConfirmOverlayButtons">
// // // //                   <button className="OverlayCloseBtn" onClick={closeOverlay}>
// // // //                     Close
// // // //                   </button>
// // // //                 </div>
// // // //               </>
// // // //             ) : (
// // // //               <>
// // // //                 <h3>{overlayAction === 'send' ? 'Send Estimate' : 'Confirm Booking'}</h3>
// // // //                 <p>
// // // //                   {overlayAction === 'send'
// // // //                     ? 'Are you sure you want to send this estimate? This action will email the estimate to the customer.'
// // // //                     : (
// // // //                       <>
// // // //                         Are you sure you want to confirm this booking? This action will send the invoice for a deposit of 
// // // //                         <strong> ${parseFloat(formData.depositToPay || 0).toFixed(2)}</strong> and update the status to "Booked."
// // // //                       </>
// // // //                     )}
// // // //                 </p>
// // // //                 <div className="ConfirmOverlayButtons">
// // // //                   <button className="OverlayCloseBtn" onClick={closeOverlay}>
// // // //                     Close
// // // //                   </button>
// // // //                   <button
// // // //                     className="OverlayConfirmBtn"
// // // //                     onClick={overlayAction === 'send' ? sendEstimate : confirmBooking}
// // // //                   >
// // // //                     {overlayAction === 'send' ? 'Send' : 'Confirm'}
// // // //                   </button>
// // // //                 </div>
// // // //               </>
// // // //             )}
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {showLoadingOverlay && (
// // // //         <div className="LoadingOverlay">
// // // //           <div className="LoadingOverlayContent">
// // // //             <div className="Spinner"></div>
// // // //             <p>Processing...</p>
// // // //           </div>
// // // //         </div>
// // // //       )}

// // // //       {showEstimateOverlay && (
// // // //         <div className="EstimateOverlay">
// // // //           <div className="EstimateOverlayContent">
// // // //             <button className="OverlayCloseBtn" onClick={closeEstimateOverlay} style={{ position: 'absolute', top: '10px', right: '10px' }}>
// // // //               Close
// // // //             </button>
// // // //             <EstimatePage LeadACVLRecordID={booking.LeadACVLRecordID} accessToken={accessToken} />
// // // //           </div>
// // // //         </div>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // };

// // // // export default Estimate;

// // // // after adding the line items

// // import React, { useEffect, useState, useRef } from 'react';
// // import './Estimate.css';
// // import CryptoJS from 'crypto-js';
// // import EstimatePage from '../EmailEsimate/Emailestimate';

// // const Estimate = ({ accessToken, booking, userDetails, userMap, updateLeadData }) => {
// //   const [isActive, setIsActive] = useState(false);
// //   const [status, setStatus] = useState('Draft');
// //   const [products, setProducts] = useState([]);
// //   const [editingRow, setEditingRow] = useState(null);
// //   const [salesValueOptions, setSalesValueOptions] = useState([]);
// //   const [existingEstimate, setExistingEstimate] = useState(null);
// //   const [formData, setFormData] = useState({});
// //   const [showConfirmOverlay, setShowConfirmOverlay] = useState(false);
// //   const [showLoadingOverlay, setShowLoadingOverlay] = useState(false);
// //   const [provinces, setProvinces] = useState([]);
// //   const [alertMessage, setAlertMessage] = useState({ type: '', message: '' });
// //   const [defaultMessage, setDefaultMessage] = useState('');
// //   const [overlayAction, setOverlayAction] = useState('');
// //   const [showViewEstimate, setShowViewEstimate] = useState(false);
// //   const [showEstimateOverlay, setShowEstimateOverlay] = useState(false);
// //   const tableRef = useRef(null);

// //   const SECRET_KEY = '7f3a1d9e4c6b2f88b0e7a5c9d4f1342b';

// //   useEffect(() => {
// //     const fetchProvinces = async () => {
// //       try {
// //         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/taxvalueid');
// //         if (!response.ok) throw new Error('Error fetching provinces');
// //         const data = await response.json();
// //         setProvinces(data.records || []);
// //       } catch (error) {
// //         console.error('Error fetching provinces:', error);
// //       }
// //     };

// //     const fetchSalesValues = async () => {
// //       try {
// //         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/salesvalueid');
// //         if (!response.ok) throw new Error('Error fetching sales values');
// //         const data = await response.json();
// //         setSalesValueOptions(data.records || []);
// //       } catch (error) {
// //         console.error('Error fetching sales values:', error);
// //       }
// //     };

// //     fetchProvinces();
// //     fetchSalesValues();
// //   }, []);

// //   useEffect(() => {
// //     const fetchEmailTemplate = async () => {
// //       try {
// //         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/emailtemp');
// //         if (!response.ok) throw new Error('Error fetching email template');
// //         const data = await response.json();
// //         if (data.status === 'success' && data.records.length > 0) {
// //           setDefaultMessage(data.records[0].defaultMessage || '');
// //         }
// //       } catch (error) {
// //         console.error('Error fetching email template:', error);
// //         setDefaultMessage(
// //           'Thank you for the opportunity to provide an estimate for your move.'
// //         );
// //       }
// //     };

// //     fetchEmailTemplate();
// //   }, []);

// //   useEffect(() => {
// //     const checkExistingEstimate = async () => {
// //       if (!booking?.LeadACVLRecordID || !accessToken) return;
// //       setShowViewEstimate(false);
// //       if (booking?.Status === 'Estimate sent' || booking?.Status === 'Booked') {
// //         setShowViewEstimate(true);
// //       }
// //       try {
// //         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/esti', {
// //           method: 'GET',
// //           headers: {
// //             'Authorization': `Bearer ${accessToken}`,
// //             'Content-Type': 'application/json',
// //             'LeadACVLRecordID': booking.LeadACVLRecordID,
// //           },
// //         });
// //         if (response.ok) {
// //           const result = await response.json();
// //           if (result.status === 'success' && result.totalRecords > 0) {
// //             setExistingEstimate(result.data[0]);
// //             const itemsString = result.data[0].Items;
// //             let validJsonString = itemsString
// //               .replace(/=/g, ':')
// //               .replace(/([{,])\s*([^{,\s:]+)\s*:/g, '$1"$2":')
// //               .replace(/:\s*([^",}\s][^,}]*)(?=[,}])/g, (match, value) => {
// //                 const trimmedValue = value.trim();
// //                 return /^[0-9.-]+$/.test(trimmedValue) ? `:${trimmedValue}` : `:"${trimmedValue}"`;
// //               });

// //             try {
// //               const parsedItems = JSON.parse(validJsonString).map(item => {
// //                 const matchingOption = salesValueOptions.find(opt => opt.Name === item.desc);
// //                 return {
// //                   productService: item.desc,
// //                   description: matchingOption ? matchingOption.Description : item.desc,
// //                   qty: parseFloat(item.qty) || 0,
// //                   rate: parseFloat(item.rate) || 0,
// //                   amount: parseFloat(item.amount) || 0,
// //                   idValue: matchingOption ? matchingOption.IdValue : '',
// //                 };
// //               });
// //               setProducts(parsedItems);
// //             } catch (parseError) {
// //               console.error('JSON parse error:', parseError);
// //               const manualItems = itemsString.match(/\{[^}]*\}/g)?.map(itemStr => {
// //                 const item = {};
// //                 itemStr.replace(/(\w+)\s*=\s*([^,}]+)/g, (_, key, value) => {
// //                   item[key] = isNaN(value) ? value.trim() : parseFloat(value);
// //                 });
// //                 const matchingOption = salesValueOptions.find(opt => opt.Name === item.desc);
// //                 return {
// //                   productService: item.desc,
// //                   description: matchingOption ? matchingOption.Description : item.desc,
// //                   qty: parseFloat(item.qty) || 0,
// //                   rate: parseFloat(item.rate) || 0,
// //                   amount: parseFloat(item.amount) || 0,
// //                   idValue: matchingOption ? matchingOption.IdValue : '',
// //                 };
// //               }) || [];
// //               setProducts(manualItems);
// //             }
// //           } else {
// //             setExistingEstimate(null);
// //             setProducts([]);
// //           }
// //         } else {
// //           console.error('API request failed:', response.statusText);
// //         }
// //       } catch (error) {
// //         console.error('Error checking existing estimate:', error);
// //       }
// //     };

// //     setProducts([]);
// //     setExistingEstimate(null);
// //     setEditingRow(null);
// //     setStatus('Draft');
// //     checkExistingEstimate();
// //   }, [booking, accessToken, salesValueOptions, userDetails]);

// //   useEffect(() => {
// //     let newFormData;
// //     if (existingEstimate) {
// //       const taxProvince = existingEstimate.Tax || '';
// //       const taxId = taxProvince ? provinces.find(p => p.Province === taxProvince)?.ID : 2;
// //       newFormData = {
// //         customerName: booking.Customer_Name || '',
// //         customerEmail: existingEstimate.Email || '',
// //         originAddressLine1: booking.FromAddress || booking.OriginCity,
// //         originProvince: booking.OriginCity || '',
// //         moveDate: booking.Move_Date || '',
// //         destAddressLine1: booking.ToAddress || booking.DestinationCity,
// //         destProvince: booking.DestinationCity || '',
// //         moveSize: booking.Move_Size || '',
// //         depositToPay: existingEstimate.Deposittopay || '',
// //         discountInput: existingEstimate.Discount || '0.00',
// //         discountType: existingEstimate.DiscountType || 'percent',
// //         message: existingEstimate.message || defaultMessage,
// //         selectedProvince: taxProvince,
// //         provinceId: taxId,
// //       };
// //     } else if (booking) {
// //       newFormData = {
// //         customerName: booking.Customer_Name || '',
// //         customerEmail: booking.Email || '',
// //         originAddressLine1: booking.FromAddress || booking.OriginCity,
// //         moveDate: booking.Move_Date || '',
// //         destAddressLine1: booking.ToAddress || booking.DestinationCity,
// //         moveSize: booking.Move_Size || '',
// //         discountType: 'percent',
// //         discountInput: '0.00',
// //         selectedProvince: '',
// //         provinceId: 2,
// //         depositToPay: '100',
// //         message: defaultMessage,
// //       };
// //     } else {
// //       newFormData = { message: defaultMessage };
// //     }
// //     setFormData(newFormData);
// //     updateTotals();
// //   }, [booking, existingEstimate, defaultMessage, provinces]);

// //   useEffect(() => {
// //     updateTotals();
// //   }, [products, formData]);

// //   useEffect(() => {
// //     const handleClickOutside = (event) => {
// //       if (tableRef.current && !tableRef.current.contains(event.target) && editingRow !== null) {
// //         saveRow(editingRow);
// //       }
// //     };

// //     document.addEventListener('mousedown', handleClickOutside);
// //     return () => {
// //       document.removeEventListener('mousedown', handleClickOutside);
// //     };
// //   }, [editingRow]);

// //   const toTitleCase = str => str?.toLowerCase().replace(/(^|\s)\w/g, letter => letter.toUpperCase()) || '';

// //   const calculateSubtotal = () => products.reduce((sum, product) => sum + (parseFloat(product.amount) || 0), 0);

// //   const calculateDiscount = subtotal => {
// //     const discountType = formData.discountType || 'percent';
// //     const discountValue = parseFloat(formData.discountInput) || 0;
// //     return discountType === 'percent' ? (subtotal * discountValue) / 100 : discountValue;
// //   };

// //   const calculateTax = subtotalAfterDiscount => {
// //     const selectedProvince = provinces.find(p => p.Province === formData.selectedProvince);
// //     const taxPercentage = selectedProvince ? selectedProvince['Tax%'] * 100 : 0;
// //     return (subtotalAfterDiscount * taxPercentage) / 100;
// //   };

// //   const updateTotals = () => {
// //     const subtotal = calculateSubtotal();
// //     const discountAmount = calculateDiscount(subtotal);
// //     const subtotalAfterDiscount = subtotal - discountAmount;
// //     const gstAmount = calculateTax(subtotalAfterDiscount);
// //     const total = subtotalAfterDiscount + gstAmount;
// //     document.getElementById('EstimateSubtotal').textContent = subtotal.toFixed(2);
// //     document.getElementById('EstimateDiscountAmount').textContent = discountAmount.toFixed(2);
// //     document.getElementById('EstimateGstAmount').textContent = gstAmount.toFixed(2);
// //     document.getElementById('EstimateTotal').textContent = total.toFixed(2);
// //   };

// //   const handleFormChange = (field, value) => {
// //     setFormData(prev => ({ ...prev, [field]: value }));
// //   };

// //   const toggleContent = () => setIsActive(prev => !prev);

// //   const handleCancelClick = e => {
// //     e.stopPropagation();
// //     setIsActive(false);
// //   };

// //   const handleProductServiceChange = (index, value) => {
// //     const match = salesValueOptions.find(opt => opt.Name === value);
// //     if (match) {
// //       const descriptionInput = document.getElementById(`EstimateDescription-${index}`);
// //       const rateInput = document.getElementById(`EstimateRate-${index}`);
// //       if (descriptionInput) descriptionInput.value = match.Description;
// //       if (rateInput) rateInput.value = match.UnitPrice;
// //     }
// //   };

// //   const addNewRow = () => {
// //     let updated = [...products]; 
// //     if (editingRow !== null && editingRow < updated.length) {
// //       const result = saveRow(editingRow);
// //       if (!result) return;
// //       updated = result;
// //     }

// //     const newRow = { productService: '', description: '', rate: 0, qty: 0, amount: 0, idValue: '' };
// //     const newProducts = [...updated, newRow];
// //     const newIndex = newProducts.length - 1;

// //     setProducts(newProducts);
// //     setEditingRow(newIndex);

// //     setTimeout(() => {
// //       const input = document.getElementById(`EstimateProductService-${newIndex}`);
// //       if (input) input.focus();

// //       const row = document.querySelector(`#EstimateProductsTableBody tr:nth-child(${newIndex + 1})`);
// //       if (row) row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
// //     }, 100);
// //   };

// //   const deleteRow = index => {
// //     const newProducts = products.filter((_, i) => i !== index);
// //     setProducts(newProducts);
// //     if (editingRow === index) setEditingRow(null);
// //   };

// //   const saveRow = index => {
// //     const qty = parseFloat(document.getElementById(`EstimateQty-${index}`).value) || 0;
// //     const rate = parseFloat(document.getElementById(`EstimateRate-${index}`).value) || 0;
  
// //     if (qty < 0 || rate < 0) {
// //       setAlertMessage({ type: 'error', message: 'Quantity and rate must be non-negative.' });
// //       setShowConfirmOverlay(true);
// //       return null;
// //     }
  
// //     const productService = document.getElementById(`EstimateProductService-${index}`).value;
// //     const description = document.getElementById(`EstimateDescription-${index}`).value;
// //     const amount = (qty * rate).toFixed(2);
  
// //     const matchingOption = salesValueOptions.find(opt => opt.Name === productService);
// //     const idValue = matchingOption ? matchingOption.IdValue : '';
  
// //     const updatedProducts = products.map((p, i) =>
// //       i === index ? { ...p, productService, description: toTitleCase(description), rate, qty, amount, idValue } : p
// //     );
  
// //     setProducts(updatedProducts);
// //     setEditingRow(null);
// //     return updatedProducts;
// //   };
  
// //   const handleQtyRateChange = index => {
// //     const qty = parseFloat(document.getElementById(`EstimateQty-${index}`).value) || 0;
// //     const rate = parseFloat(document.getElementById(`EstimateRate-${index}`).value) || 0;
// //     const amount = (qty * rate).toFixed(2);
// //     const updatedProducts = [...products];
// //     updatedProducts[index] = { ...updatedProducts[index], qty, rate, amount };
// //     setProducts(updatedProducts);
// //   };

// //   const toggleEditMode = index => {
// //     if (editingRow !== null && editingRow !== index) saveRow(editingRow);
// //     setEditingRow(editingRow === index ? null : index);
// //   };

// //   const handleSendConfirm = () => {
// //     setOverlayAction('confirm');
// //     setShowConfirmOverlay(true);
// //     setAlertMessage({ type: '', message: '' });
// //   };

// //   const closeOverlay = () => {
// //     setShowConfirmOverlay(false);
// //     setAlertMessage({ type: '', message: '' });
// //     setOverlayAction('');
// //   };

// //   const handleSaveClick = () => {
// //     if (editingRow !== null) saveRow(editingRow);
// //   };

// //   const handleProvinceChange = provinceName => {
// //     let newProvinceId;
// //     if (!provinceName) {
// //       newProvinceId = 2;
// //     } else {
// //       const selectedProvinceData = provinces.find(p => p.Province === provinceName);
// //       newProvinceId = selectedProvinceData?.ID || 2;
// //     }
// //     setFormData(prev => ({
// //       ...prev,
// //       selectedProvince: provinceName,
// //       provinceId: newProvinceId,
// //       gstDropdown: !provinceName ? '0' : (provinces.find(p => p.Province === provinceName)['Tax%'] * 100).toString(),
// //     }));
// //   };

// //   const handleViewEstimateClick = () => {
// //     if (!booking?.LeadACVLRecordID) {
// //       setAlertMessage({ type: 'error', message: 'Estimate ID is missing.' });
// //       setShowConfirmOverlay(true);
// //       return;
// //     }
// //     setShowEstimateOverlay(true);
// //   };

// //   const closeEstimateOverlay = () => {
// //     setShowEstimateOverlay(false);
// //   };

// //   const handleSendClick = () => {
// //     setOverlayAction('send');
// //     setShowConfirmOverlay(true);
// //     setAlertMessage({ type: '', message: '' });
// //   };

// //   const sendEstimate = async () => {
// //     if (products.length === 0) {
// //       setAlertMessage({ type: 'error', message: 'Please add at least one product/service to the estimate before sending.' });
// //       setShowConfirmOverlay(true);
// //       return;
// //     }

// //     if (editingRow !== null) {
// //       const updated = saveRow(editingRow);
// //       if (!updated) return;
// //     }

// //     setShowConfirmOverlay(false);
// //     setShowLoadingOverlay(true);
// //     setAlertMessage({ type: '', message: '' });

// //     const selectedProvince = provinces.find(p => p.Province === formData.selectedProvince);
// //     const taxField = selectedProvince
// //       ? `${selectedProvince.Province} - ${(selectedProvince['Tax%'] * 100).toFixed(0)}%`
// //       : '0';

// //     let salesAgentName = booking?.Sales_Agent || '';
// //     if (!salesAgentName && userDetails?.userId && userMap) {
// //       salesAgentName = userMap[userDetails.userId] || 'Agent';
// //     }
// //     if (!salesAgentName) {
// //       salesAgentName = 'Agent';
// //     }

// //     const payload1 = {
// //       LeadACVLRecordID: booking.LeadACVLRecordID,
// //       OriginCity: booking.OriginCity,
// //       Customer_Name: formData.customerName,
// //       Deposittopay: formData.depositToPay,
// //       Sales_Agent: salesAgentName,
// //       Email: formData.customerEmail,
// //       message: formData.message,
// //       Move_Size: formData.moveSize,
// //       Move_Date: formData.moveDate,
// //       Estimatetotal: parseFloat(document.getElementById('EstimateTotal').textContent),
// //       DestinationCity: booking.DestinationCity,
// //       FromAddress: `${formData.originAddressLine1}`,
// //       ToAddress: `${formData.destAddressLine1}`,
// //       Items: products.map(product => ({
// //         desc: product.productService,
// //         prod: product.description,
// //         qty: product.qty,
// //         rate: parseFloat(product.rate).toFixed(2),
// //         amount: parseFloat(product.amount).toFixed(2),
// //         idValue: product.idValue || '',
// //         TaxCodeRef: formData.provinceId.toString(),
// //       })),
// //       Subtotal: calculateSubtotal().toFixed(2),
// //       Discount: formData.discountInput,
// //       TAXValue: calculateTax(calculateSubtotal() - calculateDiscount(calculateSubtotal())).toFixed(2),
// //       DiscountType: formData.discountType || ' ',
// //       Tax: formData.selectedProvince || '0',
// //       TaxPercentage: taxField || '0',
// //     };

// //     const payload2 = {
// //       recipientEmail: formData.customerEmail,
// //       subject: 'Estimate #' + booking.LeadACVLRecordID + ' from All Canada Van Lines Inc.',
// //       message: formData.message,
// //       filteredByOriginDestRange: products.map(product => ({
// //         'Estimate Item - Desc': product.productService,
// //         'Estimate Item - pro': product.description,
// //         'Estimate Item - Quantity': product.qty,
// //         'Estimate Item - Rate': parseFloat(product.rate),
// //         'Estimate Item - Amount': parseFloat(product.amount),
// //       })),
// //       subTotal: calculateSubtotal(),
// //       tax: taxField,
// //       Deposittopay: formData.depositToPay,
// //       taxAmount: calculateTax(calculateSubtotal() - calculateDiscount(calculateSubtotal())),
// //       Discount: calculateDiscount(calculateSubtotal()),
// //       finalamount: parseFloat(document.getElementById('EstimateTotal').textContent),
// //       LeadACVLRecordID: booking.LeadACVLRecordID,
// //     };

// //     const payload3 = [
// //       {
// //         ROWID: booking.ROWID,
// //         Status: 'Estimate sent',
// //         Estimate_Amount: parseFloat(document.getElementById('EstimateTotal').textContent),
// //       },    
// //     ];

// //     try {
// //       const response1 = await fetch('https://salesjet-10097049716.catalystappsail.com/esti', {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
// //         body: JSON.stringify(payload1),
// //       });
// //       if (!response1.ok) throw new Error('Failed to send estimate to First API');
// //       console.log('First API Response:', await response1.json());

// //       const response2 = await fetch(
// //         'https://salesjet-841904208.catalystserverless.com/server/email-estimate-function/email-estimate',
// //         {
// //           method: 'POST',
// //           headers: { 'Content-Type': 'application/json' },
// //           body: JSON.stringify(payload2),
// //         }
// //       );

// //       if (!response2.ok) {
// //         let errorMessage = `HTTP error ${response2.status}: ${response2.statusText}`;
// //         try {
// //           const errorData = await response2.json();
// //           errorMessage = errorData.message || errorData.error || errorMessage; 
// //         } catch (jsonError) {
// //           console.warn('Failed to parse error response from Second API:', jsonError);
// //         }
// //         throw new Error(errorMessage); 
// //       }

// //       console.log('Second API Response:', await response2.json());

// //       if (booking.Status !== 'Booked') {
// //         const response3 = await fetch('https://salesjet-10097049716.catalystappsail.com/leadsdata', {
// //           method: 'PUT',
// //           headers: {
// //             'Content-Type': 'application/json',
// //             Authorization: `Bearer ${accessToken}`,
// //           },
// //           body: JSON.stringify(payload3),
// //         });
// //         if (!response3.ok) throw new Error('Failed to update status to "Estimate sent"');
// //         console.log('Status Update Response:', await response3.json());
// //         // addednewly
// //          const updatedBooking = {
// //           LeadACVLRecordID: booking.LeadACVLRecordID,
// //           ROWID: booking.ROWID,
// //           Status: 'Estimate sent',
// //           Estimate_Amount: parseFloat(document.getElementById('EstimateTotal').textContent),
// //         };
// //         console.log('Calling updateLeadData with:', updatedBooking);
// //         updateLeadData(updatedBooking);
// //       } else {
// //         console.log('Booking already marked as "Booked", skipping status update.');
// //       }

// //       setStatus('Sent');
// //       setShowViewEstimate(true);
// //       setAlertMessage({ type: 'success', message: 'Email sent successfully' });
// //     } catch (error) {
// //       console.error('Error sending estimate:', error);
// //       setAlertMessage({ type: 'error', message: `Failed to send estimate: ${error.message}` });
// //     } finally {
// //       setShowLoadingOverlay(false);
// //       setShowConfirmOverlay(true);
// //     }
// //   };

// //   const confirmBooking = async () => {
// //     setShowConfirmOverlay(false);
// //     setShowLoadingOverlay(true);
// //     setAlertMessage({ type: '', message: '' });
// //     const customerEmail = document.getElementById('EstimateCustomerEmail').value;
// //     const customerName = document.getElementById('EstimateCustomerName').value;
// //     const DocNumber = booking.LeadACVLRecordID || 'DocNumber';
// //     const billAddr = {
// //       Line1: document.getElementById('EstimateOriginAddressLine1').value,
// //       Country: 'CA',
// //     };
// //     const shipAddr = {
// //       Line1: document.getElementById('EstimateDestAddressLine1').value,
// //       Country: 'CA',
// //     };
// //     const depositAmount = parseFloat(document.getElementById('Deposittopay').value) || 0;

// //     const selectedProvinceData = provinces.find(p => p.Province === formData.selectedProvince);
// //     const defaultProvinceData = provinces.find(p => p.Province === "Zero-rated");
// //     const taxCodeData = selectedProvinceData || defaultProvinceData;
// //     const taxCodeRef = taxCodeData ? {
// //       value: taxCodeData.ID.toString(),
// //       name: taxCodeData.Province
// //     } : {
// //       value: '2',
// //       name: 'Zero-rated'
// //     };

// //     const lineItems = [];
// //     if (depositAmount > 0) {
// //       lineItems.push({
// //         Id: '1',
// //         LineNum: 1,
// //         Description: 'Deposit Towards Move Booked',
// //         Amount: depositAmount,
// //         DetailType: 'SalesItemLineDetail',
// //         SalesItemLineDetail: {
// //           ItemRef: {
// //             value: '1',
// //             name: 'Services',
// //           },
// //           UnitPrice: depositAmount,
// //           Qty: 1,
// //           ItemAccountRef: {
// //             value: '52',
// //             name: 'Services',
// //           },
// //           TaxCodeRef: taxCodeRef,
// //         },
// //       });
// //     } else {
// //       setAlertMessage({ type: 'error', message: 'Please specify a deposit amount to confirm the booking.' });
// //       setShowLoadingOverlay(false);
// //       setShowConfirmOverlay(true);
// //       return;
// //     }
// //     const payload = {
// //       customerEmail: customerEmail,
// //       DisplayName: customerName,
// //       invoiceData: {
// //         BillEmail: {
// //           Address: customerEmail,
// //         },
// //         DocNumber: DocNumber,
// //         TxnDate: new Date().toISOString().split('T')[0],
// //         DueDate: document.getElementById('EstimateMoveDate').value,
// //         CustomField: [
// //           {
// //             DefinitionId: '1',
// //             Name: 'Sales Agent',
// //             Type: 'StringType',
// //             StringValue: 'Paul1',
// //           },
// //         ],
// //         BillAddr: billAddr,
// //         ShipAddr: shipAddr,
// //         CustomerMemo: {
// //           value: 'Receipt deposit for your upcoming move. This will be applied toward your final invoice.',
// //         },
// //         GlobalTaxCalculation: 'NotApplicable',
// //         Line: lineItems,
// //         Deposit: depositAmount,
// //         DepositToAccountRef: {
// //           value: '5',
// //           name: 'Undeposited Funds',
// //         },
// //       },
// //     };
// //     const payload4 = [
// //       {
// //         ROWID: booking.ROWID,
// //         Status: 'Booked',
// //       },
// //     ];
// //     try {
// //       const response = await fetch(
// //         'https://salesjet-841904208.catalystserverless.com/server/qb_post/handle-invoice',
// //         {
// //           method: 'POST',
// //           headers: {
// //             'Content-Type': 'application/json',
// //           },
// //           body: JSON.stringify(payload),
// //         }
// //       );

// //       if (!response.ok) {
// //         const errorData = await response.json();
// //         console.error('API Error:', errorData);
// //         setAlertMessage({
// //           type: 'error',
// //           message: `Failed to create invoice: ${errorData.Fault?.Error[0]?.Message || 'Unknown error'} (${errorData.Fault?.Error[0]?.Detail || ''})`,
// //         });
// //         throw new Error('Failed to save estimate');
// //       }

// //       const result = await response.json();
// //       console.log('Estimate saved successfully:', result);

// //       const response2 = await fetch('https://salesjet-10097049716.catalystappsail.com/leadsdata', {
// //         method: 'PUT',
// //         headers: {
// //           'Content-Type': 'application/json',
// //           Authorization: `Bearer ${accessToken}`,
// //         },
// //         body: JSON.stringify(payload4),
// //       });
// //       if (!response2.ok) throw new Error('Failed to update status to "Booked"');
// //       console.log('Status Update Response:', await response2.json());

// //       setStatus('Saved');
// //       setShowViewEstimate(true);
// //       setAlertMessage({ type: 'success', message: 'Invoice sent successfully in QB' });
// //     } catch (error) {
// //       console.error('Error saving estimate:', error);
// //       setAlertMessage({ type: 'error', message: 'Failed to Create Invoice in QB. Please try again.' });
// //     } finally {
// //       setShowLoadingOverlay(false);
// //       setShowConfirmOverlay(true);
// //     }
// //   };

// //   // Function to generate and copy customer link

// //   const handleCopyCustomerLink = () => {
// //     if (!booking?.LeadACVLRecordID) {
// //       setAlertMessage({ type: 'error', message: 'Estimate ID is missing.' });
// //       setShowConfirmOverlay(true);
// //       return;
// //     }

// //     const encryptedId = CryptoJS.AES.encrypt(booking.LeadACVLRecordID.toString(), SECRET_KEY).toString();
// //     const encodedEncryptedId = encodeURIComponent(encryptedId);
// //     const customerLink = `https://salesjet.allcanadavanlines.com/server/estimate_view/?${encodedEncryptedId}`;

// //     navigator.clipboard.writeText(customerLink).then(() => {
// //       setAlertMessage({ type: 'success', message: 'Customer link copied to clipboard!' });
// //       setShowConfirmOverlay(true);
// //     }).catch(err => {
// //       setAlertMessage({ type: 'error', message: 'Failed to copy link to clipboard.' });
// //       setShowConfirmOverlay(true);
// //       console.error('Clipboard error:', err);
// //     });
// //   };

// //   return (
// //     <div>
// //       <div className={`EstimateHeader ${isActive ? 'EstimateActive' : ''}`} onClick={toggleContent}>
// //         <div className="EstimateLeftSection">
// //           <h2>ESTIMATE</h2>
// //           <span className="EstimateLeftSection" style={{ background: 'white', padding: '5px', borderRadius: '10px' }}>
// //             {booking.Status}
// //           </span>
// //           {showViewEstimate && (
// //             <>
// //               <button
// //                 className="EstimateViewBtn"
// //                 onClick={handleViewEstimateClick}
// //               >
// //                 View Estimate
// //               </button>
// //               <button
// //                 className="EstimateViewBtn"
// //                 onClick={handleCopyCustomerLink}
// //                 style={{ marginLeft: '10px' }}
// //               >
// //                 Customer Link
// //               </button>
// //             </>
// //           )}
// //         </div>
// //         <div className="EstimateRightButtons">
// //           <button className="EstimateCancelBtn" onClick={handleCancelClick}>
// //             Cancel
// //           </button>
// //           <button className="EstimateSendBtn" onClick={handleSendClick}>
// //             Send
// //           </button>
// //         </div>
// //       </div>     
// //       <div className={`EstimateContent ${isActive ? 'EstimateVisible' : ''}`}>
// //         <div className="EstimateCustomerSection">
// //           <div className="EstimateCustomerField">
// //             <label htmlFor="EstimateCustomerName">Customer</label>
// //             <input
// //               type="text"
// //               id="EstimateCustomerName"
// //               placeholder="Enter customer name"
// //               value={formData.customerName || ''}
// //               readOnly
// //               onChange={e => handleFormChange('customerName', e.target.value)}
// //             />
// //           </div>
// //           <div className="EstimateEmailField">
// //             <label htmlFor="EstimateCustomerEmail">Email</label>
// //             <input
// //               type="text"
// //               id="EstimateCustomerEmail"
// //               placeholder="Email (separate emails...)"
// //               value={formData.customerEmail || ''}
// //               onChange={e => handleFormChange('customerEmail', e.target.value)}
// //             />
// //           </div>
// //         </div>

// //         <div className="EstimateAddressSection">
// //           <div className="EstimateAddressesContainer">
// //             <div>
// //               <label>Origin Address</label>
// //               <div className="EstimateAddressField">
// //                 <input
// //                   type="text"
// //                   id="EstimateOriginAddressLine1"
// //                   placeholder="Enter the Origin Address Line 1"
// //                   maxLength="100"
// //                   value={formData.originAddressLine1 || ''}
// //                   onChange={e => handleFormChange('originAddressLine1', e.target.value)}
// //                   readOnly
// //                 />
// //               </div>
// //               <div className="EstimateAddressFieldDate">
// //                 <label>Move Date</label>
// //                 <input
// //                   type="date"
// //                   id="EstimateMoveDate"
// //                   value={formData.moveDate || ''}
// //                   onChange={e => handleFormChange('moveDate', e.target.value)}
// //                   readOnly
// //                 />
// //               </div>
// //             </div>
// //             <div>
// //               <label>Destination Address</label>
// //               <div className="EstimateAddressField">
// //                 <input
// //                   type="text"
// //                   id="EstimateDestAddressLine1"
// //                   placeholder="Enter the Destination Address Line 1"
// //                   maxLength="100"
// //                   value={formData.destAddressLine1 || ''}
// //                   onChange={e => handleFormChange('destAddressLine1', e.target.value)}
// //                   readOnly
// //                 />
// //               </div>
// //               <div className="EstimateAddressField">
// //                 <label>Move Size</label>
// //                 <input
// //                   type="text"
// //                   id="EstimateMoveSize"
// //                   placeholder="Enter move size"
// //                   value={formData.moveSize || ''}
// //                   onChange={e => handleFormChange('moveSize', e.target.value)}
// //                   readOnly
// //                 />
// //               </div>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="EstimateTableSection" ref={tableRef}>
// //           <table id="EstimateProductsTable">
// //             <thead>
// //               <tr>
// //                 <th scope="col">#</th>
// //                 <th scope="col">
// //                   PRODUCT/
// //                   <br />
// //                   SERVICE
// //                 </th>
// //                 <th scope="col">DESCRIPTION</th>
// //                 <th scope="col">
// //                   <div className="EstimateHeaderLabel">
// //                     <span>RATE</span>
// //                     <span className="EstimateCurrency">CA$</span>
// //                   </div>
// //                 </th>
// //                 <th scope="col">QTY</th>
// //                 <th scope="col">
// //                   <div className="EstimateHeaderLabel">
// //                     <span>AMOUNT</span>
// //                     <span className="EstimateCurrency">CA$</span>
// //                   </div>
// //                 </th>
// //                 <th scope="col"></th>
// //                 <th scope="col"></th>
// //               </tr>
// //             </thead>
// //             <tbody id="EstimateProductsTableBody">
// //               {products.map((product, index) => (
// //                 <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F9FAFB' }}>
// //                   {editingRow === index ? (
// //                     <>
// //                       <td>{index + 1}</td>
// //                       <td>
// //                         <div className="EstimateAutocompleteContainer">
// //                           <input
// //                             type="text"
// //                             id={`EstimateProductService-${index}`}
// //                             defaultValue={product.productService}
// //                             list={`salesValueOptionsForProduct-${index}`}
// //                             className="EstimateEditableInput EstimateProductService"
// //                             onChange={e => handleProductServiceChange(index, e.target.value)}
// //                           />
// //                           <datalist id={`salesValueOptionsForProduct-${index}`}>
// //                             {salesValueOptions.map(opt => (
// //                               <option key={opt.IdValue} value={opt.Name} />
// //                             ))}
// //                           </datalist>
// //                         </div>
// //                       </td>
// //                       <td>
// //                         <div className="EstimateAutocompleteContainer">
// //                           <input
// //                             type="text"
// //                             id={`EstimateDescription-${index}`}
// //                             defaultValue={product.description}
// //                             list={`salesValueOptionsForDescription-${index}`}
// //                             className="EstimateEditableInput EstimateDescription"
// //                           />
// //                           <datalist id={`salesValueOptionsForDescription-${index}`}>
// //                             {salesValueOptions.map(opt => (
// //                               <option key={opt.IdValue} value={opt.Description} />
// //                             ))}
// //                           </datalist>
// //                         </div>
// //                       </td>
// //                       <td>
// //                         <input
// //                           type="number"
// //                           id={`EstimateRate-${index}`}
// //                           defaultValue={product.rate}
// //                           className="EstimateEditableInput EstimateRate"
// //                           min="0"
// //                           step="0.01"
// //                           onChange={() => handleQtyRateChange(index)}
// //                         />
// //                       </td>
// //                       <td>
// //                         <input
// //                           type="number"
// //                           id={`EstimateQty-${index}`}
// //                           defaultValue={product.qty}
// //                           className="EstimateEditableInput EstimateQty"
// //                           min="0"
// //                           step="1"
// //                           onChange={() => handleQtyRateChange(index)}
// //                         />
// //                       </td>
// //                       <td className="EstimateAmount">{(product.qty * product.rate).toFixed(2)}</td>
// //                       <td>
// //                         <button className="EstimateDeleteBtn" onClick={() => deleteRow(index)}>
// //                           🗑️
// //                         </button>
// //                       </td>
// //                       <td>
// //                         <button className="EstimateEditBtn" onClick={() => saveRow(index)}>
// //                           ✏️
// //                         </button>
// //                       </td>
// //                     </>
// //                   ) : (
// //                     <>
// //                       <td>{index + 1}</td>
// //                       <td>{product.productService || ''}</td>
// //                       <td>{product.description || ''}</td>
// //                       <td>{parseFloat(product.rate).toFixed(2)}</td>
// //                       <td>{product.qty || '0'}</td>
// //                       <td className="EstimateAmount">{product.amount}</td>
// //                       <td>
// //                         <button className="EstimateDeleteBtn" onClick={() => deleteRow(index)}>
// //                           🗑️
// //                         </button>
// //                       </td>
// //                       <td>
// //                         <button className="EstimateEditBtn" onClick={() => toggleEditMode(index)}>
// //                           ✏️
// //                         </button>
// //                       </td>
// //                     </>
// //                   )}
// //                 </tr>
// //               ))}
// //             </tbody>
// //           </table>
// //           <div className="EstimateActionButtons">
// //             <button id="EstimateAddLinesBtn" onClick={addNewRow}>
// //               Add Lines
// //             </button>
// //             <button id="EstimateClearLinesBtn" onClick={() => {
// //               setProducts([]);
// //               setEditingRow(null);
// //             }}>
// //               Clear All Lines
// //             </button>
// //             <button id="EstimateSaveBtn" onClick={handleSaveClick}>
// //               Save
// //             </button>
// //           </div>
// //         </div>

// //         <div className="EstimateTotalsContainer">
// //           <div className="EstimateMessageSection">
// //             <label htmlFor="EstimateMessage">Email Content</label>
// //             <textarea
// //               id="EstimateMessage"
// //               placeholder="Email message"
// //               value={formData.message || ''}
// //               onChange={e => handleFormChange('message', e.target.value)}
// //             />
// //           </div>
// //           <div className="EstimateTotalsSection">
// //             <div className="EstimateTotalsRow EstimateSubtotalRow">
// //               <label>SUBTOTAL</label>
// //               <div className="EstimateMiddleSection"></div>
// //               <div className="EstimateSpacer"></div>
// //               <span className="EstimateValue" id="EstimateSubtotal">
// //                 0.00
// //               </span>
// //             </div>
// //             <div className="EstimateTotalsRow EstimateDiscountRow">
// //               <label>DISCOUNT</label>
// //               <div className="EstimateMiddleSection">
// //                 <div className="EstimateDiscountContainer">
// //                   <select
// //                     id="EstimateDiscountTypeDropdown"
// //                     value={formData.discountType || 'percent'}
// //                     onChange={e => handleFormChange('discountType', e.target.value)}
// //                   >
// //                     <option value="percent">%</option>
// //                     <option value="value">$</option>
// //                   </select>
// //                   <div id="EstimateDiscountInputContainer">
// //                     <input
// //                       type="number"
// //                       id="EstimateDiscountInput"
// //                       placeholder="0.00"
// //                       min="0"
// //                       step="0.01"
// //                       value={formData.discountInput || '0.00'}
// //                       onChange={e => handleFormChange('discountInput', e.target.value)}
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //               <div className="EstimateSpacer"></div>
// //               <span className="EstimateValue" id="EstimateDiscountAmount">
// //                 0.00
// //               </span>
// //             </div>
// //             <div className="EstimateTotalsRow EstimateTaxRow">
// //               <label>TAX</label>
// //               <div className="EstimateMiddleSection">
// //                 <select
// //                   id="EstimateProvinceDropdown"
// //                   value={formData.selectedProvince || ''}
// //                   onChange={e => handleProvinceChange(e.target.value)}
// //                 >
// //                   <option value="">Select Province</option>
// //                   {provinces.map(province => (
// //                     <option key={province.ID} value={province.Province}>
// //                       {province.Province} ({province['Tax%'] * 100}%)
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div>
// //               <div className="EstimateSpacer"></div>
// //               <span className="EstimateValue" id="EstimateGstAmount">
// //                 0.00
// //               </span>
// //             </div>
// //             <div className="EstimateTotalsRow EstimateEstimateTotal EstimateEstimateTotalRow">
// //               <label className="EstimateBold">ESTIMATE TOTAL</label>
// //               <div className="EstimateSpacer"></div>
// //               <span className="EstimateValue EstimateBold" id="EstimateTotal">
// //                 0.00
// //               </span>
// //             </div>
// //             <div className="EstimateTotalsRow EstimateEstimateTotal EstimateEstimateTotalRow">
// //               <label className="EstimateBold">Deposit to pay</label>
// //               <div className="EstimateSpacer"></div>
// //               <span className="EstimateValue EstimateBold">
// //                 <input
// //                   type="number"
// //                   style={{ padding: '5px', border: '1px solid', borderRadius: '2px' }}
// //                   id="Deposittopay"
// //                   placeholder="Deposit to pay"
// //                   value={formData.depositToPay || ''}
// //                   onChange={e => handleFormChange('depositToPay', e.target.value)}
// //                 />
// //               </span>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       {showConfirmOverlay && (
// //         <div className="ConfirmOverlay">
// //           <div className="ConfirmOverlayContent">
// //             {alertMessage.message ? (
// //               <>
// //                 <h3>{alertMessage.type === 'success' ? 'Success' : 'Error'}</h3>
// //                 <p>{alertMessage.message}</p>
// //                 <div className="ConfirmOverlayButtons">
// //                   <button className="OverlayCloseBtn" onClick={closeOverlay}>
// //                     Close
// //                   </button>
// //                 </div>
// //               </>
// //             ) : (
// //               <>
// //                 <h3>{overlayAction === 'send' ? 'Send Estimate' : 'Confirm Booking'}</h3>
// //                 <p>
// //                   {overlayAction === 'send'
// //                     ? 'Are you sure you want to send this estimate? This action will email the estimate to the customer.'
// //                     : (
// //                       <>
// //                         Are you sure you want to confirm this booking? This action will send the invoice for a deposit of 
// //                         <strong> ${parseFloat(formData.depositToPay || 0).toFixed(2)}</strong> and update the status to "Booked."
// //                       </>
// //                     )}
// //                 </p>
// //                 <div className="ConfirmOverlayButtons">
// //                   <button className="OverlayCloseBtn" onClick={closeOverlay}>
// //                     Close
// //                   </button>
// //                   <button
// //                     className="OverlayConfirmBtn"
// //                     onClick={overlayAction === 'send' ? sendEstimate : confirmBooking}
// //                   >
// //                     {overlayAction === 'send' ? 'Send' : 'Confirm'}
// //                   </button>
// //                 </div>
// //               </>
// //             )}
// //           </div>
// //         </div>
// //       )}

// //       {showLoadingOverlay && (
// //         <div className="LoadingOverlay">
// //           <div className="LoadingOverlayContent">
// //             <div className="Spinner"></div>
// //             <p>Processing...</p>
// //           </div>
// //         </div>
// //       )}

// //       {showEstimateOverlay && (
// //         <div className="EstimateOverlay">
// //           <div className="EstimateOverlayContent">
// //             <button className="OverlayCloseBtn" onClick={closeEstimateOverlay} style={{ position: 'absolute', top: '10px', right: '10px' }}>
// //               Close
// //             </button>
// //             <EstimatePage LeadACVLRecordID={booking.LeadACVLRecordID} accessToken={accessToken} />
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default Estimate;

// // after the change in the view estimate
// import React, { useEffect, useState, useRef } from 'react';
// import './Estimate.css';
// import CryptoJS from 'crypto-js';

// const Estimate = ({ accessToken, booking, userDetails, userMap, updateLeadData }) => {
//   const [isActive, setIsActive] = useState(false);
//   const [status, setStatus] = useState('Draft');
//   const [products, setProducts] = useState([]);
//   const [editingRow, setEditingRow] = useState(null);
//   const [salesValueOptions, setSalesValueOptions] = useState([]);
//   const [existingEstimate, setExistingEstimate] = useState(null);
//   const [formData, setFormData] = useState({});
//   const [showConfirmOverlay, setShowConfirmOverlay] = useState(false);
//   const [showLoadingOverlay, setShowLoadingOverlay] = useState(false);
//   const [provinces, setProvinces] = useState([]);
//   const [alertMessage, setAlertMessage] = useState({ type: '', message: '' });
//   const [defaultMessage, setDefaultMessage] = useState('');
//   const [overlayAction, setOverlayAction] = useState('');
//   const [showViewEstimate, setShowViewEstimate] = useState(false);
//   const [showEstimateOverlay, setShowEstimateOverlay] = useState(false);
//   const tableRef = useRef(null);

//   const SECRET_KEY = '7f3a1d9e4c6b2f88b0e7a5c9d4f1342b';

//   useEffect(() => {
//     const fetchProvinces = async () => {
//       try {
//         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/taxvalueid');
//         if (!response.ok) throw new Error('Error fetching provinces');
//         const data = await response.json();
//         setProvinces(data.records || []);
//       } catch (error) {
//         console.error('Error fetching provinces:', error);
//       }
//     };

//     const fetchSalesValues = async () => {
//       try {
//         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/salesvalueid');
//         if (!response.ok) throw new Error('Error fetching sales values');
//         const data = await response.json();
//         setSalesValueOptions(data.records || []);
//       } catch (error) {
//         console.error('Error fetching sales values:', error);
//       }
//     };

//     fetchProvinces();
//     fetchSalesValues();
//   }, []);

//   useEffect(() => {
//     const fetchEmailTemplate = async () => {
//       try {
//         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/emailtemp');
//         if (!response.ok) throw new Error('Error fetching email template');
//         const data = await response.json();
//         if (data.status === 'success' && data.records.length > 0) {
//           setDefaultMessage(data.records[0].defaultMessage || '');
//         }
//       } catch (error) {
//         console.error('Error fetching email template:', error);
//         setDefaultMessage(
//           'Thank you for the opportunity to provide an estimate for your move.'
//         );
//       }
//     };

//     fetchEmailTemplate();
//   }, []);

//   useEffect(() => {
//     const checkExistingEstimate = async () => {
//       if (!booking?.LeadACVLRecordID || !accessToken) return;
//       setShowViewEstimate(false);
//       if (booking?.Status === 'Estimate sent' || booking?.Status === 'Booked') {
//         setShowViewEstimate(true);
//       }
//       try {
//         const response = await fetch('https://salesjet-10097049716.catalystappsail.com/esti', {
//           method: 'GET',
//           headers: {
//             'Authorization': `Bearer ${accessToken}`,
//             'Content-Type': 'application/json',
//             'LeadACVLRecordID': booking.LeadACVLRecordID,
//           },
//         });
//         if (response.ok) {
//           const result = await response.json();
//           if (result.status === 'success' && result.totalRecords > 0) {
//             setExistingEstimate(result.data[0]);
//             const itemsString = result.data[0].Items;
//             let validJsonString = itemsString
//               .replace(/=/g, ':')
//               .replace(/([{,])\s*([^{,\s:]+)\s*:/g, '$1"$2":')
//               .replace(/:\s*([^",}\s][^,}]*)(?=[,}])/g, (match, value) => {
//                 const trimmedValue = value.trim();
//                 return /^[0-9.-]+$/.test(trimmedValue) ? `:${trimmedValue}` : `:"${trimmedValue}"`;
//               });

//             try {
//               const parsedItems = JSON.parse(validJsonString).map(item => {
//                 const matchingOption = salesValueOptions.find(opt => opt.Name === item.desc);
//                 return {
//                   productService: item.desc,
//                   description: matchingOption ? matchingOption.Description : item.desc,
//                   qty: parseFloat(item.qty) || 0,
//                   rate: parseFloat(item.rate) || 0,
//                   amount: parseFloat(item.amount) || 0,
//                   idValue: matchingOption ? matchingOption.IdValue : '',
//                 };
//               });
//               setProducts(parsedItems);
//             } catch (parseError) {
//               console.error('JSON parse error:', parseError);
//               const manualItems = itemsString.match(/\{[^}]*\}/g)?.map(itemStr => {
//                 const item = {};
//                 itemStr.replace(/(\w+)\s*=\s*([^,}]+)/g, (_, key, value) => {
//                   item[key] = isNaN(value) ? value.trim() : parseFloat(value);
//                 });
//                 const matchingOption = salesValueOptions.find(opt => opt.Name === item.desc);
//                 return {
//                   productService: item.desc,
//                   description: matchingOption ? matchingOption.Description : item.desc,
//                   qty: parseFloat(item.qty) || 0,
//                   rate: parseFloat(item.rate) || 0,
//                   amount: parseFloat(item.amount) || 0,
//                   idValue: matchingOption ? matchingOption.IdValue : '',
//                 };
//               }) || [];
//               setProducts(manualItems);
//             }
//           } else {
//             setExistingEstimate(null);
//             setProducts([]);
//           }
//         } else {
//           console.error('API request failed:', response.statusText);
//         }
//       } catch (error) {
//         console.error('Error checking existing estimate:', error);
//       }
//     };

//     setProducts([]);
//     setExistingEstimate(null);
//     setEditingRow(null);
//     setStatus('Draft');
//     checkExistingEstimate();
//   }, [booking, accessToken, salesValueOptions, userDetails]);

//   useEffect(() => {
//     let newFormData;
//     if (existingEstimate) {
//       const taxProvince = existingEstimate.Tax || '';
//       const taxId = taxProvince ? provinces.find(p => p.Province === taxProvince)?.ID : 2;
//       newFormData = {
//         customerName: booking.Customer_Name || '',
//         customerEmail: existingEstimate.Email || '',
//         originAddressLine1: booking.FromAddress || booking.OriginCity,
//         originProvince: booking.OriginCity || '',
//         moveDate: booking.Move_Date || '',
//         destAddressLine1: booking.ToAddress || booking.DestinationCity,
//         destProvince: booking.DestinationCity || '',
//         moveSize: booking.Move_Size || '',
//         depositToPay: existingEstimate.Deposittopay || '',
//         discountInput: existingEstimate.Discount || '0.00',
//         discountType: existingEstimate.DiscountType || 'percent',
//         message: existingEstimate.message || defaultMessage,
//         selectedProvince: taxProvince,
//         provinceId: taxId,
//       };
//     } else if (booking) {
//       newFormData = {
//         customerName: booking.Customer_Name || '',
//         customerEmail: booking.Email || '',
//         originAddressLine1: booking.FromAddress || booking.OriginCity,
//         moveDate: booking.Move_Date || '',
//         destAddressLine1: booking.ToAddress || booking.DestinationCity,
//         moveSize: booking.Move_Size || '',
//         discountType: 'percent',
//         discountInput: '0.00',
//         selectedProvince: '',
//         provinceId: 2,
//         depositToPay: '100',
//         message: defaultMessage,
//       };
//     } else {
//       newFormData = { message: defaultMessage };
//     }
//     setFormData(newFormData);
//     updateTotals();
//   }, [booking, existingEstimate, defaultMessage, provinces]);

//   useEffect(() => {
//     updateTotals();
//   }, [products, formData]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (tableRef.current && !tableRef.current.contains(event.target) && editingRow !== null) {
//         saveRow(editingRow);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [editingRow]);

//   const toTitleCase = str => str?.toLowerCase().replace(/(^|\s)\w/g, letter => letter.toUpperCase()) || '';

//   const calculateSubtotal = () => products.reduce((sum, product) => sum + (parseFloat(product.amount) || 0), 0);

//   const calculateDiscount = subtotal => {
//     const discountType = formData.discountType || 'percent';
//     const discountValue = parseFloat(formData.discountInput) || 0;
//     return discountType === 'percent' ? (subtotal * discountValue) / 100 : discountValue;
//   };

//   const calculateTax = subtotalAfterDiscount => {
//     const selectedProvince = provinces.find(p => p.Province === formData.selectedProvince);
//     const taxPercentage = selectedProvince ? selectedProvince['Tax%'] * 100 : 0;
//     return (subtotalAfterDiscount * taxPercentage) / 100;
//   };

//   const updateTotals = () => {
//     const subtotal = calculateSubtotal();
//     const discountAmount = calculateDiscount(subtotal);
//     const subtotalAfterDiscount = subtotal - discountAmount;
//     const gstAmount = calculateTax(subtotalAfterDiscount);
//     const total = subtotalAfterDiscount + gstAmount;
//     document.getElementById('EstimateSubtotal').textContent = subtotal.toFixed(2);
//     document.getElementById('EstimateDiscountAmount').textContent = discountAmount.toFixed(2);
//     document.getElementById('EstimateGstAmount').textContent = gstAmount.toFixed(2);
//     document.getElementById('EstimateTotal').textContent = total.toFixed(2);
//   };

//   const handleFormChange = (field, value) => {
//     setFormData(prev => ({ ...prev, [field]: value }));
//   };

//   const toggleContent = () => setIsActive(prev => !prev);

//   const handleCancelClick = e => {
//     e.stopPropagation();
//     setIsActive(false);
//   };

//   const handleProductServiceChange = (index, value) => {
//     const match = salesValueOptions.find(opt => opt.Name === value);
//     if (match) {
//       const descriptionInput = document.getElementById(`EstimateDescription-${index}`);
//       const rateInput = document.getElementById(`EstimateRate-${index}`);
//       if (descriptionInput) descriptionInput.value = match.Description;
//       if (rateInput) rateInput.value = match.UnitPrice;
//     }
//   };

//   const addNewRow = () => {
//     let updated = [...products]; 
//     if (editingRow !== null && editingRow < updated.length) {
//       const result = saveRow(editingRow);
//       if (!result) return;
//       updated = result;
//     }

//     const newRow = { productService: '', description: '', rate: 0, qty: 0, amount: 0, idValue: '' };
//     const newProducts = [...updated, newRow];
//     const newIndex = newProducts.length - 1;

//     setProducts(newProducts);
//     setEditingRow(newIndex);

//     setTimeout(() => {
//       const input = document.getElementById(`EstimateProductService-${newIndex}`);
//       if (input) input.focus();

//       const row = document.querySelector(`#EstimateProductsTableBody tr:nth-child(${newIndex + 1})`);
//       if (row) row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
//     }, 100);
//   };

//   const deleteRow = index => {
//     const newProducts = products.filter((_, i) => i !== index);
//     setProducts(newProducts);
//     if (editingRow === index) setEditingRow(null);
//   };

//   const saveRow = index => {
//     const qty = parseFloat(document.getElementById(`EstimateQty-${index}`).value) || 0;
//     const rate = parseFloat(document.getElementById(`EstimateRate-${index}`).value) || 0;
  
//     if (qty < 0 || rate < 0) {
//       setAlertMessage({ type: 'error', message: 'Quantity and rate must be non-negative.' });
//       setShowConfirmOverlay(true);
//       return null;
//     }
  
//     const productService = document.getElementById(`EstimateProductService-${index}`).value;
//     const description = document.getElementById(`EstimateDescription-${index}`).value;
//     const amount = (qty * rate).toFixed(2);
  
//     const matchingOption = salesValueOptions.find(opt => opt.Name === productService);
//     const idValue = matchingOption ? matchingOption.IdValue : '';
  
//     const updatedProducts = products.map((p, i) =>
//       i === index ? { ...p, productService, description: toTitleCase(description), rate, qty, amount, idValue } : p
//     );
  
//     setProducts(updatedProducts);
//     setEditingRow(null);
//     return updatedProducts;
//   };
  
//   const handleQtyRateChange = index => {
//     const qty = parseFloat(document.getElementById(`EstimateQty-${index}`).value) || 0;
//     const rate = parseFloat(document.getElementById(`EstimateRate-${index}`).value) || 0;
//     const amount = (qty * rate).toFixed(2);
//     const updatedProducts = [...products];
//     updatedProducts[index] = { ...updatedProducts[index], qty, rate, amount };
//     setProducts(updatedProducts);
//   };

//   const toggleEditMode = index => {
//     if (editingRow !== null && editingRow !== index) saveRow(editingRow);
//     setEditingRow(editingRow === index ? null : index);
//   };

//   const handleSendConfirm = () => {
//     setOverlayAction('confirm');
//     setShowConfirmOverlay(true);
//     setAlertMessage({ type: '', message: '' });
//   };

//   const closeOverlay = () => {
//     setShowConfirmOverlay(false);
//     setAlertMessage({ type: '', message: '' });
//     setOverlayAction('');
//   };

//   const handleSaveClick = () => {
//     if (editingRow !== null) saveRow(editingRow);
//   };

//   const handleProvinceChange = provinceName => {
//     let newProvinceId;
//     if (!provinceName) {
//       newProvinceId = 2;
//     } else {
//       const selectedProvinceData = provinces.find(p => p.Province === provinceName);
//       newProvinceId = selectedProvinceData?.ID || 2;
//     }
//     setFormData(prev => ({
//       ...prev,
//       selectedProvince: provinceName,
//       provinceId: newProvinceId,
//       gstDropdown: !provinceName ? '0' : (provinces.find(p => p.Province === provinceName)['Tax%'] * 100).toString(),
//     }));
//   };

//   const handleViewEstimateClick = () => {
//     if (!booking?.LeadACVLRecordID) {
//       setAlertMessage({ type: 'error', message: 'Estimate ID is missing.' });
//       setShowConfirmOverlay(true);
//       return;
//     }
//     setShowEstimateOverlay(true);
//   };

//   const closeEstimateOverlay = () => {
//     setShowEstimateOverlay(false);
//   };

//   const handleSendClick = () => {
//     setOverlayAction('send');
//     setShowConfirmOverlay(true);
//     setAlertMessage({ type: '', message: '' });
//   };

//   const sendEstimate = async () => {
//     if (products.length === 0) {
//       setAlertMessage({ type: 'error', message: 'Please add at least one product/service to the estimate before sending.' });
//       setShowConfirmOverlay(true);
//       return;
//     }

//     if (editingRow !== null) {
//       const updated = saveRow(editingRow);
//       if (!updated) return;
//     }

//     setShowConfirmOverlay(false);
//     setShowLoadingOverlay(true);
//     setAlertMessage({ type: '', message: '' });

//     const selectedProvince = provinces.find(p => p.Province === formData.selectedProvince);
//     const taxField = selectedProvince
//       ? `${selectedProvince.Province} - ${(selectedProvince['Tax%'] * 100).toFixed(0)}%`
//       : '0';

//     let salesAgentName = booking?.Sales_Agent || '';
//     if (!salesAgentName && userDetails?.userId && userMap) {
//       salesAgentName = userMap[userDetails.userId] || 'Agent';
//     }
//     if (!salesAgentName) {
//       salesAgentName = 'Agent';
//     }

//     const payload1 = {
//       LeadACVLRecordID: booking.LeadACVLRecordID,
//       OriginCity: booking.OriginCity,
//       Customer_Name: formData.customerName,
//       Deposittopay: formData.depositToPay,
//       Sales_Agent: salesAgentName,
//       Email: formData.customerEmail,
//       message: formData.message,
//       Move_Size: formData.moveSize,
//       Move_Date: formData.moveDate,
//       Estimatetotal: parseFloat(document.getElementById('EstimateTotal').textContent),
//       DestinationCity: booking.DestinationCity,
//       FromAddress: `${formData.originAddressLine1}`,
//       ToAddress: `${formData.destAddressLine1}`,
//       Items: products.map(product => ({
//         desc: product.productService,
//         prod: product.description,
//         qty: product.qty,
//         rate: parseFloat(product.rate).toFixed(2),
//         amount: parseFloat(product.amount).toFixed(2),
//         idValue: product.idValue || '',
//         TaxCodeRef: formData.provinceId.toString(),
//       })),
//       Subtotal: calculateSubtotal().toFixed(2),
//       Discount: formData.discountInput,
//       TAXValue: calculateTax(calculateSubtotal() - calculateDiscount(calculateSubtotal())).toFixed(2),
//       DiscountType: formData.discountType || ' ',
//       Tax: formData.selectedProvince || '0',
//       TaxPercentage: taxField || '0',
//     };

//     const payload2 = {
//       recipientEmail: formData.customerEmail,
//       subject: 'Estimate #' + booking.LeadACVLRecordID + ' from All Canada Van Lines Inc.',
//       message: formData.message,
//       filteredByOriginDestRange: products.map(product => ({
//         'Estimate Item - Desc': product.productService,
//         'Estimate Item - pro': product.description,
//         'Estimate Item - Quantity': product.qty,
//         'Estimate Item - Rate': parseFloat(product.rate),
//         'Estimate Item - Amount': parseFloat(product.amount),
//       })),
//       subTotal: calculateSubtotal(),
//       tax: taxField,
//       Deposittopay: formData.depositToPay,
//       taxAmount: calculateTax(calculateSubtotal() - calculateDiscount(calculateSubtotal())),
//       Discount: calculateDiscount(calculateSubtotal()),
//       finalamount: parseFloat(document.getElementById('EstimateTotal').textContent),
//       LeadACVLRecordID: booking.LeadACVLRecordID,
//     };

//     const payload3 = [
//       {
//         ROWID: booking.ROWID,
//         Status: 'Estimate sent',
//         Estimate_Amount: parseFloat(document.getElementById('EstimateTotal').textContent),
//       },    
//     ];

//     try {
//       const response1 = await fetch('https://salesjet-10097049716.catalystappsail.com/esti', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
//         body: JSON.stringify(payload1),
//       });
//       if (!response1.ok) throw new Error('Failed to send estimate to First API');
//       console.log('First API Response:', await response1.json());

//       const response2 = await fetch(
//         'https://salesjet-841904208.catalystserverless.com/server/email-estimate-function/email-estimate',
//         {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify(payload2),
//         }
//       );

//       if (!response2.ok) {
//         let errorMessage = `HTTP error ${response2.status}: ${response2.statusText}`;
//         try {
//           const errorData = await response2.json();
//           errorMessage = errorData.message || errorData.error || errorMessage; 
//         } catch (jsonError) {
//           console.warn('Failed to parse error response from Second API:', jsonError);
//         }
//         throw new Error(errorMessage); 
//       }

//       console.log('Second API Response:', await response2.json());

//       if (booking.Status !== 'Booked') {
//         const response3 = await fetch('https://salesjet-10097049716.catalystappsail.com/leadsdata', {
//           method: 'PUT',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${accessToken}`,
//           },
//           body: JSON.stringify(payload3),
//         });
//         if (!response3.ok) throw new Error('Failed to update status to "Estimate sent"');
//         console.log('Status Update Response:', await response3.json());
//         // addednewly
//          const updatedBooking = {
//           LeadACVLRecordID: booking.LeadACVLRecordID,
//           ROWID: booking.ROWID,
//           Status: 'Estimate sent',
//           Estimate_Amount: parseFloat(document.getElementById('EstimateTotal').textContent),
//         };
//         console.log('Calling updateLeadData with:', updatedBooking);
//         updateLeadData(updatedBooking);
//       } else {
//         console.log('Booking already marked as "Booked", skipping status update.');
//       }

//       setStatus('Sent');
//       setShowViewEstimate(true);
//       setAlertMessage({ type: 'success', message: 'Email sent successfully' });
//     } catch (error) {
//       console.error('Error sending estimate:', error);
//       setAlertMessage({ type: 'error', message: `Failed to send estimate: ${error.message}` });
//     } finally {
//       setShowLoadingOverlay(false);
//       setShowConfirmOverlay(true);
//     }
//   };

//   const confirmBooking = async () => {
//     setShowConfirmOverlay(false);
//     setShowLoadingOverlay(true);
//     setAlertMessage({ type: '', message: '' });
//     const customerEmail = document.getElementById('EstimateCustomerEmail').value;
//     const customerName = document.getElementById('EstimateCustomerName').value;
//     const DocNumber = booking.LeadACVLRecordID || 'DocNumber';
//     const billAddr = {
//       Line1: document.getElementById('EstimateOriginAddressLine1').value,
//       Country: 'CA',
//     };
//     const shipAddr = {
//       Line1: document.getElementById('EstimateDestAddressLine1').value,
//       Country: 'CA',
//     };
//     const depositAmount = parseFloat(document.getElementById('Deposittopay').value) || 0;

//     const selectedProvinceData = provinces.find(p => p.Province === formData.selectedProvince);
//     const defaultProvinceData = provinces.find(p => p.Province === "Zero-rated");
//     const taxCodeData = selectedProvinceData || defaultProvinceData;
//     const taxCodeRef = taxCodeData ? {
//       value: taxCodeData.ID.toString(),
//       name: taxCodeData.Province
//     } : {
//       value: '2',
//       name: 'Zero-rated'
//     };

//     const lineItems = [];
//     if (depositAmount > 0) {
//       lineItems.push({
//         Id: '1',
//         LineNum: 1,
//         Description: 'Deposit Towards Move Booked',
//         Amount: depositAmount,
//         DetailType: 'SalesItemLineDetail',
//         SalesItemLineDetail: {
//           ItemRef: {
//             value: '1',
//             name: 'Services',
//           },
//           UnitPrice: depositAmount,
//           Qty: 1,
//           ItemAccountRef: {
//             value: '52',
//             name: 'Services',
//           },
//           TaxCodeRef: taxCodeRef,
//         },
//       });
//     } else {
//       setAlertMessage({ type: 'error', message: 'Please specify a deposit amount to confirm the booking.' });
//       setShowLoadingOverlay(false);
//       setShowConfirmOverlay(true);
//       return;
//     }
//     const payload = {
//       customerEmail: customerEmail,
//       DisplayName: customerName,
//       invoiceData: {
//         BillEmail: {
//           Address: customerEmail,
//         },
//         DocNumber: DocNumber,
//         TxnDate: new Date().toISOString().split('T')[0],
//         DueDate: document.getElementById('EstimateMoveDate').value,
//         CustomField: [
//           {
//             DefinitionId: '1',
//             Name: 'Sales Agent',
//             Type: 'StringType',
//             StringValue: 'Paul1',
//           },
//         ],
//         BillAddr: billAddr,
//         ShipAddr: shipAddr,
//         CustomerMemo: {
//           value: 'Receipt deposit for your upcoming move. This will be applied toward your final invoice.',
//         },
//         GlobalTaxCalculation: 'NotApplicable',
//         Line: lineItems,
//         Deposit: depositAmount,
//         DepositToAccountRef: {
//           value: '5',
//           name: 'Undeposited Funds',
//         },
//       },
//     };
//     const payload4 = [
//       {
//         ROWID: booking.ROWID,
//         Status: 'Booked',
//       },
//     ];
//     try {
//       const response = await fetch(
//         'https://salesjet-841904208.catalystserverless.com/server/qb_post/handle-invoice',
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       if (!response.ok) {
//         const errorData = await response.json();
//         console.error('API Error:', errorData);
//         setAlertMessage({
//           type: 'error',
//           message: `Failed to create invoice: ${errorData.Fault?.Error[0]?.Message || 'Unknown error'} (${errorData.Fault?.Error[0]?.Detail || ''})`,
//         });
//         throw new Error('Failed to save estimate');
//       }

//       const result = await response.json();
//       console.log('Estimate saved successfully:', result);

//       const response2 = await fetch('https://salesjet-10097049716.catalystappsail.com/leadsdata', {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//           Authorization: `Bearer ${accessToken}`,
//         },
//         body: JSON.stringify(payload4),
//       });
//       if (!response2.ok) throw new Error('Failed to update status to "Booked"');
//       console.log('Status Update Response:', await response2.json());

//       setStatus('Saved');
//       setShowViewEstimate(true);
//       setAlertMessage({ type: 'success', message: 'Invoice sent successfully in QB' });
//     } catch (error) {
//       console.error('Error saving estimate:', error);
//       setAlertMessage({ type: 'error', message: 'Failed to Create Invoice in QB. Please try again.' });
//     } finally {
//       setShowLoadingOverlay(false);
//       setShowConfirmOverlay(true);
//     }
//   };

//   // Function to generate and copy customer link

//   const handleCopyCustomerLink = () => {
//     if (!booking?.LeadACVLRecordID) {
//       setAlertMessage({ type: 'error', message: 'Estimate ID is missing.' });
//       setShowConfirmOverlay(true);
//       return;
//     }

//     const encryptedId = CryptoJS.AES.encrypt(booking.LeadACVLRecordID.toString(), SECRET_KEY).toString();
//     const encodedEncryptedId = encodeURIComponent(encryptedId);
//     const customerLink = `https://salesjet.allcanadavanlines.com/server/estimate_view/?${encodedEncryptedId}`;

//     navigator.clipboard.writeText(customerLink).then(() => {
//       setAlertMessage({ type: 'success', message: 'Customer link copied to clipboard!' });
//       setShowConfirmOverlay(true);
//     }).catch(err => {
//       setAlertMessage({ type: 'error', message: 'Failed to copy link to clipboard.' });
//       setShowConfirmOverlay(true);
//       console.error('Clipboard error:', err);
//     });
//   };

//   return (
//     <div>
//       <div className={`EstimateHeader ${isActive ? 'EstimateActive' : ''}`} onClick={toggleContent}>
//         <div className="EstimateLeftSection">
//           <h2>ESTIMATE</h2>
//           <span className="EstimateLeftSection" style={{ background: 'white', padding: '5px', borderRadius: '10px' }}>
//             {booking.Status}
//           </span>
//           {showViewEstimate && (
//             <>
//               <button
//                 className="EstimateViewBtn"
//                 onClick={handleViewEstimateClick}
//               >
//                 View Estimate
//               </button>
//               <button
//                 className="EstimateViewBtn"
//                 onClick={handleCopyCustomerLink}
//                 style={{ marginLeft: '10px' }}
//               >
//                 Customer Link
//               </button>
//             </>
//           )}
//         </div>
//         <div className="EstimateRightButtons">
//           <button className="EstimateCancelBtn" onClick={handleCancelClick}>
//             Cancel
//           </button>
//           <button className="EstimateSendBtn" onClick={handleSendClick}>
//             Send
//           </button>
//         </div>
//       </div>     
//       <div className={`EstimateContent ${isActive ? 'EstimateVisible' : ''}`}>
//         <div className="EstimateCustomerSection">
//           <div className="EstimateCustomerField">
//             <label htmlFor="EstimateCustomerName">Customer</label>
//             <input
//               type="text"
//               id="EstimateCustomerName"
//               placeholder="Enter customer name"
//               value={formData.customerName || ''}
//               readOnly
//               onChange={e => handleFormChange('customerName', e.target.value)}
//             />
//           </div>
//           <div className="EstimateEmailField">
//             <label htmlFor="EstimateCustomerEmail">Email</label>
//             <input
//               type="text"
//               id="EstimateCustomerEmail"
//               placeholder="Email (separate emails...)"
//               value={formData.customerEmail || ''}
//               onChange={e => handleFormChange('customerEmail', e.target.value)}
//             />
//           </div>
//         </div>

//         <div className="EstimateAddressSection">
//           <div className="EstimateAddressesContainer">
//             <div>
//               <label>Origin Address</label>
//               <div className="EstimateAddressField">
//                 <input
//                   type="text"
//                   id="EstimateOriginAddressLine1"
//                   placeholder="Enter the Origin Address Line 1"
//                   maxLength="100"
//                   value={formData.originAddressLine1 || ''}
//                   onChange={e => handleFormChange('originAddressLine1', e.target.value)}
//                   readOnly
//                 />
//               </div>
//               <div className="EstimateAddressFieldDate">
//                 <label>Move Date</label>
//                 <input
//                   type="date"
//                   id="EstimateMoveDate"
//                   value={formData.moveDate || ''}
//                   onChange={e => handleFormChange('moveDate', e.target.value)}
//                   readOnly
//                 />
//               </div>
//             </div>
//             <div>
//               <label>Destination Address</label>
//               <div className="EstimateAddressField">
//                 <input
//                   type="text"
//                   id="EstimateDestAddressLine1"
//                   placeholder="Enter the Destination Address Line 1"
//                   maxLength="100"
//                   value={formData.destAddressLine1 || ''}
//                   onChange={e => handleFormChange('destAddressLine1', e.target.value)}
//                   readOnly
//                 />
//               </div>
//               <div className="EstimateAddressField">
//                 <label>Move Size</label>
//                 <input
//                   type="text"
//                   id="EstimateMoveSize"
//                   placeholder="Enter move size"
//                   value={formData.moveSize || ''}
//                   onChange={e => handleFormChange('moveSize', e.target.value)}
//                   readOnly
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="EstimateTableSection" ref={tableRef}>
//           <table id="EstimateProductsTable">
//             <thead>
//               <tr>
//                 <th scope="col">#</th>
//                 <th scope="col">
//                   PRODUCT/
//                   <br />
//                   SERVICE
//                 </th>
//                 <th scope="col">DESCRIPTION</th>
//                 <th scope="col">
//                   <div className="EstimateHeaderLabel">
//                     <span>RATE</span>
//                     <span className="EstimateCurrency">CA$</span>
//                   </div>
//                 </th>
//                 <th scope="col">QTY</th>
//                 <th scope="col">
//                   <div className="EstimateHeaderLabel">
//                     <span>AMOUNT</span>
//                     <span className="EstimateCurrency">CA$</span>
//                   </div>
//                 </th>
//                 <th scope="col"></th>
//                 <th scope="col"></th>
//               </tr>
//             </thead>
//             <tbody id="EstimateProductsTableBody">
//               {products.map((product, index) => (
//                 <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F9FAFB' }}>
//                   {editingRow === index ? (
//                     <>
//                       <td>{index + 1}</td>
//                       <td>
//                         <div className="EstimateAutocompleteContainer">
//                           <input
//                             type="text"
//                             id={`EstimateProductService-${index}`}
//                             defaultValue={product.productService}
//                             list={`salesValueOptionsForProduct-${index}`}
//                             className="EstimateEditableInput EstimateProductService"
//                             onChange={e => handleProductServiceChange(index, e.target.value)}
//                           />
//                           <datalist id={`salesValueOptionsForProduct-${index}`}>
//                             {salesValueOptions.map(opt => (
//                               <option key={opt.IdValue} value={opt.Name} />
//                             ))}
//                           </datalist>
//                         </div>
//                       </td>
//                       <td>
//                         <div className="EstimateAutocompleteContainer">
//                           <input
//                             type="text"
//                             id={`EstimateDescription-${index}`}
//                             defaultValue={product.description}
//                             list={`salesValueOptionsForDescription-${index}`}
//                             className="EstimateEditableInput EstimateDescription"
//                           />
//                           <datalist id={`salesValueOptionsForDescription-${index}`}>
//                             {salesValueOptions.map(opt => (
//                               <option key={opt.IdValue} value={opt.Description} />
//                             ))}
//                           </datalist>
//                         </div>
//                       </td>
//                       <td>
//                         <input
//                           type="number"
//                           id={`EstimateRate-${index}`}
//                           defaultValue={product.rate}
//                           className="EstimateEditableInput EstimateRate"
//                           min="0"
//                           step="0.01"
//                           onChange={() => handleQtyRateChange(index)}
//                         />
//                       </td>
//                       <td>
//                         <input
//                           type="number"
//                           id={`EstimateQty-${index}`}
//                           defaultValue={product.qty}
//                           className="EstimateEditableInput EstimateQty"
//                           min="0"
//                           step="1"
//                           onChange={() => handleQtyRateChange(index)}
//                         />
//                       </td>
//                       <td className="EstimateAmount">{(product.qty * product.rate).toFixed(2)}</td>
//                       <td>
//                         <button className="EstimateDeleteBtn" onClick={() => deleteRow(index)}>
//                           🗑️
//                         </button>
//                       </td>
//                       <td>
//                         <button className="EstimateEditBtn" onClick={() => saveRow(index)}>
//                           ✏️
//                         </button>
//                       </td>
//                     </>
//                   ) : (
//                     <>
//                       <td>{index + 1}</td>
//                       <td>{product.productService || ''}</td>
//                       <td>{product.description || ''}</td>
//                       <td>{parseFloat(product.rate).toFixed(2)}</td>
//                       <td>{product.qty || '0'}</td>
//                       <td className="EstimateAmount">{product.amount}</td>
//                       <td>
//                         <button className="EstimateDeleteBtn" onClick={() => deleteRow(index)}>
//                           🗑️
//                         </button>
//                       </td>
//                       <td>
//                         <button className="EstimateEditBtn" onClick={() => toggleEditMode(index)}>
//                           ✏️
//                         </button>
//                       </td>
//                     </>
//                   )}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//           <div className="EstimateActionButtons">
//             <button id="EstimateAddLinesBtn" onClick={addNewRow}>
//               Add Lines
//             </button>
//             <button id="EstimateClearLinesBtn" onClick={() => {
//               setProducts([]);
//               setEditingRow(null);
//             }}>
//               Clear All Lines
//             </button>
//             <button id="EstimateSaveBtn" onClick={handleSaveClick}>
//               Save
//             </button>
//           </div>
//         </div>

//         <div className="EstimateTotalsContainer">
//           <div className="EstimateMessageSection">
//             <label htmlFor="EstimateMessage">Email Content</label>
//             <textarea
//               id="EstimateMessage"
//               placeholder="Email message"
//               value={formData.message || ''}
//               onChange={e => handleFormChange('message', e.target.value)}
//             />
//           </div>
//           <div className="EstimateTotalsSection">
//             <div className="EstimateTotalsRow EstimateSubtotalRow">
//               <label>SUBTOTAL</label>
//               <div className="EstimateMiddleSection"></div>
//               <div className="EstimateSpacer"></div>
//               <span className="EstimateValue" id="EstimateSubtotal">
//                 0.00
//               </span>
//             </div>
//             <div className="EstimateTotalsRow EstimateDiscountRow">
//               <label>DISCOUNT</label>
//               <div className="EstimateMiddleSection">
//                 <div className="EstimateDiscountContainer">
//                   <select
//                     id="EstimateDiscountTypeDropdown"
//                     value={formData.discountType || 'percent'}
//                     onChange={e => handleFormChange('discountType', e.target.value)}
//                   >
//                     <option value="percent">%</option>
//                     <option value="value">$</option>
//                   </select>
//                   <div id="EstimateDiscountInputContainer">
//                     <input
//                       type="number"
//                       id="EstimateDiscountInput"
//                       placeholder="0.00"
//                       min="0"
//                       step="0.01"
//                       value={formData.discountInput || '0.00'}
//                       onChange={e => handleFormChange('discountInput', e.target.value)}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="EstimateSpacer"></div>
//               <span className="EstimateValue" id="EstimateDiscountAmount">
//                 0.00
//               </span>
//             </div>
//             <div className="EstimateTotalsRow EstimateTaxRow">
//               <label>TAX</label>
//               <div className="EstimateMiddleSection">
//                 <select
//                   id="EstimateProvinceDropdown"
//                   value={formData.selectedProvince || ''}
//                   onChange={e => handleProvinceChange(e.target.value)}
//                 >
//                   <option value="">Select Province</option>
//                   {provinces.map(province => (
//                     <option key={province.ID} value={province.Province}>
//                       {province.Province} ({province['Tax%'] * 100}%)
//                     </option>
//                   ))}
//                 </select>
//               </div>
//               <div className="EstimateSpacer"></div>
//               <span className="EstimateValue" id="EstimateGstAmount">
//                 0.00
//               </span>
//             </div>
//             <div className="EstimateTotalsRow EstimateEstimateTotal EstimateEstimateTotalRow">
//               <label className="EstimateBold">ESTIMATE TOTAL</label>
//               <div className="EstimateSpacer"></div>
//               <span className="EstimateValue EstimateBold" id="EstimateTotal">
//                 0.00
//               </span>
//             </div>
//             <div className="EstimateTotalsRow EstimateEstimateTotal EstimateEstimateTotalRow">
//               <label className="EstimateBold">Deposit to pay</label>
//               <div className="EstimateSpacer"></div>
//               <span className="EstimateValue EstimateBold">
//                 <input
//                   type="number"
//                   style={{ padding: '5px', border: '1px solid', borderRadius: '2px' }}
//                   id="Deposittopay"
//                   placeholder="Deposit to pay"
//                   value={formData.depositToPay || ''}
//                   onChange={e => handleFormChange('depositToPay', e.target.value)}
//                 />
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {showConfirmOverlay && (
//         <div className="ConfirmOverlay">
//           <div className="ConfirmOverlayContent">
//             {alertMessage.message ? (
//               <>
//                 <h3>{alertMessage.type === 'success' ? 'Success' : 'Error'}</h3>
//                 <p>{alertMessage.message}</p>
//                 <div className="ConfirmOverlayButtons">
//                   <button className="OverlayCloseBtn" onClick={closeOverlay}>
//                     Close
//                   </button>
//                 </div>
//               </>
//             ) : (
//               <>
//                 <h3>{overlayAction === 'send' ? 'Send Estimate' : 'Confirm Booking'}</h3>
//                 <p>
//                   {overlayAction === 'send'
//                     ? 'Are you sure you want to send this estimate? This action will email the estimate to the customer.'
//                     : (
//                       <>
//                         Are you sure you want to confirm this booking? This action will send the invoice for a deposit of 
//                         <strong> ${parseFloat(formData.depositToPay || 0).toFixed(2)}</strong> and update the status to "Booked."
//                       </>
//                     )}
//                 </p>
//                 <div className="ConfirmOverlayButtons">
//                   <button className="OverlayCloseBtn" onClick={closeOverlay}>
//                     Close
//                   </button>
//                   <button
//                     className="OverlayConfirmBtn"
//                     onClick={overlayAction === 'send' ? sendEstimate : confirmBooking}
//                   >
//                     {overlayAction === 'send' ? 'Send' : 'Confirm'}
//                   </button>
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//       )}

//       {showLoadingOverlay && (
//         <div className="LoadingOverlay">
//           <div className="LoadingOverlayContent">
//             <div className="Spinner"></div>
//             <p>Processing...</p>
//           </div>
//         </div>
//       )}

//       {showEstimateOverlay && (
//         <div className="EstimateOverlay">
//           <div className="EstimateOverlayContent">
//             <button className="OverlayCloseBtn" onClick={closeEstimateOverlay} style={{ position: 'absolute', top: '10px', right: '10px' }}>
//               Close
//             </button>
//             <iframe
//               src={`https://salesjet.allcanadavanlines.com/server/estimate_view/?${booking.LeadACVLRecordID}`}
//               width="100%"
//               height="100%"
//               style={{ border: 'none'}}
//               title="View Estimate"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Estimate;

// after getting dropdown

import React, { useEffect, useState, useRef } from 'react';
import './Estimate.css';
import CryptoJS from 'crypto-js';

let cachedDefaultMessage = null;
let cachedProvinces = null;
let cachedSalesValueOptions = null;

const Estimate = ({ accessToken, booking, userDetails, userMap, updateLeadData }) => {
  const [isActive, setIsActive] = useState(false);
  const [status, setStatus] = useState('Draft');
  const [products, setProducts] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [salesValueOptions, setSalesValueOptions] = useState([]);
  const [existingEstimate, setExistingEstimate] = useState(null);
  const [formData, setFormData] = useState({});
  const [showConfirmOverlay, setShowConfirmOverlay] = useState(false);
  const [showLoadingOverlay, setShowLoadingOverlay] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [alertMessage, setAlertMessage] = useState({ type: '', message: '' });
  const [defaultMessage, setDefaultMessage] = useState('');
  const [overlayAction, setOverlayAction] = useState('');
  const [showViewEstimate, setShowViewEstimate] = useState(false);
  const [showEstimateOverlay, setShowEstimateOverlay] = useState(false);
  const tableRef = useRef(null);
  const SECRET_KEY = '7f3a1d9e4c6b2f88b0e7a5c9d4f1342b';

  useEffect(() => {
    const fetchProvinces = async () => {
      if (cachedProvinces !== null) {
        setProvinces(cachedProvinces);
        return;
      }

      try {
        const response = await fetch('https://salesjet-10097049716.catalystappsail.com/taxvalueid1');
        if (!response.ok) throw new Error('Error fetching provinces');
        const apiData = await response.json();
        if (apiData.status === "success" && apiData.data) {
          const parsedData = JSON.parse(apiData.data);
          setProvinces(parsedData || []);
          cachedProvinces = parsedData || [];
        } else {
          throw new Error('No provinces found in response');
        }
      } catch (error) {
        console.error('Error fetching provinces:', error);
        const fallbackProvinces = [];
        setProvinces(fallbackProvinces);
        cachedProvinces = fallbackProvinces;
      }
    };

    const fetchSalesValues = async () => {
      if (cachedSalesValueOptions !== null) {
        setSalesValueOptions(cachedSalesValueOptions);
        return;
      }

      try {
        const response = await fetch('https://salesjet-10097049716.catalystappsail.com/salesvalueid1');
        if (!response.ok) throw new Error('Error fetching sales values');
        const apiData = await response.json();
        if (apiData.status === "success" && apiData.data) {
          const parsedData = JSON.parse(apiData.data);
          setSalesValueOptions(parsedData || []);
          cachedSalesValueOptions = parsedData || [];
        } else {
          throw new Error('No sales values found in response');
        }
      } catch (error) {
        console.error('Error fetching sales values:', error);
        const fallbackSalesValues = [];
        setSalesValueOptions(fallbackSalesValues);
        cachedSalesValueOptions = fallbackSalesValues;
      }
    };

    fetchProvinces();
    fetchSalesValues();
  }, []);

  useEffect(() => {
    const fetchEmailTemplate = async () => {
      if (cachedDefaultMessage !== null) {
        setDefaultMessage(cachedDefaultMessage);
        return;
      }

      try {
        const response = await fetch('https://salesjet-10097049716.catalystappsail.com/emailtemp1');
        if (!response.ok) throw new Error('Error fetching email template');
        const apiData = await response.json();
        if (apiData.status === "success" && apiData.data) {
          const fixedDataString = apiData.data.replace(/:\{([^}]+)\}/g, ':[$1]');
          const parsedDataArray = JSON.parse(fixedDataString);
          const allOptions = {};
          parsedDataArray.forEach(obj => {
            Object.assign(allOptions, obj);
          });
          const message = allOptions.defaultMessage || '';
          setDefaultMessage(message);
          cachedDefaultMessage = message;
        } else {
          throw new Error('No default message found in response');
        }
      } catch (error) {
        console.error('Error fetching email template:', error);
        const fallbackMessage = 'Thank you for the opportunity to provide an estimate for your move.';
        setDefaultMessage(fallbackMessage);
        cachedDefaultMessage = fallbackMessage;
      }
    };
    fetchEmailTemplate();
  }, []);

  useEffect(() => {
    const checkExistingEstimate = async () => {
      if (!booking?.LeadACVLRecordID || !accessToken) return;
      setShowViewEstimate(false);
      if (booking?.Status === 'Estimate sent' || booking?.Status === 'Booked') {
        setShowViewEstimate(true);
      }
      try {
        const response = await fetch('https://salesjet-10097049716.catalystappsail.com/esti', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            'LeadACVLRecordID': booking.LeadACVLRecordID,
          },
        });
        if (response.ok) {
          const result = await response.json();
          if (result.status === 'success' && result.totalRecords > 0) {
            setExistingEstimate(result.data[0]);
            const itemsString = result.data[0].Items;
            let validJsonString = itemsString
              .replace(/=/g, ':')
              .replace(/([{,])\s*([^{,\s:]+)\s*:/g, '$1"$2":')
              .replace(/:\s*([^",}\s][^,}]*)(?=[,}])/g, (match, value) => {
                const trimmedValue = value.trim();
                return /^[0-9.-]+$/.test(trimmedValue) ? `:${trimmedValue}` : `:"${trimmedValue}"`;
              });
            try {
              const parsedItems = JSON.parse(validJsonString).map(item => {
                const matchingOption = salesValueOptions.find(opt => opt.Name === item.desc);
                return {
                  productService: item.desc,
                  description: matchingOption ? matchingOption.Description : item.desc,
                  qty: parseFloat(item.qty) || 0,
                  rate: parseFloat(item.rate) || 0,
                  amount: parseFloat(item.amount) || 0,
                  idValue: matchingOption ? matchingOption.IdValue : '',
                };
              });
              setProducts(parsedItems);
            } catch (parseError) {
              console.error('JSON parse error:', parseError);
              const manualItems = itemsString.match(/\{[^}]*\}/g)?.map(itemStr => {
                const item = {};
                itemStr.replace(/(\w+)\s*=\s*([^,}]+)/g, (_, key, value) => {
                  item[key] = isNaN(value) ? value.trim() : parseFloat(value);
                });
                const matchingOption = salesValueOptions.find(opt => opt.Name === item.desc);
                return {
                  productService: item.desc,
                  description: matchingOption ? matchingOption.Description : item.desc,
                  qty: parseFloat(item.qty) || 0,
                  rate: parseFloat(item.rate) || 0,
                  amount: parseFloat(item.amount) || 0,
                  idValue: matchingOption ? matchingOption.IdValue : '',
                };
              }) || [];
              setProducts(manualItems);
            }
          } else {
            setExistingEstimate(null);
            setProducts([]);
          }
        } else {
          console.error('API request failed:', response.statusText);
        }
      } catch (error) {
        console.error('Error checking existing estimate:', error);
      }
    };
    setProducts([]);
    setExistingEstimate(null);
    setEditingRow(null);
    setStatus('Draft');
    checkExistingEstimate();
  }, [booking, accessToken, salesValueOptions, userDetails]);

  useEffect(() => {
    let newFormData;
    if (existingEstimate) {
      const taxProvince = existingEstimate.Tax || '';
      const taxId = taxProvince ? provinces.find(p => p.Province === taxProvince)?.ID : 2;
      newFormData = {
        customerName: booking.Customer_Name || '',
        customerEmail: existingEstimate.Email || '',
        originAddressLine1: booking.FromAddress || booking.OriginCity,
        originProvince: booking.OriginCity || '',
        moveDate: booking.Move_Date || '',
        destAddressLine1: booking.ToAddress || booking.DestinationCity,
        destProvince: booking.DestinationCity || '',
        moveSize: booking.Move_Size || '',
        depositToPay: existingEstimate.Deposittopay || '',
        discountInput: existingEstimate.Discount || '0.00',
        discountType: existingEstimate.DiscountType || 'percent',
        message: existingEstimate.message || defaultMessage,
        selectedProvince: taxProvince,
        provinceId: taxId,
      };
    } else if (booking) {
      newFormData = {
        customerName: booking.Customer_Name || '',
        customerEmail: booking.Email || '',
        originAddressLine1: booking.FromAddress || booking.OriginCity,
        moveDate: booking.Move_Date || '',
        destAddressLine1: booking.ToAddress || booking.DestinationCity,
        moveSize: booking.Move_Size || '',
        discountType: 'percent',
        discountInput: '0.00',
        selectedProvince: '',
        provinceId: 2,
        depositToPay: '100',
        message: defaultMessage,
      };
    } else {
      newFormData = { message: defaultMessage };
    }
    setFormData(newFormData);
    updateTotals();
  }, [booking, existingEstimate, defaultMessage, provinces]);

  useEffect(() => {
    updateTotals();
  }, [products, formData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tableRef.current && !tableRef.current.contains(event.target) && editingRow !== null) {
        saveRow(editingRow);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [editingRow]);

  const toTitleCase = str => str?.toLowerCase().replace(/(^|\s)\w/g, letter => letter.toUpperCase()) || '';

  const calculateSubtotal = () => products.reduce((sum, product) => sum + (parseFloat(product.amount) || 0), 0);

  const calculateDiscount = subtotal => {
    const discountType = formData.discountType || 'percent';
    const discountValue = parseFloat(formData.discountInput) || 0;
    return discountType === 'percent' ? (subtotal * discountValue) / 100 : discountValue;
  };

  const calculateTax = subtotalAfterDiscount => {
    const selectedProvince = provinces.find(p => p.Province === formData.selectedProvince);
    const taxPercentage = selectedProvince ? selectedProvince['Tax%'] * 100 : 0;
    return (subtotalAfterDiscount * taxPercentage) / 100;
  };

  const updateTotals = () => {
    const subtotal = calculateSubtotal();
    const discountAmount = calculateDiscount(subtotal);
    const subtotalAfterDiscount = subtotal - discountAmount;
    const gstAmount = calculateTax(subtotalAfterDiscount);
    const total = subtotalAfterDiscount + gstAmount;
    document.getElementById('EstimateSubtotal').textContent = subtotal.toFixed(2);
    document.getElementById('EstimateDiscountAmount').textContent = discountAmount.toFixed(2);
    document.getElementById('EstimateGstAmount').textContent = gstAmount.toFixed(2);
    document.getElementById('EstimateTotal').textContent = total.toFixed(2);
  };

  const handleFormChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const toggleContent = () => setIsActive(prev => !prev);

  const handleCancelClick = e => {
    e.stopPropagation();
    setIsActive(false);
  };

  const handleProductServiceChange = (index, value) => {
    const match = salesValueOptions.find(opt => opt.Name === value);
    if (match) {
      const descriptionInput = document.getElementById(`EstimateDescription-${index}`);
      const rateInput = document.getElementById(`EstimateRate-${index}`);
      if (descriptionInput) descriptionInput.value = match.Description;
      if (rateInput) rateInput.value = match.UnitPrice;
    }
  };

  const addNewRow = () => {
    let updated = [...products];
    if (editingRow !== null && editingRow < updated.length) {
      const result = saveRow(editingRow);
      if (!result) return;
      updated = result;
    }
    const newRow = { productService: '', description: '', rate: 0, qty: 0, amount: 0, idValue: '' };
    const newProducts = [...updated, newRow];
    const newIndex = newProducts.length - 1;
    setProducts(newProducts);
    setEditingRow(newIndex);
    setTimeout(() => {
      const input = document.getElementById(`EstimateProductService-${newIndex}`);
      if (input) input.focus();
      const row = document.querySelector(`#EstimateProductsTableBody tr:nth-child(${newIndex + 1})`);
      if (row) row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 100);
  };

  const deleteRow = index => {
    const newProducts = products.filter((_, i) => i !== index);
    setProducts(newProducts);
    if (editingRow === index) setEditingRow(null);
  };

  const saveRow = index => {
    const qty = parseFloat(document.getElementById(`EstimateQty-${index}`).value) || 0;
    const rate = parseFloat(document.getElementById(`EstimateRate-${index}`).value) || 0;
 
    if (qty < 0 || rate < 0) {
      setAlertMessage({ type: 'error', message: 'Quantity and rate must be non-negative.' });
      setShowConfirmOverlay(true);
      return null;
    }
 
    const productService = document.getElementById(`EstimateProductService-${index}`).value;
    const description = document.getElementById(`EstimateDescription-${index}`).value;
    const amount = (qty * rate).toFixed(2);
 
    const matchingOption = salesValueOptions.find(opt => opt.Name === productService);
    const idValue = matchingOption ? matchingOption.IdValue : '';
 
    const updatedProducts = products.map((p, i) =>
      i === index ? { ...p, productService, description: toTitleCase(description), rate, qty, amount, idValue } : p
    );
 
    setProducts(updatedProducts);
    setEditingRow(null);
    return updatedProducts;
  };
 
  const handleQtyRateChange = index => {
    const qty = parseFloat(document.getElementById(`EstimateQty-${index}`).value) || 0;
    const rate = parseFloat(document.getElementById(`EstimateRate-${index}`).value) || 0;
    const amount = (qty * rate).toFixed(2);
    const updatedProducts = [...products];
    updatedProducts[index] = { ...updatedProducts[index], qty, rate, amount };
    setProducts(updatedProducts);
  };

  const toggleEditMode = index => {
    if (editingRow !== null && editingRow !== index) saveRow(editingRow);
    setEditingRow(editingRow === index ? null : index);
  };

  const handleSendConfirm = () => {
    setOverlayAction('confirm');
    setShowConfirmOverlay(true);
    setAlertMessage({ type: '', message: '' });
  };

  const closeOverlay = () => {
    setShowConfirmOverlay(false);
    setAlertMessage({ type: '', message: '' });
    setOverlayAction('');
  };

  const handleSaveClick = () => {
    if (editingRow !== null) saveRow(editingRow);
  };

  const handleProvinceChange = provinceName => {
    let newProvinceId;
    if (!provinceName) {
      newProvinceId = 2;
    } else {
      const selectedProvinceData = provinces.find(p => p.Province === provinceName);
      newProvinceId = selectedProvinceData?.ID || 2;
    }
    setFormData(prev => ({
      ...prev,
      selectedProvince: provinceName,
      provinceId: newProvinceId,
      gstDropdown: !provinceName ? '0' : (provinces.find(p => p.Province === provinceName)['Tax%'] * 100).toString(),
    }));
  };

  const handleViewEstimateClick = () => {
    if (!booking?.LeadACVLRecordID) {
      setAlertMessage({ type: 'error', message: 'Estimate ID is missing.' });
      setShowConfirmOverlay(true);
      return;
    }
    setShowEstimateOverlay(true);
  };

  const closeEstimateOverlay = () => {
    setShowEstimateOverlay(false);
  };

  const handleSendClick = () => {
    setOverlayAction('send');
    setShowConfirmOverlay(true);
    setAlertMessage({ type: '', message: '' });
  };

  const sendEstimate = async () => {
    if (products.length === 0) {
      setAlertMessage({ type: 'error', message: 'Please add at least one product/service to the estimate before sending.' });
      setShowConfirmOverlay(true);
      return;
    }
    if (editingRow !== null) {
      const updated = saveRow(editingRow);
      if (!updated) return;
    }
    setShowConfirmOverlay(false);
    setShowLoadingOverlay(true);
    setAlertMessage({ type: '', message: '' });
    const selectedProvince = provinces.find(p => p.Province === formData.selectedProvince);
    const taxField = selectedProvince
      ? `${selectedProvince.Province} - ${(selectedProvince['Tax%'] * 100).toFixed(0)}%`
      : '0';
    let salesAgentName = booking?.Sales_Agent || '';
    if (!salesAgentName && userDetails?.userId && userMap) {
      salesAgentName = userMap[userDetails.userId] || 'Agent';
    }
    if (!salesAgentName) {
      salesAgentName = 'Agent';
    }
    const payload1 = {
      LeadACVLRecordID: booking.LeadACVLRecordID,
      OriginCity: booking.OriginCity,
      Customer_Name: formData.customerName,
      Deposittopay: formData.depositToPay,
      Sales_Agent: salesAgentName,
      Email: formData.customerEmail,
      message: formData.message,
      Move_Size: formData.moveSize,
      Move_Date: formData.moveDate,
      Estimatetotal: parseFloat(document.getElementById('EstimateTotal').textContent),
      DestinationCity: booking.DestinationCity,
      FromAddress: `${formData.originAddressLine1}`,
      ToAddress: `${formData.destAddressLine1}`,
      Items: products.map(product => ({
        desc: product.productService,
        prod: product.description,
        qty: product.qty,
        rate: parseFloat(product.rate).toFixed(2),
        amount: parseFloat(product.amount).toFixed(2),
        idValue: product.idValue || '',
        TaxCodeRef: formData.provinceId.toString(),
      })),
      Subtotal: calculateSubtotal().toFixed(2),
      Discount: formData.discountInput,
      TAXValue: calculateTax(calculateSubtotal() - calculateDiscount(calculateSubtotal())).toFixed(2),
      DiscountType: formData.discountType || ' ',
      Tax: formData.selectedProvince || '0',
      TaxPercentage: taxField || '0',
    };
    const payload2 = {
      recipientEmail: formData.customerEmail,
      subject: 'Estimate #' + booking.LeadACVLRecordID + ' from All Canada Van Lines Inc.',
      message: formData.message,
      filteredByOriginDestRange: products.map(product => ({
        'Estimate Item - Desc': product.productService,
        'Estimate Item - pro': product.description,
        'Estimate Item - Quantity': product.qty,
        'Estimate Item - Rate': parseFloat(product.rate),
        'Estimate Item - Amount': parseFloat(product.amount),
      })),
      subTotal: calculateSubtotal(),
      tax: taxField,
      Deposittopay: formData.depositToPay,
      taxAmount: calculateTax(calculateSubtotal() - calculateDiscount(calculateSubtotal())),
      Discount: calculateDiscount(calculateSubtotal()),
      finalamount: parseFloat(document.getElementById('EstimateTotal').textContent),
      LeadACVLRecordID: booking.LeadACVLRecordID,
    };
    const payload3 = [
      {
        ROWID: booking.ROWID,
        Status: 'Estimate sent',
        Estimate_Amount: parseFloat(document.getElementById('EstimateTotal').textContent),
      },
    ];
    try {
      const response1 = await fetch('https://salesjet-10097049716.catalystappsail.com/esti', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
        body: JSON.stringify(payload1),
      });
      if (!response1.ok) throw new Error('Failed to send estimate to First API');
      console.log('First API Response:', await response1.json());
      const response2 = await fetch(
        'https://salesjet-841904208.catalystserverless.com/server/email-estimate-function/email-estimate',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload2),
        }
      );
      if (!response2.ok) {
        let errorMessage = `HTTP error ${response2.status}: ${response2.statusText}`;
        try {
          const errorData = await response2.json();
          errorMessage = errorData.message || errorData.error || errorMessage;
        } catch (jsonError) {
          console.warn('Failed to parse error response from Second API:', jsonError);
        }
        throw new Error(errorMessage);
      }
      console.log('Second API Response:', await response2.json());
      if (booking.Status !== 'Booked') {
        const response3 = await fetch('https://salesjet-10097049716.catalystappsail.com/leadsdata', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(payload3),
        });
        if (!response3.ok) throw new Error('Failed to update status to "Estimate sent"');
        console.log('Status Update Response:', await response3.json());
        // addednewly
         const updatedBooking = {
          LeadACVLRecordID: booking.LeadACVLRecordID,
          ROWID: booking.ROWID,
          Status: 'Estimate sent',
          Estimate_Amount: parseFloat(document.getElementById('EstimateTotal').textContent),
        };
        console.log('Calling updateLeadData with:', updatedBooking);
        updateLeadData(updatedBooking);
      } else {
        console.log('Booking already marked as "Booked", skipping status update.');
      }
      setStatus('Sent');
      setShowViewEstimate(true);
      setAlertMessage({ type: 'success', message: 'Email sent successfully' });
    } catch (error) {
      console.error('Error sending estimate:', error);
      setAlertMessage({ type: 'error', message: `Failed to send estimate: ${error.message}` });
    } finally {
      setShowLoadingOverlay(false);
      setShowConfirmOverlay(true);
    }
  };

  const confirmBooking = async () => {
    setShowConfirmOverlay(false);
    setShowLoadingOverlay(true);
    setAlertMessage({ type: '', message: '' });
    const customerEmail = document.getElementById('EstimateCustomerEmail').value;
    const customerName = document.getElementById('EstimateCustomerName').value;
    const DocNumber = booking.LeadACVLRecordID || 'DocNumber';
    const billAddr = {
      Line1: document.getElementById('EstimateOriginAddressLine1').value,
      Country: 'CA',
    };
    const shipAddr = {
      Line1: document.getElementById('EstimateDestAddressLine1').value,
      Country: 'CA',
    };
    const depositAmount = parseFloat(document.getElementById('Deposittopay').value) || 0;
    const selectedProvinceData = provinces.find(p => p.Province === formData.selectedProvince);
    const defaultProvinceData = provinces.find(p => p.Province === "Zero-rated");
    const taxCodeData = selectedProvinceData || defaultProvinceData;
    const taxCodeRef = taxCodeData ? {
      value: taxCodeData.ID.toString(),
      name: taxCodeData.Province
    } : {
      value: '2',
      name: 'Zero-rated'
    };
    const lineItems = [];
    if (depositAmount > 0) {
      lineItems.push({
        Id: '1',
        LineNum: 1,
        Description: 'Deposit Towards Move Booked',
        Amount: depositAmount,
        DetailType: 'SalesItemLineDetail',
        SalesItemLineDetail: {
          ItemRef: {
            value: '1',
            name: 'Services',
          },
          UnitPrice: depositAmount,
          Qty: 1,
          ItemAccountRef: {
            value: '52',
            name: 'Services',
          },
          TaxCodeRef: taxCodeRef,
        },
      });
    } else {
      setAlertMessage({ type: 'error', message: 'Please specify a deposit amount to confirm the booking.' });
      setShowLoadingOverlay(false);
      setShowConfirmOverlay(true);
      return;
    }
    const payload = {
      customerEmail: customerEmail,
      DisplayName: customerName,
      invoiceData: {
        BillEmail: {
          Address: customerEmail,
        },
        DocNumber: DocNumber,
        TxnDate: new Date().toISOString().split('T')[0],
        DueDate: document.getElementById('EstimateMoveDate').value,
        CustomField: [
          {
            DefinitionId: '1',
            Name: 'Sales Agent',
            Type: 'StringType',
            StringValue: 'Paul1',
          },
        ],
        BillAddr: billAddr,
        ShipAddr: shipAddr,
        CustomerMemo: {
          value: 'Receipt deposit for your upcoming move. This will be applied toward your final invoice.',
        },
        GlobalTaxCalculation: 'NotApplicable',
        Line: lineItems,
        Deposit: depositAmount,
        DepositToAccountRef: {
          value: '5',
          name: 'Undeposited Funds',
        },
      },
    };
    const payload4 = [
      {
        ROWID: booking.ROWID,
        Status: 'Booked',
      },
    ];
    try {
      const response = await fetch(
        'https://salesjet-841904208.catalystserverless.com/server/qb_post/handle-invoice',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        console.error('API Error:', errorData);
        setAlertMessage({
          type: 'error',
          message: `Failed to create invoice: ${errorData.Fault?.Error[0]?.Message || 'Unknown error'} (${errorData.Fault?.Error[0]?.Detail || ''})`,
        });
        throw new Error('Failed to save estimate');
      }
      const result = await response.json();
      console.log('Estimate saved successfully:', result);
      const response2 = await fetch('https://salesjet-10097049716.catalystappsail.com/leadsdata', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload4),
      });
      if (!response2.ok) throw new Error('Failed to update status to "Booked"');
      console.log('Status Update Response:', await response2.json());
      setStatus('Saved');
      setShowViewEstimate(true);
      setAlertMessage({ type: 'success', message: 'Invoice sent successfully in QB' });
    } catch (error) {
      console.error('Error saving estimate:', error);
      setAlertMessage({ type: 'error', message: 'Failed to Create Invoice in QB. Please try again.' });
    } finally {
      setShowLoadingOverlay(false);
      setShowConfirmOverlay(true);
    }
  };

  // Function to generate and copy customer link
  const handleCopyCustomerLink = () => {
    if (!booking?.LeadACVLRecordID) {
      setAlertMessage({ type: 'error', message: 'Estimate ID is missing.' });
      setShowConfirmOverlay(true);
      return;
    }
    const encryptedId = CryptoJS.AES.encrypt(booking.LeadACVLRecordID.toString(), SECRET_KEY).toString();
    const encodedEncryptedId = encodeURIComponent(encryptedId);
    const customerLink = `https://salesjet.allcanadavanlines.com/server/estimate_view/?${encodedEncryptedId}`;
    navigator.clipboard.writeText(customerLink).then(() => {
      setAlertMessage({ type: 'success', message: 'Customer link copied to clipboard!' });
      setShowConfirmOverlay(true);
    }).catch(err => {
      setAlertMessage({ type: 'error', message: 'Failed to copy link to clipboard.' });
      setShowConfirmOverlay(true);
      console.error('Clipboard error:', err);
    });
  };

  return (
    <div>
      <div className={`EstimateHeader ${isActive ? 'EstimateActive' : ''}`} onClick={toggleContent}>
        <div className="EstimateLeftSection">
          <h2>ESTIMATE</h2>
          <span className="EstimateLeftSection" style={{ background: 'white', padding: '5px', borderRadius: '10px' }}>
            {booking.Status}
          </span>
          {showViewEstimate && (
            <>
              <button
                className="EstimateViewBtn"
                onClick={handleViewEstimateClick}
              >
                View Estimate
              </button>
              <button
                className="EstimateViewBtn"
                onClick={handleCopyCustomerLink}
                style={{ marginLeft: '10px' }}
              >
                Customer Link
              </button>
            </>
          )}
        </div>
        <div className="EstimateRightButtons">
          <button className="EstimateCancelBtn" onClick={handleCancelClick}>
            Cancel
          </button>
          <button className="EstimateSendBtn" onClick={handleSendClick}>
            Send
          </button>
        </div>
      </div>
      <div className={`EstimateContent ${isActive ? 'EstimateVisible' : ''}`}>
        <div className="EstimateCustomerSection">
          <div className="EstimateCustomerField">
            <label htmlFor="EstimateCustomerName">Customer</label>
            <input
              type="text"
              id="EstimateCustomerName"
              placeholder="Enter customer name"
              value={formData.customerName || ''}
              readOnly
              onChange={e => handleFormChange('customerName', e.target.value)}
            />
          </div>
          <div className="EstimateEmailField">
            <label htmlFor="EstimateCustomerEmail">Email</label>
            <input
              type="text"
              id="EstimateCustomerEmail"
              placeholder="Email (separate emails...)"
              value={formData.customerEmail || ''}
              onChange={e => handleFormChange('customerEmail', e.target.value)}
            />
          </div>
        </div>
        <div className="EstimateAddressSection">
          <div className="EstimateAddressesContainer">
            <div>
              <label>Origin Address</label>
              <div className="EstimateAddressField">
                <input
                  type="text"
                  id="EstimateOriginAddressLine1"
                  placeholder="Enter the Origin Address Line 1"
                  maxLength="100"
                  value={formData.originAddressLine1 || ''}
                  onChange={e => handleFormChange('originAddressLine1', e.target.value)}
                  readOnly
                />
              </div>
              <div className="EstimateAddressFieldDate">
                <label>Move Date</label>
                <input
                  type="date"
                  id="EstimateMoveDate"
                  value={formData.moveDate || ''}
                  onChange={e => handleFormChange('moveDate', e.target.value)}
                  readOnly
                />
              </div>
            </div>
            <div>
              <label>Destination Address</label>
              <div className="EstimateAddressField">
                <input
                  type="text"
                  id="EstimateDestAddressLine1"
                  placeholder="Enter the Destination Address Line 1"
                  maxLength="100"
                  value={formData.destAddressLine1 || ''}
                  onChange={e => handleFormChange('destAddressLine1', e.target.value)}
                  readOnly
                />
              </div>
              <div className="EstimateAddressField">
                <label>Move Size</label>
                <input
                  type="text"
                  id="EstimateMoveSize"
                  placeholder="Enter move size"
                  value={formData.moveSize || ''}
                  onChange={e => handleFormChange('moveSize', e.target.value)}
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>
        <div className="EstimateTableSection" ref={tableRef}>
          <table id="EstimateProductsTable">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">
                  PRODUCT/
                  <br />
                  SERVICE
                </th>
                <th scope="col">DESCRIPTION</th>
                <th scope="col">
                  <div className="EstimateHeaderLabel">
                    <span>RATE</span>
                    <span className="EstimateCurrency">CA$</span>
                  </div>
                </th>
                <th scope="col">QTY</th>
                <th scope="col">
                  <div className="EstimateHeaderLabel">
                    <span>AMOUNT</span>
                    <span className="EstimateCurrency">CA$</span>
                  </div>
                </th>
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody id="EstimateProductsTableBody">
              {products.map((product, index) => (
                <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#FFFFFF' : '#F9FAFB' }}>
                  {editingRow === index ? (
                    <>
                      <td>{index + 1}</td>
                      <td>
                        <div className="EstimateAutocompleteContainer">
                          <input
                            type="text"
                            id={`EstimateProductService-${index}`}
                            defaultValue={product.productService}
                            list={`salesValueOptionsForProduct-${index}`}
                            className="EstimateEditableInput EstimateProductService"
                            onChange={e => handleProductServiceChange(index, e.target.value)}
                          />
                          <datalist id={`salesValueOptionsForProduct-${index}`}>
                            {salesValueOptions.map(opt => (
                              <option key={opt.IdValue} value={opt.Name} />
                            ))}
                          </datalist>
                        </div>
                      </td>
                      <td>
                        <div className="EstimateAutocompleteContainer">
                          <input
                            type="text"
                            id={`EstimateDescription-${index}`}
                            defaultValue={product.description}
                            list={`salesValueOptionsForDescription-${index}`}
                            className="EstimateEditableInput EstimateDescription"
                          />
                          <datalist id={`salesValueOptionsForDescription-${index}`}>
                            {salesValueOptions.map(opt => (
                              <option key={opt.IdValue} value={opt.Description} />
                            ))}
                          </datalist>
                        </div>
                      </td>
                      <td>
                        <input
                          type="number"
                          id={`EstimateRate-${index}`}
                          defaultValue={product.rate}
                          className="EstimateEditableInput EstimateRate"
                          min="0"
                          step="0.01"
                          onChange={() => handleQtyRateChange(index)}
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          id={`EstimateQty-${index}`}
                          defaultValue={product.qty}
                          className="EstimateEditableInput EstimateQty"
                          min="0"
                          step="1"
                          onChange={() => handleQtyRateChange(index)}
                        />
                      </td>
                      <td className="EstimateAmount">{(product.qty * product.rate).toFixed(2)}</td>
                      <td>
                        <button className="EstimateDeleteBtn" onClick={() => deleteRow(index)}>
                          🗑️
                        </button>
                      </td>
                      <td>
                        <button className="EstimateEditBtn" onClick={() => saveRow(index)}>
                          ✏️
                        </button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{index + 1}</td>
                      <td>{product.productService || ''}</td>
                      <td>{product.description || ''}</td>
                      <td>{parseFloat(product.rate).toFixed(2)}</td>
                      <td>{product.qty || '0'}</td>
                      <td className="EstimateAmount">{product.amount}</td>
                      <td>
                        <button className="EstimateDeleteBtn" onClick={() => deleteRow(index)}>
                          🗑️
                        </button>
                      </td>
                      <td>
                        <button className="EstimateEditBtn" onClick={() => toggleEditMode(index)}>
                          ✏️
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          <div className="EstimateActionButtons">
            <button id="EstimateAddLinesBtn" onClick={addNewRow}>
              Add Lines
            </button>
            <button id="EstimateClearLinesBtn" onClick={() => {
              setProducts([]);
              setEditingRow(null);
            }}>
              Clear All Lines
            </button>
            <button id="EstimateSaveBtn" onClick={handleSaveClick}>
              Save
            </button>
          </div>
        </div>
        <div className="EstimateTotalsContainer">
          <div className="EstimateMessageSection">
            <label htmlFor="EstimateMessage">Email Content</label>
            <textarea
              id="EstimateMessage"
              placeholder="Email message"
              value={formData.message || ''}
              onChange={e => handleFormChange('message', e.target.value)}
            />
          </div>
          <div className="EstimateTotalsSection">
            <div className="EstimateTotalsRow EstimateSubtotalRow">
              <label>SUBTOTAL</label>
              <div className="EstimateMiddleSection"></div>
              <div className="EstimateSpacer"></div>
              <span className="EstimateValue" id="EstimateSubtotal">
                0.00
              </span>
            </div>
            <div className="EstimateTotalsRow EstimateDiscountRow">
              <label>DISCOUNT</label>
              <div className="EstimateMiddleSection">
                <div className="EstimateDiscountContainer">
                  <select
                    id="EstimateDiscountTypeDropdown"
                    value={formData.discountType || 'percent'}
                    onChange={e => handleFormChange('discountType', e.target.value)}
                  >
                    <option value="percent">%</option>
                    <option value="value">$</option>
                  </select>
                  <div id="EstimateDiscountInputContainer">
                    <input
                      type="number"
                      id="EstimateDiscountInput"
                      placeholder="0.00"
                      min="0"
                      step="0.01"
                      value={formData.discountInput || '0.00'}
                      onChange={e => handleFormChange('discountInput', e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="EstimateSpacer"></div>
              <span className="EstimateValue" id="EstimateDiscountAmount">
                0.00
              </span>
            </div>
            <div className="EstimateTotalsRow EstimateTaxRow">
              <label>TAX</label>
              <div className="EstimateMiddleSection">
                <select
                  id="EstimateProvinceDropdown"
                  value={formData.selectedProvince || ''}
                  onChange={e => handleProvinceChange(e.target.value)}
                >
                  <option value="">Select Province</option>
                  {provinces.map(province => (
                    <option key={province.ID} value={province.Province}>
                      {province.Province} ({province['Tax%'] * 100}%)
                    </option>
                  ))}
                </select>
              </div>
              <div className="EstimateSpacer"></div>
              <span className="EstimateValue" id="EstimateGstAmount">
                0.00
              </span>
            </div>
            <div className="EstimateTotalsRow EstimateEstimateTotal EstimateEstimateTotalRow">
              <label className="EstimateBold">ESTIMATE TOTAL</label>
              <div className="EstimateSpacer"></div>
              <span className="EstimateValue EstimateBold" id="EstimateTotal">
                0.00
              </span>
            </div>
            <div className="EstimateTotalsRow EstimateEstimateTotal EstimateEstimateTotalRow">
              <label className="EstimateBold">Deposit to pay</label>
              <div className="EstimateSpacer"></div>
              <span className="EstimateValue EstimateBold">
                <input
                  type="number"
                  style={{ padding: '5px', border: '1px solid', borderRadius: '2px' }}
                  id="Deposittopay"
                  placeholder="Deposit to pay"
                  value={formData.depositToPay || ''}
                  onChange={e => handleFormChange('depositToPay', e.target.value)}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
      {showConfirmOverlay && (
        <div className="ConfirmOverlay">
          <div className="ConfirmOverlayContent">
            {alertMessage.message ? (
              <>
                <h3>{alertMessage.type === 'success' ? 'Success' : 'Error'}</h3>
                <p>{alertMessage.message}</p>
                <div className="ConfirmOverlayButtons">
                  <button className="OverlayCloseBtn" onClick={closeOverlay}>
                    Close
                  </button>
                </div>
              </>
            ) : (
              <>
                <h3>{overlayAction === 'send' ? 'Send Estimate' : 'Confirm Booking'}</h3>
                <p>
                  {overlayAction === 'send'
                    ? 'Are you sure you want to send this estimate? This action will email the estimate to the customer.'
                    : (
                      <>
                        Are you sure you want to confirm this booking? This action will send the invoice for a deposit of
                        <strong> ${parseFloat(formData.depositToPay || 0).toFixed(2)}</strong> and update the status to "Booked."
                      </>
                    )}
                </p>
                <div className="ConfirmOverlayButtons">
                  <button className="OverlayCloseBtn" onClick={closeOverlay}>
                    Close
                  </button>
                  <button
                    className="OverlayConfirmBtn"
                    onClick={overlayAction === 'send' ? sendEstimate : confirmBooking}
                  >
                    {overlayAction === 'send' ? 'Send' : 'Confirm'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {showLoadingOverlay && (
        <div className="LoadingOverlay">
          <div className="LoadingOverlayContent">
            <div className="Spinner"></div>
            <p>Processing...</p>
          </div>
        </div>
      )}
      {showEstimateOverlay && (
        <div className="EstimateOverlay">
          <div className="EstimateOverlayContent">
            <button className="OverlayCloseBtn" onClick={closeEstimateOverlay} style={{ position: 'absolute', top: '10px', right: '10px' }}>
              Close
            </button>
            <iframe
              src={`https://salesjet.allcanadavanlines.com/server/estimate_view/?${booking.LeadACVLRecordID}`}
              width="100%"
              height="100%"
              style={{ border: 'none'}}
              title="View Estimate"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Estimate;